const itineraries = {
  "data": [
  {
    "total_price": 274.5,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T15:20:00",
        "buffered_depart_time": "2018-06-20T15:20:00",
        "arrive_time": "2018-06-20T15:45:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=3942848755778894_0&price=178&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObP/GQc7RXEySu6up5WPlRDX9L1+fWRjUBAE89jyP+Wfvt628tAoJqzwCtsoXIyhdyvATQw7k6X/LIrFcxLxIhC2guCvyTDxmaiRLAT1WN4vmMPiiG7uKflzNfQtgBM9yO6SW7DqTNCuMI1AQs2JqdAuV55AXuXANaaFwq9Hd7LqoE6xu89uaAuZsslBXPqh6P8asKvPTUHVayGNg+VplZbGa6XTBWLmj4yI9YK+V86RRns7kW7gSiq1AcAR+1hHQ8RloImvgXpY35G6b8xQ5p17CNuP+ebjw/AasJzuNrN1Nvmv0tKSdBeo71QCD19jTqL8nwwQz41+00VgwSk2RDBV0qyrU0etU9imjueP8qqYCvDxtcVJhYZPtGW9iIGwt+0BoMiqUPr10W0pRxnxtRGsGRIRtA9OkCIqzX4HumUL1q2Vz8tljxn/eMFPM8rvibaz9X2GxSIMaUWtFEBLQMnBoCWjvALsWG+zmre4QufpylcoDZ1v+eiF0FHOP8pI9RSBi19nxqalJMrBukcbACKYRWb81sBg85cxtPtszlvgySdt9VJYOSbnYrAM3fcs825c3BgQsyY5+/iACL5wgxyKPfXLutWb2SC8PNGL/OIeStlNSlJqHT4PYKI98/tqeK1blRtDYsghAgK70n0Z4fNlQ==",
        "price": "211",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T17:15:00",
        "buffered_depart_time": "2018-06-20T15:45:00",
        "arrive_time": "2018-06-20T21:15:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "40.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T21:45:00",
        "buffered_depart_time": "2018-06-20T21:45:00",
        "arrive_time": "2018-06-20T22:15:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "30th St Station, Philadelphia, PA",
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": "34th St b/t 11th Ave and 12th Ave, New York, NY",
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "1.0",
        "name": "megabus",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T23:20:00",
        "buffered_depart_time": "2018-06-20T23:00:00",
        "arrive_time": "2018-06-21T01:30:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-21T01:40:00",
        "buffered_depart_time": "2018-06-21T01:40:00",
        "arrive_time": "2018-06-21T01:46:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share:bus:ride-share",
    "id": 160,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T15:20:00",
        "buffered_depart_time": "2018-06-20T15:20:00",
        "arrive_time": "2018-06-20T15:45:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=3942848755778894_0&price=178&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObP/GQc7RXEySu6up5WPlRDX9L1+fWRjUBAE89jyP+Wfvt628tAoJqzwCtsoXIyhdyvATQw7k6X/LIrFcxLxIhC2guCvyTDxmaiRLAT1WN4vmMPiiG7uKflzNfQtgBM9yO6SW7DqTNCuMI1AQs2JqdAuV55AXuXANaaFwq9Hd7LqoE6xu89uaAuZsslBXPqh6P8asKvPTUHVayGNg+VplZbGa6XTBWLmj4yI9YK+V86RRns7kW7gSiq1AcAR+1hHQ8RloImvgXpY35G6b8xQ5p17CNuP+ebjw/AasJzuNrN1Nvmv0tKSdBeo71QCD19jTqL8nwwQz41+00VgwSk2RDBV0qyrU0etU9imjueP8qqYCvDxtcVJhYZPtGW9iIGwt+0BoMiqUPr10W0pRxnxtRGsGRIRtA9OkCIqzX4HumUL1q2Vz8tljxn/eMFPM8rvibaz9X2GxSIMaUWtFEBLQMnBoCWjvALsWG+zmre4QufpylcoDZ1v+eiF0FHOP8pI9RSBi19nxqalJMrBukcbACKYRWb81sBg85cxtPtszlvgySdt9VJYOSbnYrAM3fcs825c3BgQsyY5+/iACL5wgxyKPfXLutWb2SC8PNGL/OIeStlNSlJqHT4PYKI98/tqeK1blRtDYsghAgK70n0Z4fNlQ==",
        "price": "211",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T17:15:00",
        "buffered_depart_time": "2018-06-20T15:45:00",
        "arrive_time": "2018-06-20T21:15:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "40.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T21:45:00",
        "buffered_depart_time": "2018-06-20T21:45:00",
        "arrive_time": "2018-06-20T22:15:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "30th St Station, Philadelphia, PA",
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": "34th St b/t 11th Ave and 12th Ave, New York, NY",
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "1.0",
        "name": "megabus",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T23:20:00",
        "buffered_depart_time": "2018-06-20T23:00:00",
        "arrive_time": "2018-06-21T01:30:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-21T01:40:00",
        "buffered_depart_time": "2018-06-21T01:40:00",
        "arrive_time": "2018-06-21T01:46:00"
      }
    ]
  },
  {
    "total_price": 258.5,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T04:50:00",
        "buffered_depart_time": "2018-06-20T04:50:00",
        "arrive_time": "2018-06-20T05:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=4008819685527143_0%7C4008819685527143_1%7C3803210722975286_0&price=165&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPjoUDnBsV+8uftjDbJxyY5IBPEOiEo8mHQXluz8hkRli01WLCsa/jvg/MAIcwq3op82v/7bTTYw8R9/iFUAOQOdMIBiHo2p/w8/JexfVas1O2mxnOTtYDJdyhmxLKAl+Nb6Rgh3+mMBf7T5p4fK538ThWp2jQZqo83MzdhXhInUwnZoDpyOGZ7aLtNeAV88VtP3hjWngzRAQ8owcdXPDitzDnSg3ZAoOfz83eyOnc9TXLPxyoWKkonqYZUhIiwLd20JiMIhHwXnogjSzmH51+3CB3Sl+3MkmdXVRtIdRTENctK/q9bcBqvIXUD3MELqGwQEztfAsK+Xr1K2tgtnTWxERMdRIFgzQ3evhGODpEAWzqiq6oDVQ2vm/hDgX1itCsIwaE394L/aSWaU4T0i/TyKt+2KW8BtLAmqpOj+nO7Rq90HtEa5bz5cTJnI92YZ88Y7PhPlFb1QboVoR42FnT3ftLTaKsGp9bjkaau4PNtUtjQnYR/4JUwlYws7AO7HErqXVgZVxoJpkbv3tsscpO6UIsDlsZa1w1gdg9N+YKXhMPiLwU+fMjs6diTM7dFiiZM4XhJxkWGY+P0GtPAnE1pPkoZWR80wtzhFirrCxY3vn6at3IBqaE6b+V8rynIbXIeVyioK1fs5f84Hnj0kC0e8zBufRSo8jPovaGpCNM++Mt3Mpx7jSa0bkgoosIPXSw0mwpr8xHJzC2vePTATHe4daonSVNEk8Mr+OZGEuAHv4euemxH/d9U6O3Quxo1sFX",
        "price": "195",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T06:45:00",
        "buffered_depart_time": "2018-06-20T05:15:00",
        "arrive_time": "2018-06-20T21:00:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "40.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T21:30:00",
        "buffered_depart_time": "2018-06-20T21:30:00",
        "arrive_time": "2018-06-20T22:00:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "Independence Hall Visitors Center, Philadelphia, PA",
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": "34th St b/t 11th Ave and 12th Ave, New York, NY",
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "1.0",
        "name": "megabus",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T23:20:00",
        "buffered_depart_time": "2018-06-20T23:00:00",
        "arrive_time": "2018-06-21T01:20:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-21T01:30:00",
        "buffered_depart_time": "2018-06-21T01:30:00",
        "arrive_time": "2018-06-21T01:36:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share:bus:ride-share",
    "id": 157,
    "departing_segments": []
  },
  {
    "total_price": 244.5,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T15:19:00",
        "buffered_depart_time": "2018-06-20T15:19:00",
        "arrive_time": "2018-06-20T15:44:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "PHL Airport, Philadelphia",
            "to_lon": "-75.241111",
            "to_lat": "39.871944",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=PHL&departure=20-06-2018&flightsId=3764728223593090_0%7C3602000818646591_0&price=175&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPPKNo4olTmktso2qzdRrSsMucQPhn/7XXsUdNw+nk1bVo5yE9EyNajhJm5OlDb8YdFPzl4brhGZeJqE5RvozrrP3kOZKB8Tz4OXFco1TXju4EIGzZyetpPf93D5u5Db7rXxmlFym3SSGtlDHK27P5VaFZ+P2Br2MpNkOdNEv21fjWb7AzGUsz5qjUbPTJUV80Nu4BLhr3kzbNxC8Q0tJwt5WmQJWdZfkKFTOe3DK6cngH3gEXcks2NVLcKcnddCqUo5Hv1wFm0CItKyhE5ELcmxk8FzO0pbxsvYAkyLcQfrGnLLSSgqgRK5RhwAEtI21C2hcNfAjaTq+QjAFhz+XcIRLB//ArZGVYCdghflVOKAtuUDVG1EU7JZrIe2ZLyMX+Ej0l6saLE2m5fqzrPKyRM/kgXCZPVhyReYOQ0FC5bOat5ZjoXyeJRxbvrQaFJAEOGWgn+C+HlP+9EEryStl35B4pHwsHHT1ScB4Qu1dT6TKUctVePOEiHXkMXJhcVrqLb7QFKfbzUPOQk37Y/XeecCRGIZ6AhGGqbmL+74k3lYTzEBAMQzU9GVKc+GNuIiKI0d+Vc5J/1/NZFm6f+25glx++XPn3JocbsstLj85agxlwxkCmClQRqThff/yIULwJOzwaCqWe9JznUd8J01EbmyUpHui6oVvRWyWikjd2dNDi/UvAjsbekfLtSh/eXcgE",
        "price": "207",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T17:14:00",
        "buffered_depart_time": "2018-06-20T15:44:00",
        "arrive_time": "2018-06-21T04:00:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-75.241111",
            "from_lat": "39.871944"
          }
        },
        "purchase_link": null,
        "price": "21.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-21T04:30:00",
        "buffered_depart_time": "2018-06-21T04:30:00",
        "arrive_time": "2018-06-21T04:53:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share",
    "id": 148,
    "departing_segments": []
  },
  {
    "total_price": 437.0,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T03:14:00",
        "buffered_depart_time": "2018-06-18T03:14:00",
        "arrive_time": "2018-06-18T03:20:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "30th St Station, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "17.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T03:40:00",
        "buffered_depart_time": "2018-06-18T03:20:00",
        "arrive_time": "2018-06-18T05:45:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T12:20:00",
        "buffered_depart_time": "2018-06-18T12:20:00",
        "arrive_time": "2018-06-18T13:23:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=3488751098027710_0%7C3917560245168350_0%7C3917560245168350_1&price=259&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPQ/zjLVOCowaBhF3iXk2bEn07Xr+8wLkggi326weN87Ro+JAqpgcdJfVoCY0gNDJ4fB0J4RufmcjOaCwW3AbMCo8XFkKDbrB0oIQwA3e/aW6K8Ys3/ku9d1vxwmLon+yvmR6rUcdTfTK8EGievETfkPgySpkUB8YZqoXoGoiv/WY9pasl6OuRjvTlIywLL+QyfjhUKU+jCSkQWeMvi+KYd1rDl7DABeDM0CDi+zkOOd/AD/MNOyfyFnDxJJlCPfgw3udVGuJ2VuYSlsgQYekguJp/lU59sZ/S1eqWopMaTpelkpjeGmod1t17bypJHfmL5sj0Zpg8t7g7V+JfRDg76U0/K/FOPFfqlA1mkekWGFmXCY6Ia8gGY+v10wNmZ8zHGqhzxHB6rKyNyjq+hdiX/HbxCvYnQR6+OaRX+pMZTZGrbj16x+o5JKfyC4Y3wsSHc/736Um3EHrKj/L/NL2zjB2aw7UnUpKcHtmLAOlflfcJUYfJFNRK3Q/vqLroJvAcV7AdUhqD2oJmBpRmt66Tda3LECLli8QAKtmUNUUQgit/R+ut47g6kF0cIKA8GQUMOpl+xk434O4UX5m6FnBr3wiAOP0H3txba5w/OZf+KmbYjWEcw56wp3Znq0wmG0Z2fTWg6x7LumeITdmVYldk8nG49PBKUfEjTjAmVZUvDnBn5qbkb0G15TUvta9Cc5I5jtlV9ZPF/Lyl5ECsT/7qscAfMjE9FnWVwbOys9Sat12+Jls2ozxNj2/vYQNkIvgwVn8aXwJhpkraGo//KeMhJw==",
        "price": "306",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T14:53:00",
        "buffered_depart_time": "2018-06-18T13:23:00",
        "arrive_time": "2018-06-18T23:15:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T23:45:00",
        "buffered_depart_time": "2018-06-18T23:45:00",
        "arrive_time": "2018-06-19T00:09:00"
      }
    ],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 109,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T03:14:00",
        "buffered_depart_time": "2018-06-18T03:14:00",
        "arrive_time": "2018-06-18T03:20:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "30th St Station, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "17.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T03:40:00",
        "buffered_depart_time": "2018-06-18T03:20:00",
        "arrive_time": "2018-06-18T05:45:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T12:20:00",
        "buffered_depart_time": "2018-06-18T12:20:00",
        "arrive_time": "2018-06-18T13:23:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=3488751098027710_0%7C3917560245168350_0%7C3917560245168350_1&price=259&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPQ/zjLVOCowaBhF3iXk2bEn07Xr+8wLkggi326weN87Ro+JAqpgcdJfVoCY0gNDJ4fB0J4RufmcjOaCwW3AbMCo8XFkKDbrB0oIQwA3e/aW6K8Ys3/ku9d1vxwmLon+yvmR6rUcdTfTK8EGievETfkPgySpkUB8YZqoXoGoiv/WY9pasl6OuRjvTlIywLL+QyfjhUKU+jCSkQWeMvi+KYd1rDl7DABeDM0CDi+zkOOd/AD/MNOyfyFnDxJJlCPfgw3udVGuJ2VuYSlsgQYekguJp/lU59sZ/S1eqWopMaTpelkpjeGmod1t17bypJHfmL5sj0Zpg8t7g7V+JfRDg76U0/K/FOPFfqlA1mkekWGFmXCY6Ia8gGY+v10wNmZ8zHGqhzxHB6rKyNyjq+hdiX/HbxCvYnQR6+OaRX+pMZTZGrbj16x+o5JKfyC4Y3wsSHc/736Um3EHrKj/L/NL2zjB2aw7UnUpKcHtmLAOlflfcJUYfJFNRK3Q/vqLroJvAcV7AdUhqD2oJmBpRmt66Tda3LECLli8QAKtmUNUUQgit/R+ut47g6kF0cIKA8GQUMOpl+xk434O4UX5m6FnBr3wiAOP0H3txba5w/OZf+KmbYjWEcw56wp3Znq0wmG0Z2fTWg6x7LumeITdmVYldk8nG49PBKUfEjTjAmVZUvDnBn5qbkb0G15TUvta9Cc5I5jtlV9ZPF/Lyl5ECsT/7qscAfMjE9FnWVwbOys9Sat12+Jls2ozxNj2/vYQNkIvgwVn8aXwJhpkraGo//KeMhJw==",
        "price": "306",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T14:53:00",
        "buffered_depart_time": "2018-06-18T13:23:00",
        "arrive_time": "2018-06-18T23:15:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T23:45:00",
        "buffered_depart_time": "2018-06-18T23:45:00",
        "arrive_time": "2018-06-19T00:09:00"
      }
    ]
  },
  {
    "total_price": 434.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 136,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T13:59:00",
        "buffered_depart_time": "2018-06-18T13:59:00",
        "arrive_time": "2018-06-18T14:05:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "Independence Hall Visitors Center, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T14:25:00",
        "buffered_depart_time": "2018-06-18T14:05:00",
        "arrive_time": "2018-06-18T16:25:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T20:12:00",
        "buffered_depart_time": "2018-06-18T20:12:00",
        "arrive_time": "2018-06-18T21:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=4001122827516499_0%7C3982431552169857_0%7C3982431552169857_1&price=266&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPyTEy6XbRnhA5yvVmvorIVcqhQQS+ax8fObRTBjno04vq5h7aicz+gjx8tCnIVIJh09NAPOUxGpOh9k79AK6bGfhFvj69RhhtEyIENtvLahEpBm373rdrOgApvs6YHmabANZ3zhGs+7uOIQtKn4yHSH43L5vQ3rrIFpB0Q7vqDvSgiE6EfkHkiyjJuEpYTDq8s4IdpFcIOROuKIZTRgn0hspiEaK4qP/t/kP1+cyPbb8UA63kop+pjn3sn7XM+05fq4uzx5oc14LnweCoE7SfwCP71ZGk6TL3KQSX4EPSszZsOMcVjPJM39jd8TwmpMGsmuFULhDEZr0mTjGYT5TSnXjZQKHn3p22VJaKZCEQQz75L7lZaCa+dpAduUUkfxJTW3U1dKQM0mLj5Y9UhThuWWcwwN9rzNSJMC3obX9FBnT7ZYODJq2p5XiTatK6aNiME7VjrCFWyU1KNT3IsX79UlBoC1OT/ZGPzhqh/lgI6pltNJWDb9kvQcqq/kvUAERTYJJl43b0Bu+T0fNQQkDmM7GoPhO8OhZoiOi6SQBi4+glKof9r6cy3dZke1c/4nNzjzYg6mKsnnk28uQfb0at2kbdTaI83Mhgu15qQAfuk3nWAqSFVBpNkr6aBXXgKVmL6bvqF/bMdhCG9/KrOi8Bj2+qkwHTk15hA1IOzXoD9N0guwpgSafWiUwp5LjdGnZtDHpMA/Feypu6aeZ3991pzJQXqAejXwUzV6JpDA9wETyZdOqrhzwEEMm+ZOU5ajgq",
        "price": "315",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T22:45:00",
        "buffered_depart_time": "2018-06-18T21:15:00",
        "arrive_time": "2018-06-19T09:43:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-19T10:13:00",
        "buffered_depart_time": "2018-06-19T10:13:00",
        "arrive_time": "2018-06-19T10:37:00"
      }
    ]
  },
  {
    "total_price": 327.5,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T04:50:00",
        "buffered_depart_time": "2018-06-20T04:50:00",
        "arrive_time": "2018-06-20T05:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=4035207816796086_0%7C4035207816796086_1%7C3598702163596938_0&price=216&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPhMhiXGhmctYJmBJTQXuLUj1sQLf00gX21TRZqyUR0SpvoV+yG9wrU9B5Ar6P6oUSiBCHuRO3/5RF54tI0igB+D/9PpPqvFzSqMMttDq1By25DXR4EbrRJ5At+3SxjkxfGVzqyD53lYxIN4mL1WoeZa0LTFJNgqN1oJUYNOcEQfzunyKLZR80nevtXKfmer7OSOSETMIt6nbMsGRdiP+b5gC4xgVXmkMWdm7zhsRVkaQ7Y7Q2PLJXSGB9OqPmWPqgcsIgHkqojc7MtSGpz6WtM91o71URANaUm0cDFSHe1dlY8pW7IdR6UaBN2tym4ontittkIJj0fCvyIlylMxhI8eO7hSAjmBV54Ddz5SjJ52ChBgvlY5ZeF8tmHQDCreG2D+Hk7222ODayUJrJcg4TTU+f6VGG8DRRBw6/zShYveUqeP1JFTGMiNk3puTLhiQlVtjdRRd6LhjmC1noV/lUGaJ4f9XxMBZWEwbAHBrJDx/6BWFiJNQIEdmiK1DUmPCOBa5JHptKmrr+9Bo25MLMLDeHnzZgN0luToXOxc9wrI3DaZ4bo6m3gzr7J5whQzJvo21UQPBMNDwbtyriyoWyhIbpfWAWnYaTo6Xoaaftwx5Y8/OMtaCph4KSUcnRfEaU62Tuymambgc9GIYdigx/VpG7GVRJOzm8DeNeUJRbOjzB0s6k43u5AotV+WU1mLGtdKitnjQ4iwayW8khy6+mBqdGRv1C4z0CvPn0zrkf+cWxj2SqgX/WUgk4FYmE5Wwl",
        "price": "256",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T06:45:00",
        "buffered_depart_time": "2018-06-20T05:15:00",
        "arrive_time": "2018-06-20T15:40:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "40.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T16:10:00",
        "buffered_depart_time": "2018-06-20T16:10:00",
        "arrive_time": "2018-06-20T16:40:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "Independence Hall Visitors Center, Philadelphia, PA",
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": "34th St b/t 11th Ave and 12th Ave, New York, NY",
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "9.0",
        "name": "megabus",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T19:05:00",
        "buffered_depart_time": "2018-06-20T18:45:00",
        "arrive_time": "2018-06-20T21:05:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T21:15:00",
        "buffered_depart_time": "2018-06-20T21:15:00",
        "arrive_time": "2018-06-20T21:21:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share:bus:ride-share",
    "id": 177,
    "departing_segments": []
  },
  {
    "total_price": 327.5,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T04:50:00",
        "buffered_depart_time": "2018-06-20T04:50:00",
        "arrive_time": "2018-06-20T05:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=4035207816796086_0%7C4035207816796086_1%7C3598702163596938_0&price=216&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPhMhiXGhmctYJmBJTQXuLUj1sQLf00gX21TRZqyUR0SpvoV+yG9wrU9B5Ar6P6oUSiBCHuRO3/5RF54tI0igB+D/9PpPqvFzSqMMttDq1By25DXR4EbrRJ5At+3SxjkxfGVzqyD53lYxIN4mL1WoeZa0LTFJNgqN1oJUYNOcEQfzunyKLZR80nevtXKfmer7OSOSETMIt6nbMsGRdiP+b5gC4xgVXmkMWdm7zhsRVkaQ7Y7Q2PLJXSGB9OqPmWPqgcsIgHkqojc7MtSGpz6WtM91o71URANaUm0cDFSHe1dlY8pW7IdR6UaBN2tym4ontittkIJj0fCvyIlylMxhI8eO7hSAjmBV54Ddz5SjJ52ChBgvlY5ZeF8tmHQDCreG2D+Hk7222ODayUJrJcg4TTU+f6VGG8DRRBw6/zShYveUqeP1JFTGMiNk3puTLhiQlVtjdRRd6LhjmC1noV/lUGaJ4f9XxMBZWEwbAHBrJDx/6BWFiJNQIEdmiK1DUmPCOBa5JHptKmrr+9Bo25MLMLDeHnzZgN0luToXOxc9wrI3DaZ4bo6m3gzr7J5whQzJvo21UQPBMNDwbtyriyoWyhIbpfWAWnYaTo6Xoaaftwx5Y8/OMtaCph4KSUcnRfEaU62Tuymambgc9GIYdigx/VpG7GVRJOzm8DeNeUJRbOjzB0s6k43u5AotV+WU1mLGtdKitnjQ4iwayW8khy6+mBqdGRv1C4z0CvPn0zrkf+cWxj2SqgX/WUgk4FYmE5Wwl",
        "price": "256",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T06:45:00",
        "buffered_depart_time": "2018-06-20T05:15:00",
        "arrive_time": "2018-06-20T15:40:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "40.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T16:10:00",
        "buffered_depart_time": "2018-06-20T16:10:00",
        "arrive_time": "2018-06-20T16:40:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "30th St Station, Philadelphia, PA",
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": "34th St b/t 11th Ave and 12th Ave, New York, NY",
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "9.0",
        "name": "megabus",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T19:05:00",
        "buffered_depart_time": "2018-06-20T18:45:00",
        "arrive_time": "2018-06-20T21:15:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T21:25:00",
        "buffered_depart_time": "2018-06-20T21:25:00",
        "arrive_time": "2018-06-20T21:31:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share:bus:ride-share",
    "id": 178,
    "departing_segments": []
  },
  {
    "total_price": 255.99,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.94059",
            "to_lat": "41.26069",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "6.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T11:41:00",
        "buffered_depart_time": "2018-06-20T11:41:00",
        "arrive_time": "2018-06-20T11:45:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "Eastbound side of Cherry Street, between 7th and 8th Streets, Des Moines, IA",
            "to_lon": "-93.62697",
            "to_lat": "41.58329",
            "from_string": "Crossroads Mall - N 72nd St between Dodge St and Cass St, Omaha, NE",
            "from_lon": "-95.94059",
            "from_lat": "41.26069"
          }
        },
        "purchase_link": null,
        "price": "19.99",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T12:05:00",
        "buffered_depart_time": "2018-06-20T11:45:00",
        "arrive_time": "2018-06-20T14:45:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-93.657778",
            "to_lat": "41.534167",
            "from_string": null,
            "from_lon": "-93.62697",
            "from_lat": "41.58329"
          }
        },
        "purchase_link": null,
        "price": "9.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T18:16:00",
        "buffered_depart_time": "2018-06-20T18:16:00",
        "arrive_time": "2018-06-20T18:29:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "PHL Airport, Philadelphia",
            "to_lon": "-75.241111",
            "to_lat": "39.871944",
            "from_string": "DSM Airport, Des Moines",
            "from_lon": "-93.657778",
            "from_lat": "41.534167"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=DSM&to=PHL&departure=20-06-2018&flightsId=3651478258259288_0%7C3538228865775763_0&price=168&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPZ1F/IF+TnYhSMNQyK6ni2crqxmkH9VssDo7ugVJqRMxYhHGzRIPHDk1dSgWnsk2CpSv3KmQZ3Oez2rA15GJkOEHL1YLRIt+CjJ50lNNHI0/jaQNwahy9I7zPtS9bbAhlQoLt1+c0/8tLifjdJ8yCpYyaHooVNaqZ8GdBHs/Mx2fcysxY7zJuTdBMj8L9paqAKVYHHB5ZpDcoWxs200UAMINdRVFV6QwBXEKiWI0M/tKolOPc5oEpI3haSzkdlJrgr22kudrVQVc6XLffUNNLEnDm2x7gks0hKjKQ76f5/TDuJmujkCu5bgO7YN6FvV84HCq691sKzeZJFs6fXST1sqAAk83Tnr4qDMcTAzWQXynkGv+XVgI+V+GAX/2mKq0j/Fd5g4mqKmXcf13KxGTWOzN4r92+XL1qohJQcTF5Cmek4VZP4v7S6fmzfGSbukANlsyZZREejiQUSuO4wZf1yduiPHNNSGGwK5LefXSDCYXRTrZn1ZuGOk8JQdiSQF98zL9b81S/pDc8KAHDJi6JEw4rg/0HZchfaqv7Zcq+dokAsC5+1RSHK0vr/tLnypwQzD/xdAyO+TiQ1dtN+zvw+wY3WG+LnKEh75s3lI9qUHH096CR+t7tSxOdgZHe0f0TWvBYjQHhwWJRx1S2/nJVPcoIA1Xzv1O+BG0qkj7NXSsjdI33WEOEcvMczQxXg9jq",
        "price": "199",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T19:59:00",
        "buffered_depart_time": "2018-06-20T18:29:00",
        "arrive_time": "2018-06-21T06:22:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-75.241111",
            "from_lat": "39.871944"
          }
        },
        "purchase_link": null,
        "price": "21.5",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-21T06:52:00",
        "buffered_depart_time": "2018-06-21T06:52:00",
        "arrive_time": "2018-06-21T07:15:00"
      }
    ],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 186,
    "departing_segments": []
  },
  {
    "total_price": 434.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 123,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T06:34:00",
        "buffered_depart_time": "2018-06-18T06:34:00",
        "arrive_time": "2018-06-18T06:40:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "30th St Station, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T07:00:00",
        "buffered_depart_time": "2018-06-18T06:40:00",
        "arrive_time": "2018-06-18T09:10:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T20:12:00",
        "buffered_depart_time": "2018-06-18T20:12:00",
        "arrive_time": "2018-06-18T21:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=4001122827516499_0%7C3982431552169857_0%7C3982431552169857_1&price=266&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPyTEy6XbRnhA5yvVmvorIVcqhQQS+ax8fObRTBjno04vq5h7aicz+gjx8tCnIVIJh09NAPOUxGpOh9k79AK6bGfhFvj69RhhtEyIENtvLahEpBm373rdrOgApvs6YHmabANZ3zhGs+7uOIQtKn4yHSH43L5vQ3rrIFpB0Q7vqDvSgiE6EfkHkiyjJuEpYTDq8s4IdpFcIOROuKIZTRgn0hspiEaK4qP/t/kP1+cyPbb8UA63kop+pjn3sn7XM+05fq4uzx5oc14LnweCoE7SfwCP71ZGk6TL3KQSX4EPSszZsOMcVjPJM39jd8TwmpMGsmuFULhDEZr0mTjGYT5TSnXjZQKHn3p22VJaKZCEQQz75L7lZaCa+dpAduUUkfxJTW3U1dKQM0mLj5Y9UhThuWWcwwN9rzNSJMC3obX9FBnT7ZYODJq2p5XiTatK6aNiME7VjrCFWyU1KNT3IsX79UlBoC1OT/ZGPzhqh/lgI6pltNJWDb9kvQcqq/kvUAERTYJJl43b0Bu+T0fNQQkDmM7GoPhO8OhZoiOi6SQBi4+glKof9r6cy3dZke1c/4nNzjzYg6mKsnnk28uQfb0at2kbdTaI83Mhgu15qQAfuk3nWAqSFVBpNkr6aBXXgKVmL6bvqF/bMdhCG9/KrOi8Bj2+qkwHTk15hA1IOzXoD9N0guwpgSafWiUwp5LjdGnZtDHpMA/Feypu6aeZ3991pzJQXqAejXwUzV6JpDA9wETyZdOqrhzwEEMm+ZOU5ajgq",
        "price": "315",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T22:45:00",
        "buffered_depart_time": "2018-06-18T21:15:00",
        "arrive_time": "2018-06-19T09:43:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-19T10:13:00",
        "buffered_depart_time": "2018-06-19T10:13:00",
        "arrive_time": "2018-06-19T10:37:00"
      }
    ]
  },
  {
    "total_price": 425.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 113,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T06:44:00",
        "buffered_depart_time": "2018-06-18T06:44:00",
        "arrive_time": "2018-06-18T06:50:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "Independence Hall Visitors Center, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T07:10:00",
        "buffered_depart_time": "2018-06-18T06:50:00",
        "arrive_time": "2018-06-18T09:10:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T12:20:00",
        "buffered_depart_time": "2018-06-18T12:20:00",
        "arrive_time": "2018-06-18T13:23:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=3488751098027710_0%7C3917560245168350_0%7C3917560245168350_1&price=259&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPQ/zjLVOCowaBhF3iXk2bEn07Xr+8wLkggi326weN87Ro+JAqpgcdJfVoCY0gNDJ4fB0J4RufmcjOaCwW3AbMCo8XFkKDbrB0oIQwA3e/aW6K8Ys3/ku9d1vxwmLon+yvmR6rUcdTfTK8EGievETfkPgySpkUB8YZqoXoGoiv/WY9pasl6OuRjvTlIywLL+QyfjhUKU+jCSkQWeMvi+KYd1rDl7DABeDM0CDi+zkOOd/AD/MNOyfyFnDxJJlCPfgw3udVGuJ2VuYSlsgQYekguJp/lU59sZ/S1eqWopMaTpelkpjeGmod1t17bypJHfmL5sj0Zpg8t7g7V+JfRDg76U0/K/FOPFfqlA1mkekWGFmXCY6Ia8gGY+v10wNmZ8zHGqhzxHB6rKyNyjq+hdiX/HbxCvYnQR6+OaRX+pMZTZGrbj16x+o5JKfyC4Y3wsSHc/736Um3EHrKj/L/NL2zjB2aw7UnUpKcHtmLAOlflfcJUYfJFNRK3Q/vqLroJvAcV7AdUhqD2oJmBpRmt66Tda3LECLli8QAKtmUNUUQgit/R+ut47g6kF0cIKA8GQUMOpl+xk434O4UX5m6FnBr3wiAOP0H3txba5w/OZf+KmbYjWEcw56wp3Znq0wmG0Z2fTWg6x7LumeITdmVYldk8nG49PBKUfEjTjAmVZUvDnBn5qbkb0G15TUvta9Cc5I5jtlV9ZPF/Lyl5ECsT/7qscAfMjE9FnWVwbOys9Sat12+Jls2ozxNj2/vYQNkIvgwVn8aXwJhpkraGo//KeMhJw==",
        "price": "306",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T14:53:00",
        "buffered_depart_time": "2018-06-18T13:23:00",
        "arrive_time": "2018-06-18T23:15:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T23:45:00",
        "buffered_depart_time": "2018-06-18T23:45:00",
        "arrive_time": "2018-06-19T00:09:00"
      }
    ]
  },
  {
    "total_price": 316.5,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T04:50:00",
        "buffered_depart_time": "2018-06-20T04:50:00",
        "arrive_time": "2018-06-20T05:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=4008819685527143_0%7C4008819685527143_1%7C3742737859286809_0&price=214&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPjoUDnBsV+8uftjDbJxyY5IBPEOiEo8mHQXluz8hkRli01WLCsa/jvg/MAIcwq3op+LPOUPUVH/QWZ26nJ4U24nzJvQFJZ6eIXh12dT/+EEeiZxFeD28ei+ZwIjMnT351Ia6vhguGB8/uhyYCnHMcVNrDrSPXaDmUrsSj3+nNnHi07slYhs5jhSTtZAKkAkkDzmUwJTBwEuQ//H/u2DXQn4svpqa0GQumPbs1JoZUwq6sAI8eoz6DrUIiErevVfPnU5pK4NgP8ne2hYKVPZgRKobOGjQyvjzgv+iCsO08b26zK5rbWX+zu2oluwEVdCUTvbhkFof38kqpAaVwYKU7GvPSp0sPRhqVq2oituPuos2WwBd8uKVZLsaAn3waR2e7gavFB44ltXL78vjOtFWUnUzmhHzFZ9YG16gDx9XgpG+g3dtiCkG0M0jWaRchWMFxm9v9Ig7u6Wmhzq4EVlA1GKzgwb9rKRwrxiV/nHFy0EG63/0SahBW+e0oHNnh7mEJYFqBdTqTb3I46UFUHS0nrNv81sLw4QXsTz+petIVNbXwAaVaA3kNcS+Zqc6m8pDWbUGLOfmxKP3z1AJD2r3HHpEfteYOG0FevWyrqfJjfUTCLpqeLUTF7mfiwMkFF8/6aNegyFWILLp6CdjmaRiDYkgZ2FJ+8MQuQL5VyaVvK//BdfMvzU4PBBlgIoG7mCnlhOsVEeA7J+D/SoIDngG7BfQ3CGZiKZt1oN+zqQ03sO2xTTyK5+5pwxRaA0CqAfBX7rvQM2FWjaAifWfS/wzZIw==",
        "price": "253",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T06:45:00",
        "buffered_depart_time": "2018-06-20T05:15:00",
        "arrive_time": "2018-06-20T17:45:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "40.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T18:15:00",
        "buffered_depart_time": "2018-06-20T18:15:00",
        "arrive_time": "2018-06-20T18:45:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "30th St Station, Philadelphia, PA",
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": "34th St b/t 11th Ave and 12th Ave, New York, NY",
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "1.0",
        "name": "megabus",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T23:20:00",
        "buffered_depart_time": "2018-06-20T23:00:00",
        "arrive_time": "2018-06-21T01:30:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-21T01:40:00",
        "buffered_depart_time": "2018-06-21T01:40:00",
        "arrive_time": "2018-06-21T01:46:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share:bus:ride-share",
    "id": 174,
    "departing_segments": []
  },
  {
    "total_price": 324.5,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T04:50:00",
        "buffered_depart_time": "2018-06-20T04:50:00",
        "arrive_time": "2018-06-20T05:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=4008819685527143_0%7C4008819685527143_1%7C3742737859286809_0&price=214&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPjoUDnBsV+8uftjDbJxyY5IBPEOiEo8mHQXluz8hkRli01WLCsa/jvg/MAIcwq3op+LPOUPUVH/QWZ26nJ4U24nzJvQFJZ6eIXh12dT/+EEeiZxFeD28ei+ZwIjMnT351Ia6vhguGB8/uhyYCnHMcVNrDrSPXaDmUrsSj3+nNnHi07slYhs5jhSTtZAKkAkkDzmUwJTBwEuQ//H/u2DXQn4svpqa0GQumPbs1JoZUwq6sAI8eoz6DrUIiErevVfPnU5pK4NgP8ne2hYKVPZgRKobOGjQyvjzgv+iCsO08b26zK5rbWX+zu2oluwEVdCUTvbhkFof38kqpAaVwYKU7GvPSp0sPRhqVq2oituPuos2WwBd8uKVZLsaAn3waR2e7gavFB44ltXL78vjOtFWUnUzmhHzFZ9YG16gDx9XgpG+g3dtiCkG0M0jWaRchWMFxm9v9Ig7u6Wmhzq4EVlA1GKzgwb9rKRwrxiV/nHFy0EG63/0SahBW+e0oHNnh7mEJYFqBdTqTb3I46UFUHS0nrNv81sLw4QXsTz+petIVNbXwAaVaA3kNcS+Zqc6m8pDWbUGLOfmxKP3z1AJD2r3HHpEfteYOG0FevWyrqfJjfUTCLpqeLUTF7mfiwMkFF8/6aNegyFWILLp6CdjmaRiDYkgZ2FJ+8MQuQL5VyaVvK//BdfMvzU4PBBlgIoG7mCnlhOsVEeA7J+D/SoIDngG7BfQ3CGZiKZt1oN+zqQ03sO2xTTyK5+5pwxRaA0CqAfBX7rvQM2FWjaAifWfS/wzZIw==",
        "price": "253",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T06:45:00",
        "buffered_depart_time": "2018-06-20T05:15:00",
        "arrive_time": "2018-06-20T17:45:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "40.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T18:15:00",
        "buffered_depart_time": "2018-06-20T18:15:00",
        "arrive_time": "2018-06-20T18:45:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "30th St Station, Philadelphia, PA",
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": "34th St b/t 11th Ave and 12th Ave, New York, NY",
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "9.0",
        "name": "megabus",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T20:25:00",
        "buffered_depart_time": "2018-06-20T20:05:00",
        "arrive_time": "2018-06-20T22:35:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T22:45:00",
        "buffered_depart_time": "2018-06-20T22:45:00",
        "arrive_time": "2018-06-20T22:51:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share:bus:ride-share",
    "id": 170,
    "departing_segments": []
  },
  {
    "total_price": 425.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 111,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T05:44:00",
        "buffered_depart_time": "2018-06-18T05:44:00",
        "arrive_time": "2018-06-18T05:50:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "Independence Hall Visitors Center, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T06:10:00",
        "buffered_depart_time": "2018-06-18T05:50:00",
        "arrive_time": "2018-06-18T08:10:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T12:20:00",
        "buffered_depart_time": "2018-06-18T12:20:00",
        "arrive_time": "2018-06-18T13:23:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=3488751098027710_0%7C3917560245168350_0%7C3917560245168350_1&price=259&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPQ/zjLVOCowaBhF3iXk2bEn07Xr+8wLkggi326weN87Ro+JAqpgcdJfVoCY0gNDJ4fB0J4RufmcjOaCwW3AbMCo8XFkKDbrB0oIQwA3e/aW6K8Ys3/ku9d1vxwmLon+yvmR6rUcdTfTK8EGievETfkPgySpkUB8YZqoXoGoiv/WY9pasl6OuRjvTlIywLL+QyfjhUKU+jCSkQWeMvi+KYd1rDl7DABeDM0CDi+zkOOd/AD/MNOyfyFnDxJJlCPfgw3udVGuJ2VuYSlsgQYekguJp/lU59sZ/S1eqWopMaTpelkpjeGmod1t17bypJHfmL5sj0Zpg8t7g7V+JfRDg76U0/K/FOPFfqlA1mkekWGFmXCY6Ia8gGY+v10wNmZ8zHGqhzxHB6rKyNyjq+hdiX/HbxCvYnQR6+OaRX+pMZTZGrbj16x+o5JKfyC4Y3wsSHc/736Um3EHrKj/L/NL2zjB2aw7UnUpKcHtmLAOlflfcJUYfJFNRK3Q/vqLroJvAcV7AdUhqD2oJmBpRmt66Tda3LECLli8QAKtmUNUUQgit/R+ut47g6kF0cIKA8GQUMOpl+xk434O4UX5m6FnBr3wiAOP0H3txba5w/OZf+KmbYjWEcw56wp3Znq0wmG0Z2fTWg6x7LumeITdmVYldk8nG49PBKUfEjTjAmVZUvDnBn5qbkb0G15TUvta9Cc5I5jtlV9ZPF/Lyl5ECsT/7qscAfMjE9FnWVwbOys9Sat12+Jls2ozxNj2/vYQNkIvgwVn8aXwJhpkraGo//KeMhJw==",
        "price": "306",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T14:53:00",
        "buffered_depart_time": "2018-06-18T13:23:00",
        "arrive_time": "2018-06-18T23:15:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T23:45:00",
        "buffered_depart_time": "2018-06-18T23:45:00",
        "arrive_time": "2018-06-19T00:09:00"
      }
    ]
  },
  {
    "total_price": 434.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 141,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T15:34:00",
        "buffered_depart_time": "2018-06-18T15:34:00",
        "arrive_time": "2018-06-18T15:40:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "30th St Station, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T16:00:00",
        "buffered_depart_time": "2018-06-18T15:40:00",
        "arrive_time": "2018-06-18T18:10:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T20:12:00",
        "buffered_depart_time": "2018-06-18T20:12:00",
        "arrive_time": "2018-06-18T21:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=4001122827516499_0%7C3982431552169857_0%7C3982431552169857_1&price=266&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPyTEy6XbRnhA5yvVmvorIVcqhQQS+ax8fObRTBjno04vq5h7aicz+gjx8tCnIVIJh09NAPOUxGpOh9k79AK6bGfhFvj69RhhtEyIENtvLahEpBm373rdrOgApvs6YHmabANZ3zhGs+7uOIQtKn4yHSH43L5vQ3rrIFpB0Q7vqDvSgiE6EfkHkiyjJuEpYTDq8s4IdpFcIOROuKIZTRgn0hspiEaK4qP/t/kP1+cyPbb8UA63kop+pjn3sn7XM+05fq4uzx5oc14LnweCoE7SfwCP71ZGk6TL3KQSX4EPSszZsOMcVjPJM39jd8TwmpMGsmuFULhDEZr0mTjGYT5TSnXjZQKHn3p22VJaKZCEQQz75L7lZaCa+dpAduUUkfxJTW3U1dKQM0mLj5Y9UhThuWWcwwN9rzNSJMC3obX9FBnT7ZYODJq2p5XiTatK6aNiME7VjrCFWyU1KNT3IsX79UlBoC1OT/ZGPzhqh/lgI6pltNJWDb9kvQcqq/kvUAERTYJJl43b0Bu+T0fNQQkDmM7GoPhO8OhZoiOi6SQBi4+glKof9r6cy3dZke1c/4nNzjzYg6mKsnnk28uQfb0at2kbdTaI83Mhgu15qQAfuk3nWAqSFVBpNkr6aBXXgKVmL6bvqF/bMdhCG9/KrOi8Bj2+qkwHTk15hA1IOzXoD9N0guwpgSafWiUwp5LjdGnZtDHpMA/Feypu6aeZ3991pzJQXqAejXwUzV6JpDA9wETyZdOqrhzwEEMm+ZOU5ajgq",
        "price": "315",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T22:45:00",
        "buffered_depart_time": "2018-06-18T21:15:00",
        "arrive_time": "2018-06-19T09:43:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-19T10:13:00",
        "buffered_depart_time": "2018-06-19T10:13:00",
        "arrive_time": "2018-06-19T10:37:00"
      }
    ]
  },
  {
    "total_price": 434.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 135,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T13:49:00",
        "buffered_depart_time": "2018-06-18T13:49:00",
        "arrive_time": "2018-06-18T13:55:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "30th St Station, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T14:15:00",
        "buffered_depart_time": "2018-06-18T13:55:00",
        "arrive_time": "2018-06-18T16:25:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T20:12:00",
        "buffered_depart_time": "2018-06-18T20:12:00",
        "arrive_time": "2018-06-18T21:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=4001122827516499_0%7C3982431552169857_0%7C3982431552169857_1&price=266&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPyTEy6XbRnhA5yvVmvorIVcqhQQS+ax8fObRTBjno04vq5h7aicz+gjx8tCnIVIJh09NAPOUxGpOh9k79AK6bGfhFvj69RhhtEyIENtvLahEpBm373rdrOgApvs6YHmabANZ3zhGs+7uOIQtKn4yHSH43L5vQ3rrIFpB0Q7vqDvSgiE6EfkHkiyjJuEpYTDq8s4IdpFcIOROuKIZTRgn0hspiEaK4qP/t/kP1+cyPbb8UA63kop+pjn3sn7XM+05fq4uzx5oc14LnweCoE7SfwCP71ZGk6TL3KQSX4EPSszZsOMcVjPJM39jd8TwmpMGsmuFULhDEZr0mTjGYT5TSnXjZQKHn3p22VJaKZCEQQz75L7lZaCa+dpAduUUkfxJTW3U1dKQM0mLj5Y9UhThuWWcwwN9rzNSJMC3obX9FBnT7ZYODJq2p5XiTatK6aNiME7VjrCFWyU1KNT3IsX79UlBoC1OT/ZGPzhqh/lgI6pltNJWDb9kvQcqq/kvUAERTYJJl43b0Bu+T0fNQQkDmM7GoPhO8OhZoiOi6SQBi4+glKof9r6cy3dZke1c/4nNzjzYg6mKsnnk28uQfb0at2kbdTaI83Mhgu15qQAfuk3nWAqSFVBpNkr6aBXXgKVmL6bvqF/bMdhCG9/KrOi8Bj2+qkwHTk15hA1IOzXoD9N0guwpgSafWiUwp5LjdGnZtDHpMA/Feypu6aeZ3991pzJQXqAejXwUzV6JpDA9wETyZdOqrhzwEEMm+ZOU5ajgq",
        "price": "315",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T22:45:00",
        "buffered_depart_time": "2018-06-18T21:15:00",
        "arrive_time": "2018-06-19T09:43:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-19T10:13:00",
        "buffered_depart_time": "2018-06-19T10:13:00",
        "arrive_time": "2018-06-19T10:37:00"
      }
    ]
  },
  {
    "total_price": 425.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 115,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T07:44:00",
        "buffered_depart_time": "2018-06-18T07:44:00",
        "arrive_time": "2018-06-18T07:50:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "Independence Hall Visitors Center, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T08:10:00",
        "buffered_depart_time": "2018-06-18T07:50:00",
        "arrive_time": "2018-06-18T10:10:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T12:20:00",
        "buffered_depart_time": "2018-06-18T12:20:00",
        "arrive_time": "2018-06-18T13:23:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=3488751098027710_0%7C3917560245168350_0%7C3917560245168350_1&price=259&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPQ/zjLVOCowaBhF3iXk2bEn07Xr+8wLkggi326weN87Ro+JAqpgcdJfVoCY0gNDJ4fB0J4RufmcjOaCwW3AbMCo8XFkKDbrB0oIQwA3e/aW6K8Ys3/ku9d1vxwmLon+yvmR6rUcdTfTK8EGievETfkPgySpkUB8YZqoXoGoiv/WY9pasl6OuRjvTlIywLL+QyfjhUKU+jCSkQWeMvi+KYd1rDl7DABeDM0CDi+zkOOd/AD/MNOyfyFnDxJJlCPfgw3udVGuJ2VuYSlsgQYekguJp/lU59sZ/S1eqWopMaTpelkpjeGmod1t17bypJHfmL5sj0Zpg8t7g7V+JfRDg76U0/K/FOPFfqlA1mkekWGFmXCY6Ia8gGY+v10wNmZ8zHGqhzxHB6rKyNyjq+hdiX/HbxCvYnQR6+OaRX+pMZTZGrbj16x+o5JKfyC4Y3wsSHc/736Um3EHrKj/L/NL2zjB2aw7UnUpKcHtmLAOlflfcJUYfJFNRK3Q/vqLroJvAcV7AdUhqD2oJmBpRmt66Tda3LECLli8QAKtmUNUUQgit/R+ut47g6kF0cIKA8GQUMOpl+xk434O4UX5m6FnBr3wiAOP0H3txba5w/OZf+KmbYjWEcw56wp3Znq0wmG0Z2fTWg6x7LumeITdmVYldk8nG49PBKUfEjTjAmVZUvDnBn5qbkb0G15TUvta9Cc5I5jtlV9ZPF/Lyl5ECsT/7qscAfMjE9FnWVwbOys9Sat12+Jls2ozxNj2/vYQNkIvgwVn8aXwJhpkraGo//KeMhJw==",
        "price": "306",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T14:53:00",
        "buffered_depart_time": "2018-06-18T13:23:00",
        "arrive_time": "2018-06-18T23:15:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T23:45:00",
        "buffered_depart_time": "2018-06-18T23:45:00",
        "arrive_time": "2018-06-19T00:09:00"
      }
    ]
  },
  {
    "total_price": 463.0,
    "returning_segments": [],
    "permutation": "ride-share:flight:ride-share",
    "id": 103,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-74.168611",
            "to_lat": "40.6925",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "142.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T08:42:00",
        "buffered_depart_time": "2018-06-18T08:42:00",
        "arrive_time": "2018-06-18T10:30:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "EWR Airport, New York City",
            "from_lon": "-74.168611",
            "from_lat": "40.6925"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=EWR&to=OMA&departure=18-06-2018&flightsId=3779021818373216_0%7C3914261838161173_0%7C3914261838161173_1&price=258&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPLi12+Bhq9HinVbjOCrScBv14iNao0zVpgEWnskfU0f4GVdN4xo+F/ma8v/pdxEEgQXXNzEeCHb/a5wcQvEhiOd5gfNTR74vWIeFzP1UbtDP6gU1Cy58ZrkCfwliPZEReOqBGaijyjzVuViyDT5CCxeogyhSNloBwiyDQOpBjNCKwMOLsQbQEFpksfvFsVxEwgPiZAGsIM8R/xs92qkpcNrExzmtoSAAm6L7bp6v3qusUkuVFgjNhbz22BXq8e+CDF5EviSYt7tYjNKQivHPFYW5rzL25BIi03ICSdr9JTAEQOo+8TTq+4b+w4bZ0MpG1bNZZCrDhzgYnTWwcVNzzg2vaH+M3cKNzU3udBZFbRodBkttNqJo2JH8zE2hWvdblPMN79wpoyToMdbeRwvhZNVcN3oHC41JrvTajF+oB+tpTVN+QnNA0UN7WSzYyZbJlAaPjXjp7j+b/IejuUZeej8+YQTvC9Iih2+AcIv/nH6LKKOCtjbT6yWirN8/015laEy7/vp5deg3w/EZl/AI3mV4/NY0/LNd0tid23l/kt3aQyjvjKG8HkzrcspUFycccbqAGPhgWyE3POjuqjnXehTyk8uofWXarkfjNPiLgRXo8IzZUK+QsTFqWtE6Q8NpDeNdoJqLYtFTKLQH74hvVG0g6SUh0TC6eXAVk7n2KGP4ZTKwcBuHXJPP06wzEnjBBBoP1+Qt3tqIAOsuYMD8PNewNS+LscTlZdwhHuOyNjJCcEFRB5mWLn9oZdm0kCH61",
        "price": "306",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T12:00:00",
        "buffered_depart_time": "2018-06-18T10:30:00",
        "arrive_time": "2018-06-18T22:38:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T23:08:00",
        "buffered_depart_time": "2018-06-18T23:08:00",
        "arrive_time": "2018-06-18T23:32:00"
      }
    ]
  },
  {
    "total_price": 327.5,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T04:50:00",
        "buffered_depart_time": "2018-06-20T04:50:00",
        "arrive_time": "2018-06-20T05:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=4035207816796086_0%7C4035207816796086_1%7C3598702163596938_0&price=216&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPhMhiXGhmctYJmBJTQXuLUj1sQLf00gX21TRZqyUR0SpvoV+yG9wrU9B5Ar6P6oUSiBCHuRO3/5RF54tI0igB+D/9PpPqvFzSqMMttDq1By25DXR4EbrRJ5At+3SxjkxfGVzqyD53lYxIN4mL1WoeZa0LTFJNgqN1oJUYNOcEQfzunyKLZR80nevtXKfmer7OSOSETMIt6nbMsGRdiP+b5gC4xgVXmkMWdm7zhsRVkaQ7Y7Q2PLJXSGB9OqPmWPqgcsIgHkqojc7MtSGpz6WtM91o71URANaUm0cDFSHe1dlY8pW7IdR6UaBN2tym4ontittkIJj0fCvyIlylMxhI8eO7hSAjmBV54Ddz5SjJ52ChBgvlY5ZeF8tmHQDCreG2D+Hk7222ODayUJrJcg4TTU+f6VGG8DRRBw6/zShYveUqeP1JFTGMiNk3puTLhiQlVtjdRRd6LhjmC1noV/lUGaJ4f9XxMBZWEwbAHBrJDx/6BWFiJNQIEdmiK1DUmPCOBa5JHptKmrr+9Bo25MLMLDeHnzZgN0luToXOxc9wrI3DaZ4bo6m3gzr7J5whQzJvo21UQPBMNDwbtyriyoWyhIbpfWAWnYaTo6Xoaaftwx5Y8/OMtaCph4KSUcnRfEaU62Tuymambgc9GIYdigx/VpG7GVRJOzm8DeNeUJRbOjzB0s6k43u5AotV+WU1mLGtdKitnjQ4iwayW8khy6+mBqdGRv1C4z0CvPn0zrkf+cWxj2SqgX/WUgk4FYmE5Wwl",
        "price": "256",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T06:45:00",
        "buffered_depart_time": "2018-06-20T05:15:00",
        "arrive_time": "2018-06-20T15:40:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "40.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T16:10:00",
        "buffered_depart_time": "2018-06-20T16:10:00",
        "arrive_time": "2018-06-20T16:40:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "30th St Station, Philadelphia, PA",
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": "34th St b/t 11th Ave and 12th Ave, New York, NY",
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "9.0",
        "name": "megabus",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T20:25:00",
        "buffered_depart_time": "2018-06-20T20:05:00",
        "arrive_time": "2018-06-20T22:35:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T22:45:00",
        "buffered_depart_time": "2018-06-20T22:45:00",
        "arrive_time": "2018-06-20T22:51:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share:bus:ride-share",
    "id": 180,
    "departing_segments": []
  },
  {
    "total_price": 434.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 125,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T07:34:00",
        "buffered_depart_time": "2018-06-18T07:34:00",
        "arrive_time": "2018-06-18T07:40:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "30th St Station, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T08:00:00",
        "buffered_depart_time": "2018-06-18T07:40:00",
        "arrive_time": "2018-06-18T10:10:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T20:12:00",
        "buffered_depart_time": "2018-06-18T20:12:00",
        "arrive_time": "2018-06-18T21:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=4001122827516499_0%7C3982431552169857_0%7C3982431552169857_1&price=266&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPyTEy6XbRnhA5yvVmvorIVcqhQQS+ax8fObRTBjno04vq5h7aicz+gjx8tCnIVIJh09NAPOUxGpOh9k79AK6bGfhFvj69RhhtEyIENtvLahEpBm373rdrOgApvs6YHmabANZ3zhGs+7uOIQtKn4yHSH43L5vQ3rrIFpB0Q7vqDvSgiE6EfkHkiyjJuEpYTDq8s4IdpFcIOROuKIZTRgn0hspiEaK4qP/t/kP1+cyPbb8UA63kop+pjn3sn7XM+05fq4uzx5oc14LnweCoE7SfwCP71ZGk6TL3KQSX4EPSszZsOMcVjPJM39jd8TwmpMGsmuFULhDEZr0mTjGYT5TSnXjZQKHn3p22VJaKZCEQQz75L7lZaCa+dpAduUUkfxJTW3U1dKQM0mLj5Y9UhThuWWcwwN9rzNSJMC3obX9FBnT7ZYODJq2p5XiTatK6aNiME7VjrCFWyU1KNT3IsX79UlBoC1OT/ZGPzhqh/lgI6pltNJWDb9kvQcqq/kvUAERTYJJl43b0Bu+T0fNQQkDmM7GoPhO8OhZoiOi6SQBi4+glKof9r6cy3dZke1c/4nNzjzYg6mKsnnk28uQfb0at2kbdTaI83Mhgu15qQAfuk3nWAqSFVBpNkr6aBXXgKVmL6bvqF/bMdhCG9/KrOi8Bj2+qkwHTk15hA1IOzXoD9N0guwpgSafWiUwp5LjdGnZtDHpMA/Feypu6aeZ3991pzJQXqAejXwUzV6JpDA9wETyZdOqrhzwEEMm+ZOU5ajgq",
        "price": "315",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T22:45:00",
        "buffered_depart_time": "2018-06-18T21:15:00",
        "arrive_time": "2018-06-19T09:43:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-19T10:13:00",
        "buffered_depart_time": "2018-06-19T10:13:00",
        "arrive_time": "2018-06-19T10:37:00"
      }
    ]
  },
  {
    "total_price": 320.5,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T04:05:00",
        "buffered_depart_time": "2018-06-20T04:05:00",
        "arrive_time": "2018-06-20T04:30:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=3522835704288553_0%7C3558020294474371_0&price=210&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPv0KvDn6aPXv/5v9h+zKCcbu13e8YbaoOuO9VmF5FyN9a0MD7UdSZmCHohwXaF1xnr9QsbppOtU2slJWlujwbbFNc5vpNRcVRyHHs9FG0xf+iw5GN2EBc/b5rP/V2V9fU7EmnK0zYHQHgc7s3aih+0bPf7SO1wy8dsl9h8PQ+3m0vbF+Mm6Z8YWiZB+1bTSLm7dvxh4Kiie2n/nLwreB7S84FweAAH5jBxNO3ubykr0LoRm7+D/7oAsBJhWydpg4x0oYfOpAzLRew8tYIfT1G80oHID9dkhwsoTj+izzRkjr7m6HXVX11+zf87wxPPXYfIwKUf6CzMt+yH1KsDcfwOc2OWLQwsE/pY7tZBIU7oSERZ3ibs8lD3IIvSAqEcBmXQERcxYaU4idpwp44UfQjhpqZDBcMuRdnI8p1hes2iLyCpgrQuYipXBH8RA4QqdpzUehu31uGLKHzcAOxoCY/JyUtJqq2S1/nh4lI7Zn2sc6h4bW7cYItQ3QdHN6+cAjpatC509pbz6mbRpDHvlUxNOgBsukQVe6/cDJ9x0GO1QIz1jS6NZKRHB8HDcg3vtgHX8dwhnTOaTVeqCTe6TsyWqNnw6nC3FusReNirsyp61+qybAD5YWm5a02Ed855sIlf+q2X6rGFTFJSGNifgv8gTg57VOi3cgmWMGoZyYda5LVJzpxb0vvo5cyZ67N7FRZ",
        "price": "249",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T06:00:00",
        "buffered_depart_time": "2018-06-20T04:30:00",
        "arrive_time": "2018-06-20T17:00:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "40.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T17:30:00",
        "buffered_depart_time": "2018-06-20T17:30:00",
        "arrive_time": "2018-06-20T18:00:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "Independence Hall Visitors Center, Philadelphia, PA",
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": "34th St b/t 11th Ave and 12th Ave, New York, NY",
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "9.0",
        "name": "megabus",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T20:25:00",
        "buffered_depart_time": "2018-06-20T20:05:00",
        "arrive_time": "2018-06-20T22:25:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T22:35:00",
        "buffered_depart_time": "2018-06-20T22:35:00",
        "arrive_time": "2018-06-20T22:41:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share:bus:ride-share",
    "id": 163,
    "departing_segments": []
  },
  {
    "total_price": 434.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 133,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T11:54:00",
        "buffered_depart_time": "2018-06-18T11:54:00",
        "arrive_time": "2018-06-18T12:00:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "30th St Station, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T12:20:00",
        "buffered_depart_time": "2018-06-18T12:00:00",
        "arrive_time": "2018-06-18T14:30:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T20:12:00",
        "buffered_depart_time": "2018-06-18T20:12:00",
        "arrive_time": "2018-06-18T21:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=4001122827516499_0%7C3982431552169857_0%7C3982431552169857_1&price=266&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPyTEy6XbRnhA5yvVmvorIVcqhQQS+ax8fObRTBjno04vq5h7aicz+gjx8tCnIVIJh09NAPOUxGpOh9k79AK6bGfhFvj69RhhtEyIENtvLahEpBm373rdrOgApvs6YHmabANZ3zhGs+7uOIQtKn4yHSH43L5vQ3rrIFpB0Q7vqDvSgiE6EfkHkiyjJuEpYTDq8s4IdpFcIOROuKIZTRgn0hspiEaK4qP/t/kP1+cyPbb8UA63kop+pjn3sn7XM+05fq4uzx5oc14LnweCoE7SfwCP71ZGk6TL3KQSX4EPSszZsOMcVjPJM39jd8TwmpMGsmuFULhDEZr0mTjGYT5TSnXjZQKHn3p22VJaKZCEQQz75L7lZaCa+dpAduUUkfxJTW3U1dKQM0mLj5Y9UhThuWWcwwN9rzNSJMC3obX9FBnT7ZYODJq2p5XiTatK6aNiME7VjrCFWyU1KNT3IsX79UlBoC1OT/ZGPzhqh/lgI6pltNJWDb9kvQcqq/kvUAERTYJJl43b0Bu+T0fNQQkDmM7GoPhO8OhZoiOi6SQBi4+glKof9r6cy3dZke1c/4nNzjzYg6mKsnnk28uQfb0at2kbdTaI83Mhgu15qQAfuk3nWAqSFVBpNkr6aBXXgKVmL6bvqF/bMdhCG9/KrOi8Bj2+qkwHTk15hA1IOzXoD9N0guwpgSafWiUwp5LjdGnZtDHpMA/Feypu6aeZ3991pzJQXqAejXwUzV6JpDA9wETyZdOqrhzwEEMm+ZOU5ajgq",
        "price": "315",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T22:45:00",
        "buffered_depart_time": "2018-06-18T21:15:00",
        "arrive_time": "2018-06-19T09:43:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-19T10:13:00",
        "buffered_depart_time": "2018-06-19T10:13:00",
        "arrive_time": "2018-06-19T10:37:00"
      }
    ]
  },
  {
    "total_price": 323.5,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T04:50:00",
        "buffered_depart_time": "2018-06-20T04:50:00",
        "arrive_time": "2018-06-20T05:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=4035207816796086_0%7C4035207816796086_1%7C3598702163596938_0&price=216&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPhMhiXGhmctYJmBJTQXuLUj1sQLf00gX21TRZqyUR0SpvoV+yG9wrU9B5Ar6P6oUSiBCHuRO3/5RF54tI0igB+D/9PpPqvFzSqMMttDq1By25DXR4EbrRJ5At+3SxjkxfGVzqyD53lYxIN4mL1WoeZa0LTFJNgqN1oJUYNOcEQfzunyKLZR80nevtXKfmer7OSOSETMIt6nbMsGRdiP+b5gC4xgVXmkMWdm7zhsRVkaQ7Y7Q2PLJXSGB9OqPmWPqgcsIgHkqojc7MtSGpz6WtM91o71URANaUm0cDFSHe1dlY8pW7IdR6UaBN2tym4ontittkIJj0fCvyIlylMxhI8eO7hSAjmBV54Ddz5SjJ52ChBgvlY5ZeF8tmHQDCreG2D+Hk7222ODayUJrJcg4TTU+f6VGG8DRRBw6/zShYveUqeP1JFTGMiNk3puTLhiQlVtjdRRd6LhjmC1noV/lUGaJ4f9XxMBZWEwbAHBrJDx/6BWFiJNQIEdmiK1DUmPCOBa5JHptKmrr+9Bo25MLMLDeHnzZgN0luToXOxc9wrI3DaZ4bo6m3gzr7J5whQzJvo21UQPBMNDwbtyriyoWyhIbpfWAWnYaTo6Xoaaftwx5Y8/OMtaCph4KSUcnRfEaU62Tuymambgc9GIYdigx/VpG7GVRJOzm8DeNeUJRbOjzB0s6k43u5AotV+WU1mLGtdKitnjQ4iwayW8khy6+mBqdGRv1C4z0CvPn0zrkf+cWxj2SqgX/WUgk4FYmE5Wwl",
        "price": "256",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T06:45:00",
        "buffered_depart_time": "2018-06-20T05:15:00",
        "arrive_time": "2018-06-20T15:40:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "40.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T16:10:00",
        "buffered_depart_time": "2018-06-20T16:10:00",
        "arrive_time": "2018-06-20T16:40:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "30th St Station, Philadelphia, PA",
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": "34th St b/t 11th Ave and 12th Ave, New York, NY",
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T17:20:00",
        "buffered_depart_time": "2018-06-20T17:00:00",
        "arrive_time": "2018-06-20T19:30:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T19:40:00",
        "buffered_depart_time": "2018-06-20T19:40:00",
        "arrive_time": "2018-06-20T19:46:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share:bus:ride-share",
    "id": 176,
    "departing_segments": []
  },
  {
    "total_price": 434.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 131,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T10:39:00",
        "buffered_depart_time": "2018-06-18T10:39:00",
        "arrive_time": "2018-06-18T10:45:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "30th St Station, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T11:05:00",
        "buffered_depart_time": "2018-06-18T10:45:00",
        "arrive_time": "2018-06-18T13:15:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T20:12:00",
        "buffered_depart_time": "2018-06-18T20:12:00",
        "arrive_time": "2018-06-18T21:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=4001122827516499_0%7C3982431552169857_0%7C3982431552169857_1&price=266&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPyTEy6XbRnhA5yvVmvorIVcqhQQS+ax8fObRTBjno04vq5h7aicz+gjx8tCnIVIJh09NAPOUxGpOh9k79AK6bGfhFvj69RhhtEyIENtvLahEpBm373rdrOgApvs6YHmabANZ3zhGs+7uOIQtKn4yHSH43L5vQ3rrIFpB0Q7vqDvSgiE6EfkHkiyjJuEpYTDq8s4IdpFcIOROuKIZTRgn0hspiEaK4qP/t/kP1+cyPbb8UA63kop+pjn3sn7XM+05fq4uzx5oc14LnweCoE7SfwCP71ZGk6TL3KQSX4EPSszZsOMcVjPJM39jd8TwmpMGsmuFULhDEZr0mTjGYT5TSnXjZQKHn3p22VJaKZCEQQz75L7lZaCa+dpAduUUkfxJTW3U1dKQM0mLj5Y9UhThuWWcwwN9rzNSJMC3obX9FBnT7ZYODJq2p5XiTatK6aNiME7VjrCFWyU1KNT3IsX79UlBoC1OT/ZGPzhqh/lgI6pltNJWDb9kvQcqq/kvUAERTYJJl43b0Bu+T0fNQQkDmM7GoPhO8OhZoiOi6SQBi4+glKof9r6cy3dZke1c/4nNzjzYg6mKsnnk28uQfb0at2kbdTaI83Mhgu15qQAfuk3nWAqSFVBpNkr6aBXXgKVmL6bvqF/bMdhCG9/KrOi8Bj2+qkwHTk15hA1IOzXoD9N0guwpgSafWiUwp5LjdGnZtDHpMA/Feypu6aeZ3991pzJQXqAejXwUzV6JpDA9wETyZdOqrhzwEEMm+ZOU5ajgq",
        "price": "315",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T22:45:00",
        "buffered_depart_time": "2018-06-18T21:15:00",
        "arrive_time": "2018-06-19T09:43:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-19T10:13:00",
        "buffered_depart_time": "2018-06-19T10:13:00",
        "arrive_time": "2018-06-19T10:37:00"
      }
    ]
  },
  {
    "total_price": 327.5,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T04:50:00",
        "buffered_depart_time": "2018-06-20T04:50:00",
        "arrive_time": "2018-06-20T05:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=4035207816796086_0%7C4035207816796086_1%7C3598702163596938_0&price=216&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPhMhiXGhmctYJmBJTQXuLUj1sQLf00gX21TRZqyUR0SpvoV+yG9wrU9B5Ar6P6oUSiBCHuRO3/5RF54tI0igB+D/9PpPqvFzSqMMttDq1By25DXR4EbrRJ5At+3SxjkxfGVzqyD53lYxIN4mL1WoeZa0LTFJNgqN1oJUYNOcEQfzunyKLZR80nevtXKfmer7OSOSETMIt6nbMsGRdiP+b5gC4xgVXmkMWdm7zhsRVkaQ7Y7Q2PLJXSGB9OqPmWPqgcsIgHkqojc7MtSGpz6WtM91o71URANaUm0cDFSHe1dlY8pW7IdR6UaBN2tym4ontittkIJj0fCvyIlylMxhI8eO7hSAjmBV54Ddz5SjJ52ChBgvlY5ZeF8tmHQDCreG2D+Hk7222ODayUJrJcg4TTU+f6VGG8DRRBw6/zShYveUqeP1JFTGMiNk3puTLhiQlVtjdRRd6LhjmC1noV/lUGaJ4f9XxMBZWEwbAHBrJDx/6BWFiJNQIEdmiK1DUmPCOBa5JHptKmrr+9Bo25MLMLDeHnzZgN0luToXOxc9wrI3DaZ4bo6m3gzr7J5whQzJvo21UQPBMNDwbtyriyoWyhIbpfWAWnYaTo6Xoaaftwx5Y8/OMtaCph4KSUcnRfEaU62Tuymambgc9GIYdigx/VpG7GVRJOzm8DeNeUJRbOjzB0s6k43u5AotV+WU1mLGtdKitnjQ4iwayW8khy6+mBqdGRv1C4z0CvPn0zrkf+cWxj2SqgX/WUgk4FYmE5Wwl",
        "price": "256",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T06:45:00",
        "buffered_depart_time": "2018-06-20T05:15:00",
        "arrive_time": "2018-06-20T15:40:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "40.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T16:10:00",
        "buffered_depart_time": "2018-06-20T16:10:00",
        "arrive_time": "2018-06-20T16:40:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "Independence Hall Visitors Center, Philadelphia, PA",
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": "34th St b/t 11th Ave and 12th Ave, New York, NY",
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "9.0",
        "name": "megabus",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T21:20:00",
        "buffered_depart_time": "2018-06-20T21:00:00",
        "arrive_time": "2018-06-20T23:20:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T23:30:00",
        "buffered_depart_time": "2018-06-20T23:30:00",
        "arrive_time": "2018-06-20T23:36:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share:bus:ride-share",
    "id": 181,
    "departing_segments": []
  },
  {
    "total_price": 95.5,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T09:12:00",
        "buffered_depart_time": "2018-06-20T09:12:00",
        "arrive_time": "2018-06-20T09:37:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "PHL Airport, Philadelphia",
            "to_lon": "-75.241111",
            "to_lat": "39.871944",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=PHL&departure=20-06-2018&flightsId=3742737716595647_0&price=49&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPj9FNv7BwqPj1/YTvndEJYBDxQ9Teaob+YHQRal4zLsjvjCojJlBS/UTi69vNX0jniM3GpF5OaPW/OsiK4OVchyjBA2gT+0c5FbQaaPQGTOaJ4ZxVvObTM01YOx5S5FRyP74ZrmyhZNzpSWymiCALZR7HNx2sC/i8dy13mVLwGgNdBdxq4WqqvZv9cnqiQX1A+vX1XsVwWH1Scfee8WcquMDyEn+0DoETBbLCSS3r55DKGFLt3bbnQEYZaI+EztJKvzOQ23s3rIi/22xI0G1jVAYZMtD2ZZslZR9cpIOiVHI5YAuAf/B/ufGK4jko08/AqbL1jKP6PGHkoIfP9iSl6QfTaiJzrMVEo5p4qU+kGrKuJvmpXoXOf0Be+ue62Yt39LfydiFtPygW5Mcr8wpsWZDtqABBDbUNTEPNKvFy2cGQb7vF0yl9FWzqzNV3WWReh9kfKD0AO9vTXx4EffIgVKkoxP53bhmxIwip3CRvo12z8Am+nx9bRlWvihFXsg0IW0gvv2vXGhyorJQA714fohAwjpb6ip2cv77Xexng3Kp04oeZCfHoLXK1SRF8rxAm6OFkZMGcdytNDDvgeOWO2Fwvbh/mJI2KYT5TAr+c1q3iSamqwZxTCOMASyvsy4JM1Q8CB7Wwq871TLteeOvXmw==",
        "price": "58",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T11:07:00",
        "buffered_depart_time": "2018-06-20T09:37:00",
        "arrive_time": "2018-06-20T14:59:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-75.241111",
            "from_lat": "39.871944"
          }
        },
        "purchase_link": null,
        "price": "21.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T15:29:00",
        "buffered_depart_time": "2018-06-20T15:29:00",
        "arrive_time": "2018-06-20T15:52:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share",
    "id": 145,
    "departing_segments": []
  },
  {
    "total_price": 481.99,
    "returning_segments": [],
    "permutation": "ride-share:flight:ride-share:bus:ride-share",
    "id": 107,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-76.668333",
            "to_lat": "39.175278",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "159.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T02:15:00",
        "buffered_depart_time": "2018-06-18T02:15:00",
        "arrive_time": "2018-06-18T04:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "DSM Airport, Des Moines",
            "to_lon": "-93.657778",
            "to_lat": "41.534167",
            "from_string": "BWI Airport, Washington, D.C.",
            "from_lon": "-76.668333",
            "from_lat": "39.175278"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=BWI&to=DSM&departure=18-06-2018&flightsId=3996724995832597_0%7C3996724995832597_1&price=248&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPhYbp2B7dwzoom+IQKQK6YBVlDUgTUhuJLWwX3kR5FGzsPBtW8kaSJ/MyUqw1x+DiC9YLuddxh58sToymGbYLqQ9XPv/8UXS4+qS/IF6Y7reftqdXJQwnzmDyAogZMO8dE81PhOrXZmIHx0/rj1txO6syYKCwHk/wbRC7ArF8jYh9O4WQc4eSukBIC2UYr5TbgNhPcTM4C2O7Xp1dazBMCmKp892w6ngRiWxQTzL8CDBxPt5QSQ794bYihDgpzdQ9uUJFag2gbMskrpGDNKgc489VbT4Q29uHdEPPbZQ+S5w2wYDwNQoo2wd98nR3wAdwNKfqZHRfCC/DtDOo9aYJbwGjVQHmqmzC2T97arvYZ3I3pRO9a9TNtV8bzOuOFeY4FXlpKUcMihYj2Uu9SsV/raNLcscNMmluAuvlyIWJut440OGc2zd/wVnBX8iAtiqoPdAHabwaGhUkSi0EaS18oJx/rXKW9MRkyLEO+K5bvSPpgaB4uLHLXH2Udk7UNGhbHQhVxtVRGKDdlDegdIgyzxHux6miAkp/qSx0TPDz21kfylar0j7qnwLToQ9/uVBYQLwAoZIBa1ZA/M7hl31dacqA70YSK3JHzsjcLQP1gL5N9qR9ts/ydkZtiqfZOcymvXhhCTtwUmJs5lsNjCB6veI8fp2/OP87XYRqdCniFnuxB+KqZ9g4Nf5QEcppLJC9cz7UlwUEQ0p9SeBWJ//fQQ==",
        "price": "294",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T05:45:00",
        "buffered_depart_time": "2018-06-18T04:15:00",
        "arrive_time": "2018-06-18T11:20:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-93.62697",
            "to_lat": "41.58329",
            "from_string": null,
            "from_lon": "-93.657778",
            "from_lat": "41.534167"
          }
        },
        "purchase_link": null,
        "price": "13.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T11:50:00",
        "buffered_depart_time": "2018-06-18T11:50:00",
        "arrive_time": "2018-06-18T12:03:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "Crossroads Mall - N 72nd St between Dodge St and Cass St, Omaha, NE",
            "to_lon": "-95.94059",
            "to_lat": "41.26069",
            "from_string": "Eastbound side of Cherry Street, between 7th and 8th Streets, Des Moines, IA",
            "from_lon": "-93.62697",
            "from_lat": "41.58329"
          }
        },
        "purchase_link": null,
        "price": "9.99",
        "name": "megabus",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T17:40:00",
        "buffered_depart_time": "2018-06-18T17:20:00",
        "arrive_time": "2018-06-18T19:55:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.94059",
            "from_lat": "41.26069"
          }
        },
        "purchase_link": null,
        "price": "6.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T20:05:00",
        "buffered_depart_time": "2018-06-18T20:05:00",
        "arrive_time": "2018-06-18T20:09:00"
      }
    ]
  },
  {
    "total_price": 519.0,
    "returning_segments": [],
    "permutation": "ride-share:flight:ride-share",
    "id": 104,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "198.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T11:34:00",
        "buffered_depart_time": "2018-06-18T11:34:00",
        "arrive_time": "2018-06-18T13:23:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=3488751098027710_0%7C3917560245168350_0%7C3917560245168350_1&price=259&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPQ/zjLVOCowaBhF3iXk2bEn07Xr+8wLkggi326weN87Ro+JAqpgcdJfVoCY0gNDJ4fB0J4RufmcjOaCwW3AbMCo8XFkKDbrB0oIQwA3e/aW6K8Ys3/ku9d1vxwmLon+yv+bFwAiVPExnL6gsiw8TxaUmHbKSL+xay9ajemdjep+/EZA1nATyyuM0jwcNgnMHTcZfzk/qcPzjTsMS00avOBBU45EIUOQzDElkzubjIafzzee7F9tDWncyWPBIz5Tno2sHea3cd73l6vqwO/FD1WLgmVV0HXiI9oqAWiV3YZuiztBzXsEn+xzS7AfP+d05/1OSyiwc2odYc5bbQYvVBj1i/OIFdUg1SOa2cq7u7tBf63hRqJUb5oZC5eWkwxD88SHr3JyAXmaEsmTjRnZS+++mldtiDIKZnEcp1e2DHcSbWgMWmz63rzQMwLVunaz79FrShfTbz/0Yx0e9rsZpY9HFPbOtnLVQgADJFOnOutygiv5jD+KbX+s98ZIuf4+IGSbRacmw5Yi0rKEHUsrzt2poDmC/uKnXXY/S2L8Om7a0nbneIgst58LBWMZ6lg41QHx+F6SmVsnwFQr76Vew0R1EtIvyP4VwG7LlkellJvLN2o+DnI/aNjjbd/jxy4necGykgrpmWKgejZN0NWvFEHkU9dm/dZbz7D2AGFZkQ+EVw3NdkmOSEzd+mBoU6RcI4Acq9+e0nJDuVdjP/aaLkoTW3+4rEBa9HbCjYvZv1DIvKDb5xrZL3hyDh72dGJV61A1Iawj2oOCn2+lIxIi5erw==",
        "price": "306",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T14:53:00",
        "buffered_depart_time": "2018-06-18T13:23:00",
        "arrive_time": "2018-06-18T23:15:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T23:45:00",
        "buffered_depart_time": "2018-06-18T23:45:00",
        "arrive_time": "2018-06-19T00:09:00"
      }
    ]
  },
  {
    "total_price": 454.0,
    "returning_segments": [],
    "permutation": "ride-share:flight:ride-share",
    "id": 102,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-74.168611",
            "to_lat": "40.6925",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "142.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T02:42:00",
        "buffered_depart_time": "2018-06-18T02:42:00",
        "arrive_time": "2018-06-18T04:30:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "EWR Airport, New York City",
            "from_lon": "-74.168611",
            "from_lat": "40.6925"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=EWR&to=OMA&departure=18-06-2018&flightsId=3936251671636414_0%7C3617393739439407_0&price=251&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPd+K+HrEM21OsTjvEBD2tdnGWe7xDz30+/UsgP/WkM5CIhHOKRs9MhBY81RJJcS4W/bp2EcTcCjFpUqDTnvrNVUcbzgzvU2SCjWODgkQBwxaX8qXHID8o7F2fto4C2wwUQfo29AN8VsIkJDaOWQWLOpL68OBrdcn7sP1cy1emI0evzdwdRzbq7lMcBloDcPJlCUMxlaietYI6HYiwyfho77l9ziqBQWSE6T9De/jHqN2GsIgECPuWNVp1v/5Uo1coATCZHj89mkCJB27jfB2xDlZjG3yuNCFBE0oeN9fNniDNWcROP/PNAe7aDhJUlCbK3kYWAeadXSXvyrEKKe41AHZ4yQki1aDx4y9z8w24EArx8FiuqRd5UK7MnyJo8mg5RSz+Oq9moLxon//8dSWbQJ1uI28GYdC5B/Fj9wpKXH0trpx/Byg0kgVF7/LuZ+WUtYyhxfDcuQV+6Kj/NWG0UwXbj4gc8Vw6ukYgz3iZPWDoAFlkaX+obtYYhnuHLXTKFaEDoiUrwViDJMnypJ6PAuaFpep8hreDAPS5D1b0kxB3i5ZcFASx+JxewJ+8yQL4mInch7mG3o5svlBADHogd7T+S0BlfhcATYH+39qZb2zzSUmPG/BKDr2K+Ja3DxF1FXALwoIOydsfuveUX6Es9Ts0lvKUaGIhgCLPfHMQeUdZjrL4IFe4U3c0ZHO3OcT4t/jKlxMMvM8tgO+AKrtgWw==",
        "price": "297",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T06:00:00",
        "buffered_depart_time": "2018-06-18T04:30:00",
        "arrive_time": "2018-06-18T15:30:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T16:00:00",
        "buffered_depart_time": "2018-06-18T16:00:00",
        "arrive_time": "2018-06-18T16:24:00"
      }
    ]
  },
  {
    "total_price": 425.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 118,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T09:34:00",
        "buffered_depart_time": "2018-06-18T09:34:00",
        "arrive_time": "2018-06-18T09:40:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "30th St Station, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T10:00:00",
        "buffered_depart_time": "2018-06-18T09:40:00",
        "arrive_time": "2018-06-18T12:10:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T12:20:00",
        "buffered_depart_time": "2018-06-18T12:20:00",
        "arrive_time": "2018-06-18T13:23:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=3488751098027710_0%7C3917560245168350_0%7C3917560245168350_1&price=259&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPQ/zjLVOCowaBhF3iXk2bEn07Xr+8wLkggi326weN87Ro+JAqpgcdJfVoCY0gNDJ4fB0J4RufmcjOaCwW3AbMCo8XFkKDbrB0oIQwA3e/aW6K8Ys3/ku9d1vxwmLon+yvmR6rUcdTfTK8EGievETfkPgySpkUB8YZqoXoGoiv/WY9pasl6OuRjvTlIywLL+QyfjhUKU+jCSkQWeMvi+KYd1rDl7DABeDM0CDi+zkOOd/AD/MNOyfyFnDxJJlCPfgw3udVGuJ2VuYSlsgQYekguJp/lU59sZ/S1eqWopMaTpelkpjeGmod1t17bypJHfmL5sj0Zpg8t7g7V+JfRDg76U0/K/FOPFfqlA1mkekWGFmXCY6Ia8gGY+v10wNmZ8zHGqhzxHB6rKyNyjq+hdiX/HbxCvYnQR6+OaRX+pMZTZGrbj16x+o5JKfyC4Y3wsSHc/736Um3EHrKj/L/NL2zjB2aw7UnUpKcHtmLAOlflfcJUYfJFNRK3Q/vqLroJvAcV7AdUhqD2oJmBpRmt66Tda3LECLli8QAKtmUNUUQgit/R+ut47g6kF0cIKA8GQUMOpl+xk434O4UX5m6FnBr3wiAOP0H3txba5w/OZf+KmbYjWEcw56wp3Znq0wmG0Z2fTWg6x7LumeITdmVYldk8nG49PBKUfEjTjAmVZUvDnBn5qbkb0G15TUvta9Cc5I5jtlV9ZPF/Lyl5ECsT/7qscAfMjE9FnWVwbOys9Sat12+Jls2ozxNj2/vYQNkIvgwVn8aXwJhpkraGo//KeMhJw==",
        "price": "306",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T14:53:00",
        "buffered_depart_time": "2018-06-18T13:23:00",
        "arrive_time": "2018-06-18T23:15:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T23:45:00",
        "buffered_depart_time": "2018-06-18T23:45:00",
        "arrive_time": "2018-06-19T00:09:00"
      }
    ]
  },
  {
    "total_price": 396.99,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.94059",
            "to_lat": "41.26069",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "6.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T11:41:00",
        "buffered_depart_time": "2018-06-20T11:41:00",
        "arrive_time": "2018-06-20T11:45:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "Eastbound side of Cherry Street, between 7th and 8th Streets, Des Moines, IA",
            "to_lon": "-93.62697",
            "to_lat": "41.58329",
            "from_string": "Crossroads Mall - N 72nd St between Dodge St and Cass St, Omaha, NE",
            "from_lon": "-95.94059",
            "from_lat": "41.26069"
          }
        },
        "purchase_link": null,
        "price": "19.99",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T12:05:00",
        "buffered_depart_time": "2018-06-20T11:45:00",
        "arrive_time": "2018-06-20T14:45:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-93.657778",
            "to_lat": "41.534167",
            "from_string": null,
            "from_lon": "-93.62697",
            "from_lat": "41.58329"
          }
        },
        "purchase_link": null,
        "price": "9.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T15:24:00",
        "buffered_depart_time": "2018-06-20T15:24:00",
        "arrive_time": "2018-06-20T15:37:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "EWR Airport, New York City",
            "to_lon": "-74.168611",
            "to_lat": "40.6925",
            "from_string": "DSM Airport, Des Moines",
            "from_lon": "-93.657778",
            "from_lat": "41.534167"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=DSM&to=EWR&departure=20-06-2018&flightsId=3925256557994931_0%7C3925256557994931_1%7C3654777026444493_0&price=208&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPtHBIWCToAMXeV+NGQjbdlXbX0Mn2W18wcN04EbEk5nSu3Fa8lRPxDS1ckEgKF7e6/zr5qSbDj18FVKvKxRW7PkZSWnPWnPRrFSWBs3A9uHtCGG5QV+sruDJPNjQnr2wi4W8tzP61DLAoYhcPvGBfcouo6TvM283dGUebHBdiJQZ/Xyl/fetQf/bHSGbiWef75kGVK1aDpHQx8IwzszV7MXK8OJsOn5GhNXvUBYCA9RLZHKp/aTiHZN6afdEkBXS2H6ssn8U5iO6E8/t20lPpmR+zTXhSiju4XbKo2+O5eEZVUagNbS8oCGWW7kCnO4AhltU9aIdTR0PiQ2BVniuGbwOVi1OpWFgG4Ix+Qtkmiba/ki+4iQzaGOk8hKyeMmCVHRBt1SQ5lx5zefmiWKDIo8Mkn7IOgy1fWvMD6BDtoxqAjESHnUnl9sD3FsB5SoA85IGhU6YhQbpi/OBn8mHryko2dC+7oCiGSfrYQ5zpnoQMmly5j11nTwHWSD2OrY2Dh4zZFNVMoU44zkj6YQpsnrBjOpp6Fo/1Nw36+qb94LHgGXNOCJqKQDOY0YGvbzGHOmkWEdwjib/CEQhZuJSGsZaLmTixaVVbXUGS8crRjq8Srg08MEQO6oA9/x9LhATVipv5+zr0PqljiuZZp1slbnXZQRtkxnBHamMtGB/R6yOoJ8X2PsXJsTvVGcTRhw7eC5WrQVhfQ3Z2jDpSGM+op9IfEpCySXbU3KtXLEOFi4iS79DN6g1jLQyY337NRf0F",
        "price": "246",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T17:07:00",
        "buffered_depart_time": "2018-06-20T15:37:00",
        "arrive_time": "2018-06-21T06:40:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-74.168611",
            "from_lat": "40.6925"
          }
        },
        "purchase_link": null,
        "price": "115.5",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-21T07:10:00",
        "buffered_depart_time": "2018-06-21T07:10:00",
        "arrive_time": "2018-06-21T08:55:00"
      }
    ],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 189,
    "departing_segments": []
  },
  {
    "total_price": 409.99,
    "returning_segments": [],
    "permutation": "ride-share:flight:ride-share:bus:ride-share",
    "id": 108,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-74.811944",
            "to_lat": "40.276944",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "68.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T04:41:00",
        "buffered_depart_time": "2018-06-18T04:41:00",
        "arrive_time": "2018-06-18T05:30:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "DSM Airport, Des Moines",
            "to_lon": "-93.657778",
            "to_lat": "41.534167",
            "from_string": "TTN Airport, Trenton",
            "from_lon": "-74.811944",
            "from_lat": "40.276944"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=TTN&to=DSM&departure=18-06-2018&flightsId=3487651920535173_0%7C3565716239065113_0&price=265&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPMvKGKlTNa23c2RQH0Qbe9a10hg/BOPwk8bkHjTkGnZNocZtCs90d4g1iSkFb2vvuALi2r121QyOjZc9jLZ5ZJOcYMt0q+8eYv9D/zxpOVMgWS7EJl1s8dfqsIJXxosgn8mxvYH20b9EoS3dmuMp+eSPiBt9cQqieeKPNFNLrS2US6fQU0n58/T55fIPC2vWr/y4d33gHWUsYC7S5eAZcQcoHf/lfJXYDFQG/heMc9D6+AyoK0w9otZUeDc5mKKoR5KuK+S58si2vHVxqcSELPLy4o1+4S4iQ7YTC+vG0lsT289AacBxkYmrN4TquOWSe5uZo/nzOduvm6A/tZH7JEcQbk1AagFSDc1s9x3NjDbtkB+OKlmmgXe1p0COKmnLcwJZhzTHRA74GFhyiIugwAeLccZY5yTdJmSubDfVRtLZOWc1eDg3h5C9OErgcobILBsrFsg6z25WvkdQows464Vnu299aagf8XWBwyRj/WwbgN5+HB0ISK7VKQe5mWUk6c/Vn1C6oLm2VyGEj9ZnJoUajrd8eBXUQAfYnczhA0BIIBhFdzj+gy3nArfQz00Xp/oOiQv1c/rwkfEXrSUBUGsNkKmI9bZhDWm8rWBdMkIIcLoYRslPEYHoCIpOUzVa4cnxVKGWvcjoUBbZelvMrP9dVusRp3/G8aJt0eitabU3R//es4qq93dvlv7Rb8OxJkiiGiswz3t6sXO+ng2dUlw==",
        "price": "313",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T07:00:00",
        "buffered_depart_time": "2018-06-18T05:30:00",
        "arrive_time": "2018-06-18T16:10:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-93.62697",
            "to_lat": "41.58329",
            "from_string": null,
            "from_lon": "-93.657778",
            "from_lat": "41.534167"
          }
        },
        "purchase_link": null,
        "price": "13.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T16:40:00",
        "buffered_depart_time": "2018-06-18T16:40:00",
        "arrive_time": "2018-06-18T16:53:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "Crossroads Mall - N 72nd St between Dodge St and Cass St, Omaha, NE",
            "to_lon": "-95.94059",
            "to_lat": "41.26069",
            "from_string": "Eastbound side of Cherry Street, between 7th and 8th Streets, Des Moines, IA",
            "from_lon": "-93.62697",
            "from_lat": "41.58329"
          }
        },
        "purchase_link": null,
        "price": "9.99",
        "name": "megabus",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T17:40:00",
        "buffered_depart_time": "2018-06-18T17:20:00",
        "arrive_time": "2018-06-18T19:55:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.94059",
            "from_lat": "41.26069"
          }
        },
        "purchase_link": null,
        "price": "6.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T20:05:00",
        "buffered_depart_time": "2018-06-18T20:05:00",
        "arrive_time": "2018-06-18T20:09:00"
      }
    ]
  },
  {
    "total_price": 528.0,
    "returning_segments": [],
    "permutation": "ride-share:flight:ride-share",
    "id": 106,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "198.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T19:26:00",
        "buffered_depart_time": "2018-06-18T19:26:00",
        "arrive_time": "2018-06-18T21:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=4001122827516499_0%7C3982431552169857_0%7C3982431552169857_1&price=266&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPyTEy6XbRnhA5yvVmvorIVcqhQQS+ax8fObRTBjno04vq5h7aicz+gjx8tCnIVIJh09NAPOUxGpOh9k79AK6bGfhFvj69RhhtEyIENtvLahEpBm373rdrOgApvs6YHmaboqK17JZhsTcidXttykDOKkIk6zOinvXkijmheSY65KGghwDZNkbbIqYJOR8hCVv8YW8jM7MgXV1+FvEvZnocpUloAB9y4mnQ2CgAnBLMO7Qflq+RMgUghz7AQoYGtaDfjZEMrv3dWfHlfd8JexmPecbQRNgKt+UrN5saQT35E/aGVcJ5hVXRBkPpJXKNPWLl31IBFlGmsdMfWaDgHRRpaWvppwo1syqpp6oSf7oq4lge9IYxRPHr6Dwbq8e7elUo7gGdXHrRMNwNSJTwed7Uldv07SYrZ2TCghKfWmYJf9t9Vm4m6jONVxCQtf2sGTCuRqo7iwZZviKghZdH6zIaGhpOMwuy1fhF8H3j/h4yhMJTtZT9diSKg6qnc8Ag/zckALw5/hLQ23WdmLRYYrXuHkL+iSlYJtS3MjNnvJVytK98xpVDZrscQdjsflu3ZK0jocxwGBQxLwPorcF/iu9fnwcriUIl+Qh9ac8jrddARJqL8/0hcoQvt0WgYLc1V7jKAfP1DPVSNqMXfZP4h9sHm1HuhxE94A0WGRCfuPHuqqpO+N2XD5nJqszHOzWGY81w05tPUCZvuOohCwdifD+qA1kkhWC2CDi1KM83zfZ3xQnugYpUKO6dcPgf1ysCjXDs",
        "price": "315",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T22:45:00",
        "buffered_depart_time": "2018-06-18T21:15:00",
        "arrive_time": "2018-06-19T09:43:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-19T10:13:00",
        "buffered_depart_time": "2018-06-19T10:13:00",
        "arrive_time": "2018-06-19T10:37:00"
      }
    ]
  },
  {
    "total_price": 435.0,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T15:20:00",
        "buffered_depart_time": "2018-06-20T15:20:00",
        "arrive_time": "2018-06-20T15:45:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=3942848755778894_0&price=178&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObP/GQc7RXEySu6up5WPlRDX9L1+fWRjUBAE89jyP+Wfvt628tAoJqzwCtsoXIyhdyvATQw7k6X/LIrFcxLxIhC2uLLKfgLMlwZBUgdD+Eqr069yn+5BA4sekTKAxzwTwZ6hjnsYMgUReKPcqFgxnqSAhrejh66E/9jJA4RByhGPZkNKcCQ/AUeFqU5fVHbwkEQsMB4PMP6hhK/34ULTjn/KsAP3mzUWPuWX2v7mHMYBr9BF3biwBckl8m5p7aVv279wX55KIDYl62znkFbwqAVDrkMvv9zVOGAAaWiM/EiodUeaMHaJJ3AbzVnomVXp4fxDw30WRksA1gKnkCNQXzZOftF6qvm9JeGY1t9VyYGuPIx/nt/4wDqEjXG24Vs85wGpBa28YtKEKHbgb7J6HAVRvBZhZ6TPIn15Cbcokgib5OoLNf7TLrgJ4lQXfPQ9PB7VBQj4rY3+N4r9ZcyV8Qm5xd54J4SehJXgP0nsY0GJfnP/8f7N+AHT0Tkq0kxifozuKGkIhGkQGdbfGhsoPIqnAuXsxAGdDSPRZOaXPMBP6WJs6X58uZAcW1mc6V8J5TOa3f+ZsQ+fOpH73U+pE0I2L3rdODaDaO5mr2VelCT1WK7bAORz27Q5QSfNx4SdtHkXGNGB4bWlSbOSbC0KvzCyw==",
        "price": "211",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T17:15:00",
        "buffered_depart_time": "2018-06-20T15:45:00",
        "arrive_time": "2018-06-20T21:15:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "208.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T21:45:00",
        "buffered_depart_time": "2018-06-20T21:45:00",
        "arrive_time": "2018-06-20T23:36:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share",
    "id": 149,
    "departing_segments": []
  },
  {
    "total_price": 387.0,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T04:31:00",
        "buffered_depart_time": "2018-06-20T04:31:00",
        "arrive_time": "2018-06-20T04:56:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "ACY Airport, Atlantic City",
            "to_lon": "-74.577222",
            "to_lat": "39.4575",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=ACY&departure=20-06-2018&flightsId=3602000657871465_0%7C3602000657871465_1%7C3638284455381550_0&price=213&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPflSDCeEN0+9xw2cm7ws5gho5Z3fcAaUr+ybrBmAgNp4YGIRsjgF4U5LDDAskv+ww1yi7Ys45EGFPy6MS7WQSDLhSdnZTNsQysPganHnw/Y1cR93OJ+AV03kGeVNtkSTT7Do8xlUG/IvYjPys1V07tHSp467+jV13FPd6QcH16eNwvuflRumVS671n7ZBwHo+eaD+SK2Y9i2CgfEyCfkXLw5gaGTUDYTrViSnj1FJFx5shont2xefwYZW1bwYUYqNUdVc/pRaJt8cWyzA9MfzgKY2FWyEeSmC3hpxYfbdpv7MlwpiaTczi3SU3fDKB/cgVlr+xxEHC3Pf+htWtiY/txyf2HhFjBZORWShcw2dn8Pgu/p+bjNoVhRqA9uXm0bkJDb+b34eXUYHIMSG7OhqWgGtB696I2O3ZrAet6yy1BmA8m2pjjomwSaaazRfSJRRZuqsK8uc8OOdaMW5zzQx+jO8v4yShpw3aCf20OLKczLNhbo/kkIV5vUbsrwdF84XGr/Kaw6fBWEd6tvzhjUJXdAuTl1prRaIrj+KaHQHTMuTdNCJ7Q/lY+nd5rTXAfHpUA+iwnBHsMrW/YJVgqSLqF6lOHsbIXMBW8K2big/iRC45Kbj7Ca691bHwV5ctrwxD71cdqAwix6uW5YXDtH87Av/U6yRNCcVbY0nr2dUTjVlwKIufpzEYer0alQvJ8dYB1Tgr3UT2bI6NHjrE9CRIbAJhNQ8zI3z1hSi3ttsQ0plccVjAEiR+smJOfOvTDlR",
        "price": "252",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T06:26:00",
        "buffered_depart_time": "2018-06-20T04:56:00",
        "arrive_time": "2018-06-20T17:13:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-74.577222",
            "from_lat": "39.4575"
          }
        },
        "purchase_link": null,
        "price": "119.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T17:43:00",
        "buffered_depart_time": "2018-06-20T17:43:00",
        "arrive_time": "2018-06-20T18:58:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share",
    "id": 154,
    "departing_segments": []
  },
  {
    "total_price": 425.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 112,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T06:34:00",
        "buffered_depart_time": "2018-06-18T06:34:00",
        "arrive_time": "2018-06-18T06:40:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "30th St Station, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T07:00:00",
        "buffered_depart_time": "2018-06-18T06:40:00",
        "arrive_time": "2018-06-18T09:10:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T12:20:00",
        "buffered_depart_time": "2018-06-18T12:20:00",
        "arrive_time": "2018-06-18T13:23:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=3488751098027710_0%7C3917560245168350_0%7C3917560245168350_1&price=259&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPQ/zjLVOCowaBhF3iXk2bEn07Xr+8wLkggi326weN87Ro+JAqpgcdJfVoCY0gNDJ4fB0J4RufmcjOaCwW3AbMCo8XFkKDbrB0oIQwA3e/aW6K8Ys3/ku9d1vxwmLon+yvmR6rUcdTfTK8EGievETfkPgySpkUB8YZqoXoGoiv/WY9pasl6OuRjvTlIywLL+QyfjhUKU+jCSkQWeMvi+KYd1rDl7DABeDM0CDi+zkOOd/AD/MNOyfyFnDxJJlCPfgw3udVGuJ2VuYSlsgQYekguJp/lU59sZ/S1eqWopMaTpelkpjeGmod1t17bypJHfmL5sj0Zpg8t7g7V+JfRDg76U0/K/FOPFfqlA1mkekWGFmXCY6Ia8gGY+v10wNmZ8zHGqhzxHB6rKyNyjq+hdiX/HbxCvYnQR6+OaRX+pMZTZGrbj16x+o5JKfyC4Y3wsSHc/736Um3EHrKj/L/NL2zjB2aw7UnUpKcHtmLAOlflfcJUYfJFNRK3Q/vqLroJvAcV7AdUhqD2oJmBpRmt66Tda3LECLli8QAKtmUNUUQgit/R+ut47g6kF0cIKA8GQUMOpl+xk434O4UX5m6FnBr3wiAOP0H3txba5w/OZf+KmbYjWEcw56wp3Znq0wmG0Z2fTWg6x7LumeITdmVYldk8nG49PBKUfEjTjAmVZUvDnBn5qbkb0G15TUvta9Cc5I5jtlV9ZPF/Lyl5ECsT/7qscAfMjE9FnWVwbOys9Sat12+Jls2ozxNj2/vYQNkIvgwVn8aXwJhpkraGo//KeMhJw==",
        "price": "306",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T14:53:00",
        "buffered_depart_time": "2018-06-18T13:23:00",
        "arrive_time": "2018-06-18T23:15:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T23:45:00",
        "buffered_depart_time": "2018-06-18T23:45:00",
        "arrive_time": "2018-06-19T00:09:00"
      }
    ]
  },
  {
    "total_price": 434.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 143,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T16:44:00",
        "buffered_depart_time": "2018-06-18T16:44:00",
        "arrive_time": "2018-06-18T16:50:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "30th St Station, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T17:10:00",
        "buffered_depart_time": "2018-06-18T16:50:00",
        "arrive_time": "2018-06-18T19:20:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T20:12:00",
        "buffered_depart_time": "2018-06-18T20:12:00",
        "arrive_time": "2018-06-18T21:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=4001122827516499_0%7C3982431552169857_0%7C3982431552169857_1&price=266&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPyTEy6XbRnhA5yvVmvorIVcqhQQS+ax8fObRTBjno04vq5h7aicz+gjx8tCnIVIJh09NAPOUxGpOh9k79AK6bGfhFvj69RhhtEyIENtvLahEpBm373rdrOgApvs6YHmabANZ3zhGs+7uOIQtKn4yHSH43L5vQ3rrIFpB0Q7vqDvSgiE6EfkHkiyjJuEpYTDq8s4IdpFcIOROuKIZTRgn0hspiEaK4qP/t/kP1+cyPbb8UA63kop+pjn3sn7XM+05fq4uzx5oc14LnweCoE7SfwCP71ZGk6TL3KQSX4EPSszZsOMcVjPJM39jd8TwmpMGsmuFULhDEZr0mTjGYT5TSnXjZQKHn3p22VJaKZCEQQz75L7lZaCa+dpAduUUkfxJTW3U1dKQM0mLj5Y9UhThuWWcwwN9rzNSJMC3obX9FBnT7ZYODJq2p5XiTatK6aNiME7VjrCFWyU1KNT3IsX79UlBoC1OT/ZGPzhqh/lgI6pltNJWDb9kvQcqq/kvUAERTYJJl43b0Bu+T0fNQQkDmM7GoPhO8OhZoiOi6SQBi4+glKof9r6cy3dZke1c/4nNzjzYg6mKsnnk28uQfb0at2kbdTaI83Mhgu15qQAfuk3nWAqSFVBpNkr6aBXXgKVmL6bvqF/bMdhCG9/KrOi8Bj2+qkwHTk15hA1IOzXoD9N0guwpgSafWiUwp5LjdGnZtDHpMA/Feypu6aeZ3991pzJQXqAejXwUzV6JpDA9wETyZdOqrhzwEEMm+ZOU5ajgq",
        "price": "315",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T22:45:00",
        "buffered_depart_time": "2018-06-18T21:15:00",
        "arrive_time": "2018-06-19T09:43:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-19T10:13:00",
        "buffered_depart_time": "2018-06-19T10:13:00",
        "arrive_time": "2018-06-19T10:37:00"
      }
    ]
  },
  {
    "total_price": 324.5,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T04:50:00",
        "buffered_depart_time": "2018-06-20T04:50:00",
        "arrive_time": "2018-06-20T05:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=4008819685527143_0%7C4008819685527143_1%7C3742737859286809_0&price=214&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPjoUDnBsV+8uftjDbJxyY5IBPEOiEo8mHQXluz8hkRli01WLCsa/jvg/MAIcwq3op+LPOUPUVH/QWZ26nJ4U24nzJvQFJZ6eIXh12dT/+EEeiZxFeD28ei+ZwIjMnT351Ia6vhguGB8/uhyYCnHMcVNrDrSPXaDmUrsSj3+nNnHi07slYhs5jhSTtZAKkAkkDzmUwJTBwEuQ//H/u2DXQn4svpqa0GQumPbs1JoZUwq6sAI8eoz6DrUIiErevVfPnU5pK4NgP8ne2hYKVPZgRKobOGjQyvjzgv+iCsO08b26zK5rbWX+zu2oluwEVdCUTvbhkFof38kqpAaVwYKU7GvPSp0sPRhqVq2oituPuos2WwBd8uKVZLsaAn3waR2e7gavFB44ltXL78vjOtFWUnUzmhHzFZ9YG16gDx9XgpG+g3dtiCkG0M0jWaRchWMFxm9v9Ig7u6Wmhzq4EVlA1GKzgwb9rKRwrxiV/nHFy0EG63/0SahBW+e0oHNnh7mEJYFqBdTqTb3I46UFUHS0nrNv81sLw4QXsTz+petIVNbXwAaVaA3kNcS+Zqc6m8pDWbUGLOfmxKP3z1AJD2r3HHpEfteYOG0FevWyrqfJjfUTCLpqeLUTF7mfiwMkFF8/6aNegyFWILLp6CdjmaRiDYkgZ2FJ+8MQuQL5VyaVvK//BdfMvzU4PBBlgIoG7mCnlhOsVEeA7J+D/SoIDngG7BfQ3CGZiKZt1oN+zqQ03sO2xTTyK5+5pwxRaA0CqAfBX7rvQM2FWjaAifWfS/wzZIw==",
        "price": "253",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T06:45:00",
        "buffered_depart_time": "2018-06-20T05:15:00",
        "arrive_time": "2018-06-20T17:45:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "40.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T18:15:00",
        "buffered_depart_time": "2018-06-20T18:15:00",
        "arrive_time": "2018-06-20T18:45:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "30th St Station, Philadelphia, PA",
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": "34th St b/t 11th Ave and 12th Ave, New York, NY",
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "9.0",
        "name": "megabus",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T21:20:00",
        "buffered_depart_time": "2018-06-20T21:00:00",
        "arrive_time": "2018-06-20T23:30:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T23:40:00",
        "buffered_depart_time": "2018-06-20T23:40:00",
        "arrive_time": "2018-06-20T23:46:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share:bus:ride-share",
    "id": 172,
    "departing_segments": []
  },
  {
    "total_price": 151.0,
    "returning_segments": [],
    "permutation": "ride-share:flight:ride-share",
    "id": 99,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.241111",
            "to_lat": "39.871944",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "19.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T15:12:00",
        "buffered_depart_time": "2018-06-18T15:12:00",
        "arrive_time": "2018-06-18T15:30:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "PHL Airport, Philadelphia",
            "from_lon": "-75.241111",
            "from_lat": "39.871944"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=PHL&to=OMA&departure=18-06-2018&flightsId=3807608768334232_0&price=99&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPvD5wmIkaiDkazhcdCySwSPfEYP5DawaDwc2e6PKNJzfukOy/sO4FQuWxd4ewReQ5xTbsZehf5MHLXew0hSjq39Rm1rvUiNdCmP7CVcdSKViDeDFTDMUu52+RAi9n2QDfsulfWWhDDdTFqQsc+biGh+55Inm8K5DY9eIxjqVQ2Gj0iJnYWET8dOMGQ7C63eRC6/uYfBR7uOovvScX3GEy61i+QBRDhd3sT4ChozFfSMNxEeKvOVkwHJ2MlFpHS1R/m2WLQ3qsjjk/YgX8xhXE2uOl3WwG5OQcvPYog2ZaLaISjNZcRAY+TGOAZ8ooj/U0E0RL5OZqu0wB1mz2sdjBztppr1iQ9t/K6iloZN8XUoH5hVvelkPk4A+FsJ/ZU9LMhnFkatYuZAPIdq5pKjR1ICf/bk3H0sk+IvxJcFHLbCnDqKR3r4qB2ofelrCSpVQ05ZG7cXiGn7VcdtIFj8MBaXeo7o+phccenWvyDi/xMkLPR/nWAbShjR5+txiACwX0izQdIgZ34kJRvrOghOUUQjtay7GdPbVzaTxV7xnxHLKBonBbv32v6HA4oGUDxTL9zny1pGSXle9nMkCFOCiBXcNqZSAwhBeoV0kuaG33pSsT+U4pAxPANJjjLFA1sE563P0al5XtrUfIUEy0hTtQgA==",
        "price": "117",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T17:00:00",
        "buffered_depart_time": "2018-06-18T15:30:00",
        "arrive_time": "2018-06-18T19:17:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T19:47:00",
        "buffered_depart_time": "2018-06-18T19:47:00",
        "arrive_time": "2018-06-18T20:11:00"
      }
    ]
  },
  {
    "total_price": 360.5,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T16:10:00",
        "buffered_depart_time": "2018-06-20T16:10:00",
        "arrive_time": "2018-06-20T16:35:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "EWR Airport, New York City",
            "to_lon": "-74.168611",
            "to_lat": "40.6925",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=EWR&departure=20-06-2018&flightsId=3602000628856350_0&price=193&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPflSDCeEN0+9xw2cm7ws5gj6F8eJT4yfG7vLkIQ7Btq7GfbJWRsPKMw0hjeiIvYSbmjN3w7Ng5azMuLkdE6LfVzC7jF2PQrqhMfHPiGkCgqCKUIs5pxwzy4XLzklrSOkeQBdSqGH32C4dvsn8D6wiCxQWHK+l1GLrCceEtVu673fHcLHrxpqzJvpqs24MqmdD6+iGNWKYMFhFkXf+Lw0iXDnzd2IP64KWogNRYW2CbPPxlfU9lOuFa1DEvwM+tRloq8NmYmyd/0Znedhugm4eCojePJqviaVztHCh4CmC9+QLbPO5fhanWA1hYScqkXc5KfstJGBpT4045iF6KtmVaighmvGrX2UmQUsygSQ9GaFLM2v38eM2ZtgCgfdCPMHoqYMZWFQ4O5/DESH1qydOSmbIkuIazjY3TE0itzvqWYYI1Jc13gatrMkTmKqhmpAJ2LSd1W5tqoShkPqvOER6Dk0iO4q/HD13TLtgYpXRx7KZB8x6zFVAtUqrGSi40S1LWSUIWHMlqhuWGTMJchhTTH5e6T4AESQrYaNP7U3obTFiKkp/yebqkTnDbeX3uPCOzWT+Dp95HHdjBwewGtvl5mJR7rd1lQRFP1lR1QVIOQtPbwuxZfjpeB0zUTG9AHTe/6N+vYmUhibKYTFZaojFGg==",
        "price": "229",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T18:05:00",
        "buffered_depart_time": "2018-06-20T16:35:00",
        "arrive_time": "2018-06-20T21:54:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-74.168611",
            "from_lat": "40.6925"
          }
        },
        "purchase_link": null,
        "price": "115.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T22:24:00",
        "buffered_depart_time": "2018-06-20T22:24:00",
        "arrive_time": "2018-06-21T00:09:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share",
    "id": 151,
    "departing_segments": []
  },
  {
    "total_price": 316.5,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T04:50:00",
        "buffered_depart_time": "2018-06-20T04:50:00",
        "arrive_time": "2018-06-20T05:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=4008819685527143_0%7C4008819685527143_1%7C3742737859286809_0&price=214&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPjoUDnBsV+8uftjDbJxyY5IBPEOiEo8mHQXluz8hkRli01WLCsa/jvg/MAIcwq3op+LPOUPUVH/QWZ26nJ4U24nzJvQFJZ6eIXh12dT/+EEeiZxFeD28ei+ZwIjMnT351Ia6vhguGB8/uhyYCnHMcVNrDrSPXaDmUrsSj3+nNnHi07slYhs5jhSTtZAKkAkkDzmUwJTBwEuQ//H/u2DXQn4svpqa0GQumPbs1JoZUwq6sAI8eoz6DrUIiErevVfPnU5pK4NgP8ne2hYKVPZgRKobOGjQyvjzgv+iCsO08b26zK5rbWX+zu2oluwEVdCUTvbhkFof38kqpAaVwYKU7GvPSp0sPRhqVq2oituPuos2WwBd8uKVZLsaAn3waR2e7gavFB44ltXL78vjOtFWUnUzmhHzFZ9YG16gDx9XgpG+g3dtiCkG0M0jWaRchWMFxm9v9Ig7u6Wmhzq4EVlA1GKzgwb9rKRwrxiV/nHFy0EG63/0SahBW+e0oHNnh7mEJYFqBdTqTb3I46UFUHS0nrNv81sLw4QXsTz+petIVNbXwAaVaA3kNcS+Zqc6m8pDWbUGLOfmxKP3z1AJD2r3HHpEfteYOG0FevWyrqfJjfUTCLpqeLUTF7mfiwMkFF8/6aNegyFWILLp6CdjmaRiDYkgZ2FJ+8MQuQL5VyaVvK//BdfMvzU4PBBlgIoG7mCnlhOsVEeA7J+D/SoIDngG7BfQ3CGZiKZt1oN+zqQ03sO2xTTyK5+5pwxRaA0CqAfBX7rvQM2FWjaAifWfS/wzZIw==",
        "price": "253",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T06:45:00",
        "buffered_depart_time": "2018-06-20T05:15:00",
        "arrive_time": "2018-06-20T17:45:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "40.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T18:15:00",
        "buffered_depart_time": "2018-06-20T18:15:00",
        "arrive_time": "2018-06-20T18:45:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "Independence Hall Visitors Center, Philadelphia, PA",
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": "34th St b/t 11th Ave and 12th Ave, New York, NY",
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "1.0",
        "name": "megabus",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T23:20:00",
        "buffered_depart_time": "2018-06-20T23:00:00",
        "arrive_time": "2018-06-21T01:20:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-21T01:30:00",
        "buffered_depart_time": "2018-06-21T01:30:00",
        "arrive_time": "2018-06-21T01:36:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share:bus:ride-share",
    "id": 173,
    "departing_segments": []
  },
  {
    "total_price": 312.5,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T04:05:00",
        "buffered_depart_time": "2018-06-20T04:05:00",
        "arrive_time": "2018-06-20T04:30:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=3522835704288553_0%7C3558020294474371_0&price=210&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPv0KvDn6aPXv/5v9h+zKCcbu13e8YbaoOuO9VmF5FyN9a0MD7UdSZmCHohwXaF1xnr9QsbppOtU2slJWlujwbbFNc5vpNRcVRyHHs9FG0xf+iw5GN2EBc/b5rP/V2V9fU7EmnK0zYHQHgc7s3aih+0bPf7SO1wy8dsl9h8PQ+3m0vbF+Mm6Z8YWiZB+1bTSLm7dvxh4Kiie2n/nLwreB7S84FweAAH5jBxNO3ubykr0LoRm7+D/7oAsBJhWydpg4x0oYfOpAzLRew8tYIfT1G80oHID9dkhwsoTj+izzRkjr7m6HXVX11+zf87wxPPXYfIwKUf6CzMt+yH1KsDcfwOc2OWLQwsE/pY7tZBIU7oSERZ3ibs8lD3IIvSAqEcBmXQERcxYaU4idpwp44UfQjhpqZDBcMuRdnI8p1hes2iLyCpgrQuYipXBH8RA4QqdpzUehu31uGLKHzcAOxoCY/JyUtJqq2S1/nh4lI7Zn2sc6h4bW7cYItQ3QdHN6+cAjpatC509pbz6mbRpDHvlUxNOgBsukQVe6/cDJ9x0GO1QIz1jS6NZKRHB8HDcg3vtgHX8dwhnTOaTVeqCTe6TsyWqNnw6nC3FusReNirsyp61+qybAD5YWm5a02Ed855sIlf+q2X6rGFTFJSGNifgv8gTg57VOi3cgmWMGoZyYda5LVJzpxb0vvo5cyZ67N7FRZ",
        "price": "249",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T06:00:00",
        "buffered_depart_time": "2018-06-20T04:30:00",
        "arrive_time": "2018-06-20T17:00:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "40.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T17:30:00",
        "buffered_depart_time": "2018-06-20T17:30:00",
        "arrive_time": "2018-06-20T18:00:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "Independence Hall Visitors Center, Philadelphia, PA",
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": "34th St b/t 11th Ave and 12th Ave, New York, NY",
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "1.0",
        "name": "megabus",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T23:20:00",
        "buffered_depart_time": "2018-06-20T23:00:00",
        "arrive_time": "2018-06-21T01:20:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-21T01:30:00",
        "buffered_depart_time": "2018-06-21T01:30:00",
        "arrive_time": "2018-06-21T01:36:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share:bus:ride-share",
    "id": 167,
    "departing_segments": []
  },
  {
    "total_price": 541.99,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.94059",
            "to_lat": "41.26069",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "6.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T11:41:00",
        "buffered_depart_time": "2018-06-20T11:41:00",
        "arrive_time": "2018-06-20T11:45:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "Eastbound side of Cherry Street, between 7th and 8th Streets, Des Moines, IA",
            "to_lon": "-93.62697",
            "to_lat": "41.58329",
            "from_string": "Crossroads Mall - N 72nd St between Dodge St and Cass St, Omaha, NE",
            "from_lon": "-95.94059",
            "from_lat": "41.26069"
          }
        },
        "purchase_link": null,
        "price": "19.99",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T12:05:00",
        "buffered_depart_time": "2018-06-20T11:45:00",
        "arrive_time": "2018-06-20T14:45:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-93.657778",
            "to_lat": "41.534167",
            "from_string": null,
            "from_lon": "-93.62697",
            "from_lat": "41.58329"
          }
        },
        "purchase_link": null,
        "price": "9.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T18:16:00",
        "buffered_depart_time": "2018-06-20T18:16:00",
        "arrive_time": "2018-06-20T18:29:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "JFK Airport, New York City",
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": "DSM Airport, Des Moines",
            "from_lon": "-93.657778",
            "from_lat": "41.534167"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=DSM&to=JFK&departure=20-06-2018&flightsId=3651478258259288_0%7C4013217459739399_0&price=195&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPZ1F/IF+TnYhSMNQyK6ni2Xc9DYRdqY3EsEBUcc7Vl8Lulbh9rRUTjO4t3LUi+2qJHoteP3D/ZH97MEHZyXo11sBFzSaMGARYvLwqWl4jZAz2QRjC+vkcEp1yWH+OAZ3DkzRBKxS0+kAQI8Si6RRPgvGHBXVFPOXBffiL/cKduUvEy4/FvPCdCl7w9uWVaWYRq5lPrk+8Y2Whyxx/QBOGqOQidhxsbUjAXSxVrbygcc4/T5r7NFHHv0TE15S6LIFagsW4GcWyfvyF8coRaS8VM3l7u7AT0bllTlX5aEe+I9kDibUHOjn2LYXwc9ugeplSLrhTq9XTOnUzdAOyZmIPMaxyE1hWav0cdBfuMA6/X4QdCEo8guh6ACZWuctKeofRA71xrgMkNXOqPDk6iuGpOfuX9gOU1EohjTcv/yZz6f7rdk0KOfe06OeBStM16Bak0LB/j4DAnD44+oLav2fKdSXWzMJFswMk+56QXRTo3ARw5ja9iKEp1PjsH6ovwSEq1qw4SObhWILPgSTCv5flD+WK4XLVIVxGuHDFZae2aJ9SlT/Gi4E2zjfkahhJkBewBMSfCeRCp7bnJyxoFXPtnEYPOL+3TMqfgcGMWRdKrA4yUxRHim/H9Gzpk0Asg0kWavfKWq4XLaAb9XDMCtK3mz7F7nEhW0ZKYP57IklRj2o793q4Br87OujMoS2sL2q2",
        "price": "231",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T19:59:00",
        "buffered_depart_time": "2018-06-20T18:29:00",
        "arrive_time": "2018-06-21T05:45:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": null,
        "price": "275.5",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-21T06:15:00",
        "buffered_depart_time": "2018-06-21T06:15:00",
        "arrive_time": "2018-06-21T08:04:00"
      }
    ],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 188,
    "departing_segments": []
  },
  {
    "total_price": 480.0,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T04:50:00",
        "buffered_depart_time": "2018-06-20T04:50:00",
        "arrive_time": "2018-06-20T05:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=4035207816796086_0%7C4035207816796086_1%7C3598702163596938_0&price=216&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPhMhiXGhmctYJmBJTQXuLUj1sQLf00gX21TRZqyUR0SpvoV+yG9wrU9B5Ar6P6oUSiBCHuRO3/5RF54tI0igB+D/9PpPqvFzSqMMttDq1By25DXR4EbrRJ5At+3Sxjkxf5XhqTithh3G0xju8Ngd88f/JChsa6pYQfzw7icdXFq2qRoPJ/i82wQVzu2GWVdMh8qoSukJYaBg1h8q+AjySVqhq1s+weIHRM0pogdo0otFdXpRoKXTQ9spC2R6j6YLgAetJ2kzRUquOtrnIKcJyZ4qy1rVnNgdQodVrOMUQ93tjHyJL6Zu55YMm6O2L/gE55zxzcHqQzisea7szJgx9Njf21mfe7SL3qZaHFnHjTvlq95AYGeYS48v8DFJDqrAafK74Txb09kHJEsETqVu/p0n87b4Wd4ykNOZvWZRaI7OM1tvlJ9j7sz8SBlEGee2gpXbxDwlkMd6Zz5uENZPlyjDEO1wA0Xv/PG5whhV8O+QlvhU80i9LP6EH/8vN8OF1ILboTE9uYZmZUDAEn7rXLqHCs4XZHJdG7IXAF5ho36z+pPddxqLgTGSbRMq51Pp7mf/NMefd5zBWVJPRAVZ1urs289rEXp5R+MlwUfieyNLSUFiOYzaveWhJ/lskXa+Cq1kosheYtYVmDCujBFL8JU2PzKV6JdcoiIzKzXiDCpp7gjAGQ9F0WGQF5zSotxjzkGXjwXBVn2VwX4mePXgik74O7hfKBXrS2uaGkiS/chHmiEGB6stl3l+2nGu/8Mgy",
        "price": "256",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T06:45:00",
        "buffered_depart_time": "2018-06-20T05:15:00",
        "arrive_time": "2018-06-20T15:40:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "208.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T16:10:00",
        "buffered_depart_time": "2018-06-20T16:10:00",
        "arrive_time": "2018-06-20T18:01:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share",
    "id": 156,
    "departing_segments": []
  },
  {
    "total_price": 403.5,
    "returning_segments": [],
    "permutation": "ride-share:flight:ride-share",
    "id": 101,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-74.577222",
            "to_lat": "39.4575",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T10:37:00",
        "buffered_depart_time": "2018-06-18T10:37:00",
        "arrive_time": "2018-06-18T11:52:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "ACY Airport, Atlantic City",
            "from_lon": "-74.577222",
            "from_lat": "39.4575"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=ACY&to=OMA&departure=18-06-2018&flightsId=3599801544787963_0%7C3531631835702220_0&price=250&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObP8IOMNeUpI+nr+FVQDC3eDa0mTP/C944ULjl5tqGpThxfGvq0fZQm4Nikn5xOJ1cI9iZdKl4iIDHPJmqLXsYSXC7eMvxI4EcDyVhXZVOWAAdM43we9VeA1VUFcSSi73RBYWRK/BQkc5uVnet2Etp9At6OM3SduNwaewxcotT4HPU2qb/KGmptYbb9X8OE1n15Y7BQnUgmCq5SNW39vBK5j3mwkxHeS+ds0fP91uyCH5hginazf0dQx6kyll3unEwHFqcntlt+8M8bpuSwnSnPeRKOYuNvnR6o1b1GN989oPeG7+X/mToHe+8B41VsXMZvoKzxsecdE8gU50eBOqvJCJ4sCjIjOepyC1PxE3A06kVnM5ZkdvSItHggceQkfnQwGrUVjCQ1nqYDdtTQD+RtgaKmiLL4xqdr9Bq5D6X2G1PnqHP1andbftenSW6stXrVMwNrN7vXFIzZGUd25n5V35p01z4pCJCeOLUYJPhCp6Z/D/PhtdH4DK05Zd+k8dCkLzsiFWpGiEvyRLgk1ThhvMoqTomrr929Vk2ditmdmxfr88OB6TVfc0k0+x7qssRWXHwoEOIK8ZA11uMAsh0jN8v8pJs0hA3YWBCxb6XwlZw+MoxFFQ7OIqw8xdglX727ios52Gef/iBOEZYQNE0Q/dItLrjXRkh3pRoPsqF+p90VOZdZg/cvJL/Q5GToK6LK",
        "price": "296",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T13:22:00",
        "buffered_depart_time": "2018-06-18T11:52:00",
        "arrive_time": "2018-06-18T20:39:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T21:09:00",
        "buffered_depart_time": "2018-06-18T21:09:00",
        "arrive_time": "2018-06-18T21:33:00"
      }
    ]
  },
  {
    "total_price": 434.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 144,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T16:54:00",
        "buffered_depart_time": "2018-06-18T16:54:00",
        "arrive_time": "2018-06-18T17:00:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "Independence Hall Visitors Center, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T17:20:00",
        "buffered_depart_time": "2018-06-18T17:00:00",
        "arrive_time": "2018-06-18T19:20:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T20:12:00",
        "buffered_depart_time": "2018-06-18T20:12:00",
        "arrive_time": "2018-06-18T21:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=4001122827516499_0%7C3982431552169857_0%7C3982431552169857_1&price=266&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPyTEy6XbRnhA5yvVmvorIVcqhQQS+ax8fObRTBjno04vq5h7aicz+gjx8tCnIVIJh09NAPOUxGpOh9k79AK6bGfhFvj69RhhtEyIENtvLahEpBm373rdrOgApvs6YHmabANZ3zhGs+7uOIQtKn4yHSH43L5vQ3rrIFpB0Q7vqDvSgiE6EfkHkiyjJuEpYTDq8s4IdpFcIOROuKIZTRgn0hspiEaK4qP/t/kP1+cyPbb8UA63kop+pjn3sn7XM+05fq4uzx5oc14LnweCoE7SfwCP71ZGk6TL3KQSX4EPSszZsOMcVjPJM39jd8TwmpMGsmuFULhDEZr0mTjGYT5TSnXjZQKHn3p22VJaKZCEQQz75L7lZaCa+dpAduUUkfxJTW3U1dKQM0mLj5Y9UhThuWWcwwN9rzNSJMC3obX9FBnT7ZYODJq2p5XiTatK6aNiME7VjrCFWyU1KNT3IsX79UlBoC1OT/ZGPzhqh/lgI6pltNJWDb9kvQcqq/kvUAERTYJJl43b0Bu+T0fNQQkDmM7GoPhO8OhZoiOi6SQBi4+glKof9r6cy3dZke1c/4nNzjzYg6mKsnnk28uQfb0at2kbdTaI83Mhgu15qQAfuk3nWAqSFVBpNkr6aBXXgKVmL6bvqF/bMdhCG9/KrOi8Bj2+qkwHTk15hA1IOzXoD9N0guwpgSafWiUwp5LjdGnZtDHpMA/Feypu6aeZ3991pzJQXqAejXwUzV6JpDA9wETyZdOqrhzwEEMm+ZOU5ajgq",
        "price": "315",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T22:45:00",
        "buffered_depart_time": "2018-06-18T21:15:00",
        "arrive_time": "2018-06-19T09:43:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-19T10:13:00",
        "buffered_depart_time": "2018-06-19T10:13:00",
        "arrive_time": "2018-06-19T10:37:00"
      }
    ]
  },
  {
    "total_price": 425.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 110,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T05:34:00",
        "buffered_depart_time": "2018-06-18T05:34:00",
        "arrive_time": "2018-06-18T05:40:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "30th St Station, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T06:00:00",
        "buffered_depart_time": "2018-06-18T05:40:00",
        "arrive_time": "2018-06-18T08:10:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T12:20:00",
        "buffered_depart_time": "2018-06-18T12:20:00",
        "arrive_time": "2018-06-18T13:23:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=3488751098027710_0%7C3917560245168350_0%7C3917560245168350_1&price=259&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPQ/zjLVOCowaBhF3iXk2bEn07Xr+8wLkggi326weN87Ro+JAqpgcdJfVoCY0gNDJ4fB0J4RufmcjOaCwW3AbMCo8XFkKDbrB0oIQwA3e/aW6K8Ys3/ku9d1vxwmLon+yvmR6rUcdTfTK8EGievETfkPgySpkUB8YZqoXoGoiv/WY9pasl6OuRjvTlIywLL+QyfjhUKU+jCSkQWeMvi+KYd1rDl7DABeDM0CDi+zkOOd/AD/MNOyfyFnDxJJlCPfgw3udVGuJ2VuYSlsgQYekguJp/lU59sZ/S1eqWopMaTpelkpjeGmod1t17bypJHfmL5sj0Zpg8t7g7V+JfRDg76U0/K/FOPFfqlA1mkekWGFmXCY6Ia8gGY+v10wNmZ8zHGqhzxHB6rKyNyjq+hdiX/HbxCvYnQR6+OaRX+pMZTZGrbj16x+o5JKfyC4Y3wsSHc/736Um3EHrKj/L/NL2zjB2aw7UnUpKcHtmLAOlflfcJUYfJFNRK3Q/vqLroJvAcV7AdUhqD2oJmBpRmt66Tda3LECLli8QAKtmUNUUQgit/R+ut47g6kF0cIKA8GQUMOpl+xk434O4UX5m6FnBr3wiAOP0H3txba5w/OZf+KmbYjWEcw56wp3Znq0wmG0Z2fTWg6x7LumeITdmVYldk8nG49PBKUfEjTjAmVZUvDnBn5qbkb0G15TUvta9Cc5I5jtlV9ZPF/Lyl5ECsT/7qscAfMjE9FnWVwbOys9Sat12+Jls2ozxNj2/vYQNkIvgwVn8aXwJhpkraGo//KeMhJw==",
        "price": "306",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T14:53:00",
        "buffered_depart_time": "2018-06-18T13:23:00",
        "arrive_time": "2018-06-18T23:15:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T23:45:00",
        "buffered_depart_time": "2018-06-18T23:45:00",
        "arrive_time": "2018-06-19T00:09:00"
      }
    ]
  },
  {
    "total_price": 434.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 139,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T15:14:00",
        "buffered_depart_time": "2018-06-18T15:14:00",
        "arrive_time": "2018-06-18T15:20:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "30th St Station, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T15:40:00",
        "buffered_depart_time": "2018-06-18T15:20:00",
        "arrive_time": "2018-06-18T17:50:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T20:12:00",
        "buffered_depart_time": "2018-06-18T20:12:00",
        "arrive_time": "2018-06-18T21:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=4001122827516499_0%7C3982431552169857_0%7C3982431552169857_1&price=266&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPyTEy6XbRnhA5yvVmvorIVcqhQQS+ax8fObRTBjno04vq5h7aicz+gjx8tCnIVIJh09NAPOUxGpOh9k79AK6bGfhFvj69RhhtEyIENtvLahEpBm373rdrOgApvs6YHmabANZ3zhGs+7uOIQtKn4yHSH43L5vQ3rrIFpB0Q7vqDvSgiE6EfkHkiyjJuEpYTDq8s4IdpFcIOROuKIZTRgn0hspiEaK4qP/t/kP1+cyPbb8UA63kop+pjn3sn7XM+05fq4uzx5oc14LnweCoE7SfwCP71ZGk6TL3KQSX4EPSszZsOMcVjPJM39jd8TwmpMGsmuFULhDEZr0mTjGYT5TSnXjZQKHn3p22VJaKZCEQQz75L7lZaCa+dpAduUUkfxJTW3U1dKQM0mLj5Y9UhThuWWcwwN9rzNSJMC3obX9FBnT7ZYODJq2p5XiTatK6aNiME7VjrCFWyU1KNT3IsX79UlBoC1OT/ZGPzhqh/lgI6pltNJWDb9kvQcqq/kvUAERTYJJl43b0Bu+T0fNQQkDmM7GoPhO8OhZoiOi6SQBi4+glKof9r6cy3dZke1c/4nNzjzYg6mKsnnk28uQfb0at2kbdTaI83Mhgu15qQAfuk3nWAqSFVBpNkr6aBXXgKVmL6bvqF/bMdhCG9/KrOi8Bj2+qkwHTk15hA1IOzXoD9N0guwpgSafWiUwp5LjdGnZtDHpMA/Feypu6aeZ3991pzJQXqAejXwUzV6JpDA9wETyZdOqrhzwEEMm+ZOU5ajgq",
        "price": "315",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T22:45:00",
        "buffered_depart_time": "2018-06-18T21:15:00",
        "arrive_time": "2018-06-19T09:43:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-19T10:13:00",
        "buffered_depart_time": "2018-06-19T10:13:00",
        "arrive_time": "2018-06-19T10:37:00"
      }
    ]
  },
  {
    "total_price": 425.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 114,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T07:34:00",
        "buffered_depart_time": "2018-06-18T07:34:00",
        "arrive_time": "2018-06-18T07:40:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "30th St Station, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T08:00:00",
        "buffered_depart_time": "2018-06-18T07:40:00",
        "arrive_time": "2018-06-18T10:10:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T12:20:00",
        "buffered_depart_time": "2018-06-18T12:20:00",
        "arrive_time": "2018-06-18T13:23:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=3488751098027710_0%7C3917560245168350_0%7C3917560245168350_1&price=259&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPQ/zjLVOCowaBhF3iXk2bEn07Xr+8wLkggi326weN87Ro+JAqpgcdJfVoCY0gNDJ4fB0J4RufmcjOaCwW3AbMCo8XFkKDbrB0oIQwA3e/aW6K8Ys3/ku9d1vxwmLon+yvmR6rUcdTfTK8EGievETfkPgySpkUB8YZqoXoGoiv/WY9pasl6OuRjvTlIywLL+QyfjhUKU+jCSkQWeMvi+KYd1rDl7DABeDM0CDi+zkOOd/AD/MNOyfyFnDxJJlCPfgw3udVGuJ2VuYSlsgQYekguJp/lU59sZ/S1eqWopMaTpelkpjeGmod1t17bypJHfmL5sj0Zpg8t7g7V+JfRDg76U0/K/FOPFfqlA1mkekWGFmXCY6Ia8gGY+v10wNmZ8zHGqhzxHB6rKyNyjq+hdiX/HbxCvYnQR6+OaRX+pMZTZGrbj16x+o5JKfyC4Y3wsSHc/736Um3EHrKj/L/NL2zjB2aw7UnUpKcHtmLAOlflfcJUYfJFNRK3Q/vqLroJvAcV7AdUhqD2oJmBpRmt66Tda3LECLli8QAKtmUNUUQgit/R+ut47g6kF0cIKA8GQUMOpl+xk434O4UX5m6FnBr3wiAOP0H3txba5w/OZf+KmbYjWEcw56wp3Znq0wmG0Z2fTWg6x7LumeITdmVYldk8nG49PBKUfEjTjAmVZUvDnBn5qbkb0G15TUvta9Cc5I5jtlV9ZPF/Lyl5ECsT/7qscAfMjE9FnWVwbOys9Sat12+Jls2ozxNj2/vYQNkIvgwVn8aXwJhpkraGo//KeMhJw==",
        "price": "306",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T14:53:00",
        "buffered_depart_time": "2018-06-18T13:23:00",
        "arrive_time": "2018-06-18T23:15:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T23:45:00",
        "buffered_depart_time": "2018-06-18T23:45:00",
        "arrive_time": "2018-06-19T00:09:00"
      }
    ]
  },
  {
    "total_price": 434.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 128,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T08:44:00",
        "buffered_depart_time": "2018-06-18T08:44:00",
        "arrive_time": "2018-06-18T08:50:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "Independence Hall Visitors Center, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T09:10:00",
        "buffered_depart_time": "2018-06-18T08:50:00",
        "arrive_time": "2018-06-18T11:10:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T20:12:00",
        "buffered_depart_time": "2018-06-18T20:12:00",
        "arrive_time": "2018-06-18T21:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=4001122827516499_0%7C3982431552169857_0%7C3982431552169857_1&price=266&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPyTEy6XbRnhA5yvVmvorIVcqhQQS+ax8fObRTBjno04vq5h7aicz+gjx8tCnIVIJh09NAPOUxGpOh9k79AK6bGfhFvj69RhhtEyIENtvLahEpBm373rdrOgApvs6YHmabANZ3zhGs+7uOIQtKn4yHSH43L5vQ3rrIFpB0Q7vqDvSgiE6EfkHkiyjJuEpYTDq8s4IdpFcIOROuKIZTRgn0hspiEaK4qP/t/kP1+cyPbb8UA63kop+pjn3sn7XM+05fq4uzx5oc14LnweCoE7SfwCP71ZGk6TL3KQSX4EPSszZsOMcVjPJM39jd8TwmpMGsmuFULhDEZr0mTjGYT5TSnXjZQKHn3p22VJaKZCEQQz75L7lZaCa+dpAduUUkfxJTW3U1dKQM0mLj5Y9UhThuWWcwwN9rzNSJMC3obX9FBnT7ZYODJq2p5XiTatK6aNiME7VjrCFWyU1KNT3IsX79UlBoC1OT/ZGPzhqh/lgI6pltNJWDb9kvQcqq/kvUAERTYJJl43b0Bu+T0fNQQkDmM7GoPhO8OhZoiOi6SQBi4+glKof9r6cy3dZke1c/4nNzjzYg6mKsnnk28uQfb0at2kbdTaI83Mhgu15qQAfuk3nWAqSFVBpNkr6aBXXgKVmL6bvqF/bMdhCG9/KrOi8Bj2+qkwHTk15hA1IOzXoD9N0guwpgSafWiUwp5LjdGnZtDHpMA/Feypu6aeZ3991pzJQXqAejXwUzV6JpDA9wETyZdOqrhzwEEMm+ZOU5ajgq",
        "price": "315",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T22:45:00",
        "buffered_depart_time": "2018-06-18T21:15:00",
        "arrive_time": "2018-06-19T09:43:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-19T10:13:00",
        "buffered_depart_time": "2018-06-19T10:13:00",
        "arrive_time": "2018-06-19T10:37:00"
      }
    ]
  },
  {
    "total_price": 425.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 116,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T08:34:00",
        "buffered_depart_time": "2018-06-18T08:34:00",
        "arrive_time": "2018-06-18T08:40:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "30th St Station, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T09:00:00",
        "buffered_depart_time": "2018-06-18T08:40:00",
        "arrive_time": "2018-06-18T11:10:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T12:20:00",
        "buffered_depart_time": "2018-06-18T12:20:00",
        "arrive_time": "2018-06-18T13:23:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=3488751098027710_0%7C3917560245168350_0%7C3917560245168350_1&price=259&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPQ/zjLVOCowaBhF3iXk2bEn07Xr+8wLkggi326weN87Ro+JAqpgcdJfVoCY0gNDJ4fB0J4RufmcjOaCwW3AbMCo8XFkKDbrB0oIQwA3e/aW6K8Ys3/ku9d1vxwmLon+yvmR6rUcdTfTK8EGievETfkPgySpkUB8YZqoXoGoiv/WY9pasl6OuRjvTlIywLL+QyfjhUKU+jCSkQWeMvi+KYd1rDl7DABeDM0CDi+zkOOd/AD/MNOyfyFnDxJJlCPfgw3udVGuJ2VuYSlsgQYekguJp/lU59sZ/S1eqWopMaTpelkpjeGmod1t17bypJHfmL5sj0Zpg8t7g7V+JfRDg76U0/K/FOPFfqlA1mkekWGFmXCY6Ia8gGY+v10wNmZ8zHGqhzxHB6rKyNyjq+hdiX/HbxCvYnQR6+OaRX+pMZTZGrbj16x+o5JKfyC4Y3wsSHc/736Um3EHrKj/L/NL2zjB2aw7UnUpKcHtmLAOlflfcJUYfJFNRK3Q/vqLroJvAcV7AdUhqD2oJmBpRmt66Tda3LECLli8QAKtmUNUUQgit/R+ut47g6kF0cIKA8GQUMOpl+xk434O4UX5m6FnBr3wiAOP0H3txba5w/OZf+KmbYjWEcw56wp3Znq0wmG0Z2fTWg6x7LumeITdmVYldk8nG49PBKUfEjTjAmVZUvDnBn5qbkb0G15TUvta9Cc5I5jtlV9ZPF/Lyl5ECsT/7qscAfMjE9FnWVwbOys9Sat12+Jls2ozxNj2/vYQNkIvgwVn8aXwJhpkraGo//KeMhJw==",
        "price": "306",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T14:53:00",
        "buffered_depart_time": "2018-06-18T13:23:00",
        "arrive_time": "2018-06-18T23:15:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T23:45:00",
        "buffered_depart_time": "2018-06-18T23:45:00",
        "arrive_time": "2018-06-19T00:09:00"
      }
    ]
  },
  {
    "total_price": 319.5,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T04:50:00",
        "buffered_depart_time": "2018-06-20T04:50:00",
        "arrive_time": "2018-06-20T05:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=4035207816796086_0%7C4035207816796086_1%7C3598702163596938_0&price=216&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPhMhiXGhmctYJmBJTQXuLUj1sQLf00gX21TRZqyUR0SpvoV+yG9wrU9B5Ar6P6oUSiBCHuRO3/5RF54tI0igB+D/9PpPqvFzSqMMttDq1By25DXR4EbrRJ5At+3SxjkxfGVzqyD53lYxIN4mL1WoeZa0LTFJNgqN1oJUYNOcEQfzunyKLZR80nevtXKfmer7OSOSETMIt6nbMsGRdiP+b5gC4xgVXmkMWdm7zhsRVkaQ7Y7Q2PLJXSGB9OqPmWPqgcsIgHkqojc7MtSGpz6WtM91o71URANaUm0cDFSHe1dlY8pW7IdR6UaBN2tym4ontittkIJj0fCvyIlylMxhI8eO7hSAjmBV54Ddz5SjJ52ChBgvlY5ZeF8tmHQDCreG2D+Hk7222ODayUJrJcg4TTU+f6VGG8DRRBw6/zShYveUqeP1JFTGMiNk3puTLhiQlVtjdRRd6LhjmC1noV/lUGaJ4f9XxMBZWEwbAHBrJDx/6BWFiJNQIEdmiK1DUmPCOBa5JHptKmrr+9Bo25MLMLDeHnzZgN0luToXOxc9wrI3DaZ4bo6m3gzr7J5whQzJvo21UQPBMNDwbtyriyoWyhIbpfWAWnYaTo6Xoaaftwx5Y8/OMtaCph4KSUcnRfEaU62Tuymambgc9GIYdigx/VpG7GVRJOzm8DeNeUJRbOjzB0s6k43u5AotV+WU1mLGtdKitnjQ4iwayW8khy6+mBqdGRv1C4z0CvPn0zrkf+cWxj2SqgX/WUgk4FYmE5Wwl",
        "price": "256",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T06:45:00",
        "buffered_depart_time": "2018-06-20T05:15:00",
        "arrive_time": "2018-06-20T15:40:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "40.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T16:10:00",
        "buffered_depart_time": "2018-06-20T16:10:00",
        "arrive_time": "2018-06-20T16:40:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "30th St Station, Philadelphia, PA",
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": "34th St b/t 11th Ave and 12th Ave, New York, NY",
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "1.0",
        "name": "megabus",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T23:20:00",
        "buffered_depart_time": "2018-06-20T23:00:00",
        "arrive_time": "2018-06-21T01:30:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-21T01:40:00",
        "buffered_depart_time": "2018-06-21T01:40:00",
        "arrive_time": "2018-06-21T01:46:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share:bus:ride-share",
    "id": 184,
    "departing_segments": []
  },
  {
    "total_price": 320.5,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T04:05:00",
        "buffered_depart_time": "2018-06-20T04:05:00",
        "arrive_time": "2018-06-20T04:30:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=3522835704288553_0%7C3558020294474371_0&price=210&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPv0KvDn6aPXv/5v9h+zKCcbu13e8YbaoOuO9VmF5FyN9a0MD7UdSZmCHohwXaF1xnr9QsbppOtU2slJWlujwbbFNc5vpNRcVRyHHs9FG0xf+iw5GN2EBc/b5rP/V2V9fU7EmnK0zYHQHgc7s3aih+0bPf7SO1wy8dsl9h8PQ+3m0vbF+Mm6Z8YWiZB+1bTSLm7dvxh4Kiie2n/nLwreB7S84FweAAH5jBxNO3ubykr0LoRm7+D/7oAsBJhWydpg4x0oYfOpAzLRew8tYIfT1G80oHID9dkhwsoTj+izzRkjr7m6HXVX11+zf87wxPPXYfIwKUf6CzMt+yH1KsDcfwOc2OWLQwsE/pY7tZBIU7oSERZ3ibs8lD3IIvSAqEcBmXQERcxYaU4idpwp44UfQjhpqZDBcMuRdnI8p1hes2iLyCpgrQuYipXBH8RA4QqdpzUehu31uGLKHzcAOxoCY/JyUtJqq2S1/nh4lI7Zn2sc6h4bW7cYItQ3QdHN6+cAjpatC509pbz6mbRpDHvlUxNOgBsukQVe6/cDJ9x0GO1QIz1jS6NZKRHB8HDcg3vtgHX8dwhnTOaTVeqCTe6TsyWqNnw6nC3FusReNirsyp61+qybAD5YWm5a02Ed855sIlf+q2X6rGFTFJSGNifgv8gTg57VOi3cgmWMGoZyYda5LVJzpxb0vvo5cyZ67N7FRZ",
        "price": "249",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T06:00:00",
        "buffered_depart_time": "2018-06-20T04:30:00",
        "arrive_time": "2018-06-20T17:00:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "40.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T17:30:00",
        "buffered_depart_time": "2018-06-20T17:30:00",
        "arrive_time": "2018-06-20T18:00:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "30th St Station, Philadelphia, PA",
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": "34th St b/t 11th Ave and 12th Ave, New York, NY",
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "9.0",
        "name": "megabus",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T19:05:00",
        "buffered_depart_time": "2018-06-20T18:45:00",
        "arrive_time": "2018-06-20T21:15:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T21:25:00",
        "buffered_depart_time": "2018-06-20T21:25:00",
        "arrive_time": "2018-06-20T21:31:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share:bus:ride-share",
    "id": 162,
    "departing_segments": []
  },
  {
    "total_price": 434.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 124,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T06:44:00",
        "buffered_depart_time": "2018-06-18T06:44:00",
        "arrive_time": "2018-06-18T06:50:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "Independence Hall Visitors Center, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T07:10:00",
        "buffered_depart_time": "2018-06-18T06:50:00",
        "arrive_time": "2018-06-18T09:10:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T20:12:00",
        "buffered_depart_time": "2018-06-18T20:12:00",
        "arrive_time": "2018-06-18T21:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=4001122827516499_0%7C3982431552169857_0%7C3982431552169857_1&price=266&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPyTEy6XbRnhA5yvVmvorIVcqhQQS+ax8fObRTBjno04vq5h7aicz+gjx8tCnIVIJh09NAPOUxGpOh9k79AK6bGfhFvj69RhhtEyIENtvLahEpBm373rdrOgApvs6YHmabANZ3zhGs+7uOIQtKn4yHSH43L5vQ3rrIFpB0Q7vqDvSgiE6EfkHkiyjJuEpYTDq8s4IdpFcIOROuKIZTRgn0hspiEaK4qP/t/kP1+cyPbb8UA63kop+pjn3sn7XM+05fq4uzx5oc14LnweCoE7SfwCP71ZGk6TL3KQSX4EPSszZsOMcVjPJM39jd8TwmpMGsmuFULhDEZr0mTjGYT5TSnXjZQKHn3p22VJaKZCEQQz75L7lZaCa+dpAduUUkfxJTW3U1dKQM0mLj5Y9UhThuWWcwwN9rzNSJMC3obX9FBnT7ZYODJq2p5XiTatK6aNiME7VjrCFWyU1KNT3IsX79UlBoC1OT/ZGPzhqh/lgI6pltNJWDb9kvQcqq/kvUAERTYJJl43b0Bu+T0fNQQkDmM7GoPhO8OhZoiOi6SQBi4+glKof9r6cy3dZke1c/4nNzjzYg6mKsnnk28uQfb0at2kbdTaI83Mhgu15qQAfuk3nWAqSFVBpNkr6aBXXgKVmL6bvqF/bMdhCG9/KrOi8Bj2+qkwHTk15hA1IOzXoD9N0guwpgSafWiUwp5LjdGnZtDHpMA/Feypu6aeZ3991pzJQXqAejXwUzV6JpDA9wETyZdOqrhzwEEMm+ZOU5ajgq",
        "price": "315",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T22:45:00",
        "buffered_depart_time": "2018-06-18T21:15:00",
        "arrive_time": "2018-06-19T09:43:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-19T10:13:00",
        "buffered_depart_time": "2018-06-19T10:13:00",
        "arrive_time": "2018-06-19T10:37:00"
      }
    ]
  },
  {
    "total_price": 434.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 138,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T14:49:00",
        "buffered_depart_time": "2018-06-18T14:49:00",
        "arrive_time": "2018-06-18T14:55:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "Independence Hall Visitors Center, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T15:15:00",
        "buffered_depart_time": "2018-06-18T14:55:00",
        "arrive_time": "2018-06-18T17:15:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T20:12:00",
        "buffered_depart_time": "2018-06-18T20:12:00",
        "arrive_time": "2018-06-18T21:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=4001122827516499_0%7C3982431552169857_0%7C3982431552169857_1&price=266&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPyTEy6XbRnhA5yvVmvorIVcqhQQS+ax8fObRTBjno04vq5h7aicz+gjx8tCnIVIJh09NAPOUxGpOh9k79AK6bGfhFvj69RhhtEyIENtvLahEpBm373rdrOgApvs6YHmabANZ3zhGs+7uOIQtKn4yHSH43L5vQ3rrIFpB0Q7vqDvSgiE6EfkHkiyjJuEpYTDq8s4IdpFcIOROuKIZTRgn0hspiEaK4qP/t/kP1+cyPbb8UA63kop+pjn3sn7XM+05fq4uzx5oc14LnweCoE7SfwCP71ZGk6TL3KQSX4EPSszZsOMcVjPJM39jd8TwmpMGsmuFULhDEZr0mTjGYT5TSnXjZQKHn3p22VJaKZCEQQz75L7lZaCa+dpAduUUkfxJTW3U1dKQM0mLj5Y9UhThuWWcwwN9rzNSJMC3obX9FBnT7ZYODJq2p5XiTatK6aNiME7VjrCFWyU1KNT3IsX79UlBoC1OT/ZGPzhqh/lgI6pltNJWDb9kvQcqq/kvUAERTYJJl43b0Bu+T0fNQQkDmM7GoPhO8OhZoiOi6SQBi4+glKof9r6cy3dZke1c/4nNzjzYg6mKsnnk28uQfb0at2kbdTaI83Mhgu15qQAfuk3nWAqSFVBpNkr6aBXXgKVmL6bvqF/bMdhCG9/KrOi8Bj2+qkwHTk15hA1IOzXoD9N0guwpgSafWiUwp5LjdGnZtDHpMA/Feypu6aeZ3991pzJQXqAejXwUzV6JpDA9wETyZdOqrhzwEEMm+ZOU5ajgq",
        "price": "315",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T22:45:00",
        "buffered_depart_time": "2018-06-18T21:15:00",
        "arrive_time": "2018-06-19T09:43:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-19T10:13:00",
        "buffered_depart_time": "2018-06-19T10:13:00",
        "arrive_time": "2018-06-19T10:37:00"
      }
    ]
  },
  {
    "total_price": 320.5,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T04:05:00",
        "buffered_depart_time": "2018-06-20T04:05:00",
        "arrive_time": "2018-06-20T04:30:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=3522835704288553_0%7C3558020294474371_0&price=210&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPv0KvDn6aPXv/5v9h+zKCcbu13e8YbaoOuO9VmF5FyN9a0MD7UdSZmCHohwXaF1xnr9QsbppOtU2slJWlujwbbFNc5vpNRcVRyHHs9FG0xf+iw5GN2EBc/b5rP/V2V9fU7EmnK0zYHQHgc7s3aih+0bPf7SO1wy8dsl9h8PQ+3m0vbF+Mm6Z8YWiZB+1bTSLm7dvxh4Kiie2n/nLwreB7S84FweAAH5jBxNO3ubykr0LoRm7+D/7oAsBJhWydpg4x0oYfOpAzLRew8tYIfT1G80oHID9dkhwsoTj+izzRkjr7m6HXVX11+zf87wxPPXYfIwKUf6CzMt+yH1KsDcfwOc2OWLQwsE/pY7tZBIU7oSERZ3ibs8lD3IIvSAqEcBmXQERcxYaU4idpwp44UfQjhpqZDBcMuRdnI8p1hes2iLyCpgrQuYipXBH8RA4QqdpzUehu31uGLKHzcAOxoCY/JyUtJqq2S1/nh4lI7Zn2sc6h4bW7cYItQ3QdHN6+cAjpatC509pbz6mbRpDHvlUxNOgBsukQVe6/cDJ9x0GO1QIz1jS6NZKRHB8HDcg3vtgHX8dwhnTOaTVeqCTe6TsyWqNnw6nC3FusReNirsyp61+qybAD5YWm5a02Ed855sIlf+q2X6rGFTFJSGNifgv8gTg57VOi3cgmWMGoZyYda5LVJzpxb0vvo5cyZ67N7FRZ",
        "price": "249",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T06:00:00",
        "buffered_depart_time": "2018-06-20T04:30:00",
        "arrive_time": "2018-06-20T17:00:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "40.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T17:30:00",
        "buffered_depart_time": "2018-06-20T17:30:00",
        "arrive_time": "2018-06-20T18:00:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "30th St Station, Philadelphia, PA",
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": "34th St b/t 11th Ave and 12th Ave, New York, NY",
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "9.0",
        "name": "megabus",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T20:25:00",
        "buffered_depart_time": "2018-06-20T20:05:00",
        "arrive_time": "2018-06-20T22:35:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T22:45:00",
        "buffered_depart_time": "2018-06-20T22:45:00",
        "arrive_time": "2018-06-20T22:51:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share:bus:ride-share",
    "id": 164,
    "departing_segments": []
  },
  {
    "total_price": 434.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 127,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T08:34:00",
        "buffered_depart_time": "2018-06-18T08:34:00",
        "arrive_time": "2018-06-18T08:40:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "30th St Station, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T09:00:00",
        "buffered_depart_time": "2018-06-18T08:40:00",
        "arrive_time": "2018-06-18T11:10:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T20:12:00",
        "buffered_depart_time": "2018-06-18T20:12:00",
        "arrive_time": "2018-06-18T21:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=4001122827516499_0%7C3982431552169857_0%7C3982431552169857_1&price=266&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPyTEy6XbRnhA5yvVmvorIVcqhQQS+ax8fObRTBjno04vq5h7aicz+gjx8tCnIVIJh09NAPOUxGpOh9k79AK6bGfhFvj69RhhtEyIENtvLahEpBm373rdrOgApvs6YHmabANZ3zhGs+7uOIQtKn4yHSH43L5vQ3rrIFpB0Q7vqDvSgiE6EfkHkiyjJuEpYTDq8s4IdpFcIOROuKIZTRgn0hspiEaK4qP/t/kP1+cyPbb8UA63kop+pjn3sn7XM+05fq4uzx5oc14LnweCoE7SfwCP71ZGk6TL3KQSX4EPSszZsOMcVjPJM39jd8TwmpMGsmuFULhDEZr0mTjGYT5TSnXjZQKHn3p22VJaKZCEQQz75L7lZaCa+dpAduUUkfxJTW3U1dKQM0mLj5Y9UhThuWWcwwN9rzNSJMC3obX9FBnT7ZYODJq2p5XiTatK6aNiME7VjrCFWyU1KNT3IsX79UlBoC1OT/ZGPzhqh/lgI6pltNJWDb9kvQcqq/kvUAERTYJJl43b0Bu+T0fNQQkDmM7GoPhO8OhZoiOi6SQBi4+glKof9r6cy3dZke1c/4nNzjzYg6mKsnnk28uQfb0at2kbdTaI83Mhgu15qQAfuk3nWAqSFVBpNkr6aBXXgKVmL6bvqF/bMdhCG9/KrOi8Bj2+qkwHTk15hA1IOzXoD9N0guwpgSafWiUwp5LjdGnZtDHpMA/Feypu6aeZ3991pzJQXqAejXwUzV6JpDA9wETyZdOqrhzwEEMm+ZOU5ajgq",
        "price": "315",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T22:45:00",
        "buffered_depart_time": "2018-06-18T21:15:00",
        "arrive_time": "2018-06-19T09:43:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-19T10:13:00",
        "buffered_depart_time": "2018-06-19T10:13:00",
        "arrive_time": "2018-06-19T10:37:00"
      }
    ]
  },
  {
    "total_price": 473.0,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T04:05:00",
        "buffered_depart_time": "2018-06-20T04:05:00",
        "arrive_time": "2018-06-20T04:30:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=3522835704288553_0%7C3558020294474371_0&price=210&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPv0KvDn6aPXv/5v9h+zKCcbu13e8YbaoOuO9VmF5FyN9a0MD7UdSZmCHohwXaF1xnr9QsbppOtU2slJWlujwbbFNc5vpNRcVRyHHs9FG0xf/lbgUvalptpj008mz/S2jU+6zrO34QoiDo7xLw9+7c8y28Llmhzy8wcwZhvtRIKyOUHM4qptjaha3RqXqcxGsPvlz0jFeDfRWVxrARDZxWQ0GUieCNcKcBxlUdIIOMMf+LTh+Mw6WLgd4Sg6u+amp4X27o5vFuevGQRym6VAWTVVfuXZs9nBePAtWr+sJDN+XfqSPqisIv+SfKa/gL9UNd8weT9O4o6M3RV7mQM0t4DM/hQcYrPwANDeJRORpidZLMx2qKessY/dsaezIIo/FSUUcOzJ0s5oAOjcV6uzWBICxq3eb2Uy8EP494cdiv+nBKUFycqcXycxUO6d09pHxxgbcFx6Lm6wneC5xwnbpx1XofF37cnJ3UqA1IBtOqhQfG2x94SMoVDb2icVskJ+YQGzfARMbtwDEvuUP/PVpuXdc8vakj6ftdSzumL1ZJF0FQRprs3VaFX4bA3aV7yXQ6ArVrQFL7kFqubsvXPsNknBC79cmOnwWp3JCdISSlvLC8oli5uXH2OP+abk3GsWcePq4owKYYXOqQNbb3Nx9cqWEt5ESxq70zOSJCfsnhNXueNPoHHS1x0bJfrzWCO1tM",
        "price": "249",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T06:00:00",
        "buffered_depart_time": "2018-06-20T04:30:00",
        "arrive_time": "2018-06-20T17:00:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "208.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T17:30:00",
        "buffered_depart_time": "2018-06-20T17:30:00",
        "arrive_time": "2018-06-20T19:21:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share",
    "id": 153,
    "departing_segments": []
  },
  {
    "total_price": 258.5,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T04:50:00",
        "buffered_depart_time": "2018-06-20T04:50:00",
        "arrive_time": "2018-06-20T05:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=4008819685527143_0%7C4008819685527143_1%7C3803210722975286_0&price=165&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPjoUDnBsV+8uftjDbJxyY5IBPEOiEo8mHQXluz8hkRli01WLCsa/jvg/MAIcwq3op82v/7bTTYw8R9/iFUAOQOdMIBiHo2p/w8/JexfVas1O2mxnOTtYDJdyhmxLKAl+Nb6Rgh3+mMBf7T5p4fK538ThWp2jQZqo83MzdhXhInUwnZoDpyOGZ7aLtNeAV88VtP3hjWngzRAQ8owcdXPDitzDnSg3ZAoOfz83eyOnc9TXLPxyoWKkonqYZUhIiwLd20JiMIhHwXnogjSzmH51+3CB3Sl+3MkmdXVRtIdRTENctK/q9bcBqvIXUD3MELqGwQEztfAsK+Xr1K2tgtnTWxERMdRIFgzQ3evhGODpEAWzqiq6oDVQ2vm/hDgX1itCsIwaE394L/aSWaU4T0i/TyKt+2KW8BtLAmqpOj+nO7Rq90HtEa5bz5cTJnI92YZ88Y7PhPlFb1QboVoR42FnT3ftLTaKsGp9bjkaau4PNtUtjQnYR/4JUwlYws7AO7HErqXVgZVxoJpkbv3tsscpO6UIsDlsZa1w1gdg9N+YKXhMPiLwU+fMjs6diTM7dFiiZM4XhJxkWGY+P0GtPAnE1pPkoZWR80wtzhFirrCxY3vn6at3IBqaE6b+V8rynIbXIeVyioK1fs5f84Hnj0kC0e8zBufRSo8jPovaGpCNM++Mt3Mpx7jSa0bkgoosIPXSw0mwpr8xHJzC2vePTATHe4daonSVNEk8Mr+OZGEuAHv4euemxH/d9U6O3Quxo1sFX",
        "price": "195",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T06:45:00",
        "buffered_depart_time": "2018-06-20T05:15:00",
        "arrive_time": "2018-06-20T21:00:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "40.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T21:30:00",
        "buffered_depart_time": "2018-06-20T21:30:00",
        "arrive_time": "2018-06-20T22:00:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "30th St Station, Philadelphia, PA",
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": "34th St b/t 11th Ave and 12th Ave, New York, NY",
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "1.0",
        "name": "megabus",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T23:20:00",
        "buffered_depart_time": "2018-06-20T23:00:00",
        "arrive_time": "2018-06-21T01:30:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-21T01:40:00",
        "buffered_depart_time": "2018-06-21T01:40:00",
        "arrive_time": "2018-06-21T01:46:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share:bus:ride-share",
    "id": 158,
    "departing_segments": []
  },
  {
    "total_price": 320.5,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T04:05:00",
        "buffered_depart_time": "2018-06-20T04:05:00",
        "arrive_time": "2018-06-20T04:30:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=3522835704288553_0%7C3558020294474371_0&price=210&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPv0KvDn6aPXv/5v9h+zKCcbu13e8YbaoOuO9VmF5FyN9a0MD7UdSZmCHohwXaF1xnr9QsbppOtU2slJWlujwbbFNc5vpNRcVRyHHs9FG0xf+iw5GN2EBc/b5rP/V2V9fU7EmnK0zYHQHgc7s3aih+0bPf7SO1wy8dsl9h8PQ+3m0vbF+Mm6Z8YWiZB+1bTSLm7dvxh4Kiie2n/nLwreB7S84FweAAH5jBxNO3ubykr0LoRm7+D/7oAsBJhWydpg4x0oYfOpAzLRew8tYIfT1G80oHID9dkhwsoTj+izzRkjr7m6HXVX11+zf87wxPPXYfIwKUf6CzMt+yH1KsDcfwOc2OWLQwsE/pY7tZBIU7oSERZ3ibs8lD3IIvSAqEcBmXQERcxYaU4idpwp44UfQjhpqZDBcMuRdnI8p1hes2iLyCpgrQuYipXBH8RA4QqdpzUehu31uGLKHzcAOxoCY/JyUtJqq2S1/nh4lI7Zn2sc6h4bW7cYItQ3QdHN6+cAjpatC509pbz6mbRpDHvlUxNOgBsukQVe6/cDJ9x0GO1QIz1jS6NZKRHB8HDcg3vtgHX8dwhnTOaTVeqCTe6TsyWqNnw6nC3FusReNirsyp61+qybAD5YWm5a02Ed855sIlf+q2X6rGFTFJSGNifgv8gTg57VOi3cgmWMGoZyYda5LVJzpxb0vvo5cyZ67N7FRZ",
        "price": "249",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T06:00:00",
        "buffered_depart_time": "2018-06-20T04:30:00",
        "arrive_time": "2018-06-20T17:00:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "40.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T17:30:00",
        "buffered_depart_time": "2018-06-20T17:30:00",
        "arrive_time": "2018-06-20T18:00:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "30th St Station, Philadelphia, PA",
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": "34th St b/t 11th Ave and 12th Ave, New York, NY",
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "9.0",
        "name": "megabus",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T21:20:00",
        "buffered_depart_time": "2018-06-20T21:00:00",
        "arrive_time": "2018-06-20T23:30:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T23:40:00",
        "buffered_depart_time": "2018-06-20T23:40:00",
        "arrive_time": "2018-06-20T23:46:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share:bus:ride-share",
    "id": 166,
    "departing_segments": []
  },
  {
    "total_price": 327.5,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T04:50:00",
        "buffered_depart_time": "2018-06-20T04:50:00",
        "arrive_time": "2018-06-20T05:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=4035207816796086_0%7C4035207816796086_1%7C3598702163596938_0&price=216&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPhMhiXGhmctYJmBJTQXuLUj1sQLf00gX21TRZqyUR0SpvoV+yG9wrU9B5Ar6P6oUSiBCHuRO3/5RF54tI0igB+D/9PpPqvFzSqMMttDq1By25DXR4EbrRJ5At+3SxjkxfGVzqyD53lYxIN4mL1WoeZa0LTFJNgqN1oJUYNOcEQfzunyKLZR80nevtXKfmer7OSOSETMIt6nbMsGRdiP+b5gC4xgVXmkMWdm7zhsRVkaQ7Y7Q2PLJXSGB9OqPmWPqgcsIgHkqojc7MtSGpz6WtM91o71URANaUm0cDFSHe1dlY8pW7IdR6UaBN2tym4ontittkIJj0fCvyIlylMxhI8eO7hSAjmBV54Ddz5SjJ52ChBgvlY5ZeF8tmHQDCreG2D+Hk7222ODayUJrJcg4TTU+f6VGG8DRRBw6/zShYveUqeP1JFTGMiNk3puTLhiQlVtjdRRd6LhjmC1noV/lUGaJ4f9XxMBZWEwbAHBrJDx/6BWFiJNQIEdmiK1DUmPCOBa5JHptKmrr+9Bo25MLMLDeHnzZgN0luToXOxc9wrI3DaZ4bo6m3gzr7J5whQzJvo21UQPBMNDwbtyriyoWyhIbpfWAWnYaTo6Xoaaftwx5Y8/OMtaCph4KSUcnRfEaU62Tuymambgc9GIYdigx/VpG7GVRJOzm8DeNeUJRbOjzB0s6k43u5AotV+WU1mLGtdKitnjQ4iwayW8khy6+mBqdGRv1C4z0CvPn0zrkf+cWxj2SqgX/WUgk4FYmE5Wwl",
        "price": "256",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T06:45:00",
        "buffered_depart_time": "2018-06-20T05:15:00",
        "arrive_time": "2018-06-20T15:40:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "40.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T16:10:00",
        "buffered_depart_time": "2018-06-20T16:10:00",
        "arrive_time": "2018-06-20T16:40:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "Independence Hall Visitors Center, Philadelphia, PA",
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": "34th St b/t 11th Ave and 12th Ave, New York, NY",
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "9.0",
        "name": "megabus",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T20:25:00",
        "buffered_depart_time": "2018-06-20T20:05:00",
        "arrive_time": "2018-06-20T22:25:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T22:35:00",
        "buffered_depart_time": "2018-06-20T22:35:00",
        "arrive_time": "2018-06-20T22:41:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share:bus:ride-share",
    "id": 179,
    "departing_segments": []
  },
  {
    "total_price": 425.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 117,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T08:44:00",
        "buffered_depart_time": "2018-06-18T08:44:00",
        "arrive_time": "2018-06-18T08:50:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "Independence Hall Visitors Center, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T09:10:00",
        "buffered_depart_time": "2018-06-18T08:50:00",
        "arrive_time": "2018-06-18T11:10:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T12:20:00",
        "buffered_depart_time": "2018-06-18T12:20:00",
        "arrive_time": "2018-06-18T13:23:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=3488751098027710_0%7C3917560245168350_0%7C3917560245168350_1&price=259&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPQ/zjLVOCowaBhF3iXk2bEn07Xr+8wLkggi326weN87Ro+JAqpgcdJfVoCY0gNDJ4fB0J4RufmcjOaCwW3AbMCo8XFkKDbrB0oIQwA3e/aW6K8Ys3/ku9d1vxwmLon+yvmR6rUcdTfTK8EGievETfkPgySpkUB8YZqoXoGoiv/WY9pasl6OuRjvTlIywLL+QyfjhUKU+jCSkQWeMvi+KYd1rDl7DABeDM0CDi+zkOOd/AD/MNOyfyFnDxJJlCPfgw3udVGuJ2VuYSlsgQYekguJp/lU59sZ/S1eqWopMaTpelkpjeGmod1t17bypJHfmL5sj0Zpg8t7g7V+JfRDg76U0/K/FOPFfqlA1mkekWGFmXCY6Ia8gGY+v10wNmZ8zHGqhzxHB6rKyNyjq+hdiX/HbxCvYnQR6+OaRX+pMZTZGrbj16x+o5JKfyC4Y3wsSHc/736Um3EHrKj/L/NL2zjB2aw7UnUpKcHtmLAOlflfcJUYfJFNRK3Q/vqLroJvAcV7AdUhqD2oJmBpRmt66Tda3LECLli8QAKtmUNUUQgit/R+ut47g6kF0cIKA8GQUMOpl+xk434O4UX5m6FnBr3wiAOP0H3txba5w/OZf+KmbYjWEcw56wp3Znq0wmG0Z2fTWg6x7LumeITdmVYldk8nG49PBKUfEjTjAmVZUvDnBn5qbkb0G15TUvta9Cc5I5jtlV9ZPF/Lyl5ECsT/7qscAfMjE9FnWVwbOys9Sat12+Jls2ozxNj2/vYQNkIvgwVn8aXwJhpkraGo//KeMhJw==",
        "price": "306",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T14:53:00",
        "buffered_depart_time": "2018-06-18T13:23:00",
        "arrive_time": "2018-06-18T23:15:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T23:45:00",
        "buffered_depart_time": "2018-06-18T23:45:00",
        "arrive_time": "2018-06-19T00:09:00"
      }
    ]
  },
  {
    "total_price": 434.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 126,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T07:44:00",
        "buffered_depart_time": "2018-06-18T07:44:00",
        "arrive_time": "2018-06-18T07:50:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "Independence Hall Visitors Center, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T08:10:00",
        "buffered_depart_time": "2018-06-18T07:50:00",
        "arrive_time": "2018-06-18T10:10:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T20:12:00",
        "buffered_depart_time": "2018-06-18T20:12:00",
        "arrive_time": "2018-06-18T21:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=4001122827516499_0%7C3982431552169857_0%7C3982431552169857_1&price=266&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPyTEy6XbRnhA5yvVmvorIVcqhQQS+ax8fObRTBjno04vq5h7aicz+gjx8tCnIVIJh09NAPOUxGpOh9k79AK6bGfhFvj69RhhtEyIENtvLahEpBm373rdrOgApvs6YHmabANZ3zhGs+7uOIQtKn4yHSH43L5vQ3rrIFpB0Q7vqDvSgiE6EfkHkiyjJuEpYTDq8s4IdpFcIOROuKIZTRgn0hspiEaK4qP/t/kP1+cyPbb8UA63kop+pjn3sn7XM+05fq4uzx5oc14LnweCoE7SfwCP71ZGk6TL3KQSX4EPSszZsOMcVjPJM39jd8TwmpMGsmuFULhDEZr0mTjGYT5TSnXjZQKHn3p22VJaKZCEQQz75L7lZaCa+dpAduUUkfxJTW3U1dKQM0mLj5Y9UhThuWWcwwN9rzNSJMC3obX9FBnT7ZYODJq2p5XiTatK6aNiME7VjrCFWyU1KNT3IsX79UlBoC1OT/ZGPzhqh/lgI6pltNJWDb9kvQcqq/kvUAERTYJJl43b0Bu+T0fNQQkDmM7GoPhO8OhZoiOi6SQBi4+glKof9r6cy3dZke1c/4nNzjzYg6mKsnnk28uQfb0at2kbdTaI83Mhgu15qQAfuk3nWAqSFVBpNkr6aBXXgKVmL6bvqF/bMdhCG9/KrOi8Bj2+qkwHTk15hA1IOzXoD9N0guwpgSafWiUwp5LjdGnZtDHpMA/Feypu6aeZ3991pzJQXqAejXwUzV6JpDA9wETyZdOqrhzwEEMm+ZOU5ajgq",
        "price": "315",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T22:45:00",
        "buffered_depart_time": "2018-06-18T21:15:00",
        "arrive_time": "2018-06-19T09:43:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-19T10:13:00",
        "buffered_depart_time": "2018-06-19T10:13:00",
        "arrive_time": "2018-06-19T10:37:00"
      }
    ]
  },
  {
    "total_price": 434.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 134,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T12:04:00",
        "buffered_depart_time": "2018-06-18T12:04:00",
        "arrive_time": "2018-06-18T12:10:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "Independence Hall Visitors Center, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T12:30:00",
        "buffered_depart_time": "2018-06-18T12:10:00",
        "arrive_time": "2018-06-18T14:30:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T20:12:00",
        "buffered_depart_time": "2018-06-18T20:12:00",
        "arrive_time": "2018-06-18T21:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=4001122827516499_0%7C3982431552169857_0%7C3982431552169857_1&price=266&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPyTEy6XbRnhA5yvVmvorIVcqhQQS+ax8fObRTBjno04vq5h7aicz+gjx8tCnIVIJh09NAPOUxGpOh9k79AK6bGfhFvj69RhhtEyIENtvLahEpBm373rdrOgApvs6YHmabANZ3zhGs+7uOIQtKn4yHSH43L5vQ3rrIFpB0Q7vqDvSgiE6EfkHkiyjJuEpYTDq8s4IdpFcIOROuKIZTRgn0hspiEaK4qP/t/kP1+cyPbb8UA63kop+pjn3sn7XM+05fq4uzx5oc14LnweCoE7SfwCP71ZGk6TL3KQSX4EPSszZsOMcVjPJM39jd8TwmpMGsmuFULhDEZr0mTjGYT5TSnXjZQKHn3p22VJaKZCEQQz75L7lZaCa+dpAduUUkfxJTW3U1dKQM0mLj5Y9UhThuWWcwwN9rzNSJMC3obX9FBnT7ZYODJq2p5XiTatK6aNiME7VjrCFWyU1KNT3IsX79UlBoC1OT/ZGPzhqh/lgI6pltNJWDb9kvQcqq/kvUAERTYJJl43b0Bu+T0fNQQkDmM7GoPhO8OhZoiOi6SQBi4+glKof9r6cy3dZke1c/4nNzjzYg6mKsnnk28uQfb0at2kbdTaI83Mhgu15qQAfuk3nWAqSFVBpNkr6aBXXgKVmL6bvqF/bMdhCG9/KrOi8Bj2+qkwHTk15hA1IOzXoD9N0guwpgSafWiUwp5LjdGnZtDHpMA/Feypu6aeZ3991pzJQXqAejXwUzV6JpDA9wETyZdOqrhzwEEMm+ZOU5ajgq",
        "price": "315",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T22:45:00",
        "buffered_depart_time": "2018-06-18T21:15:00",
        "arrive_time": "2018-06-19T09:43:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-19T10:13:00",
        "buffered_depart_time": "2018-06-19T10:13:00",
        "arrive_time": "2018-06-19T10:37:00"
      }
    ]
  },
  {
    "total_price": 327.5,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T04:50:00",
        "buffered_depart_time": "2018-06-20T04:50:00",
        "arrive_time": "2018-06-20T05:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=4035207816796086_0%7C4035207816796086_1%7C3598702163596938_0&price=216&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPhMhiXGhmctYJmBJTQXuLUj1sQLf00gX21TRZqyUR0SpvoV+yG9wrU9B5Ar6P6oUSiBCHuRO3/5RF54tI0igB+D/9PpPqvFzSqMMttDq1By25DXR4EbrRJ5At+3SxjkxfGVzqyD53lYxIN4mL1WoeZa0LTFJNgqN1oJUYNOcEQfzunyKLZR80nevtXKfmer7OSOSETMIt6nbMsGRdiP+b5gC4xgVXmkMWdm7zhsRVkaQ7Y7Q2PLJXSGB9OqPmWPqgcsIgHkqojc7MtSGpz6WtM91o71URANaUm0cDFSHe1dlY8pW7IdR6UaBN2tym4ontittkIJj0fCvyIlylMxhI8eO7hSAjmBV54Ddz5SjJ52ChBgvlY5ZeF8tmHQDCreG2D+Hk7222ODayUJrJcg4TTU+f6VGG8DRRBw6/zShYveUqeP1JFTGMiNk3puTLhiQlVtjdRRd6LhjmC1noV/lUGaJ4f9XxMBZWEwbAHBrJDx/6BWFiJNQIEdmiK1DUmPCOBa5JHptKmrr+9Bo25MLMLDeHnzZgN0luToXOxc9wrI3DaZ4bo6m3gzr7J5whQzJvo21UQPBMNDwbtyriyoWyhIbpfWAWnYaTo6Xoaaftwx5Y8/OMtaCph4KSUcnRfEaU62Tuymambgc9GIYdigx/VpG7GVRJOzm8DeNeUJRbOjzB0s6k43u5AotV+WU1mLGtdKitnjQ4iwayW8khy6+mBqdGRv1C4z0CvPn0zrkf+cWxj2SqgX/WUgk4FYmE5Wwl",
        "price": "256",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T06:45:00",
        "buffered_depart_time": "2018-06-20T05:15:00",
        "arrive_time": "2018-06-20T15:40:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "40.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T16:10:00",
        "buffered_depart_time": "2018-06-20T16:10:00",
        "arrive_time": "2018-06-20T16:40:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "30th St Station, Philadelphia, PA",
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": "34th St b/t 11th Ave and 12th Ave, New York, NY",
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "9.0",
        "name": "megabus",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T21:20:00",
        "buffered_depart_time": "2018-06-20T21:00:00",
        "arrive_time": "2018-06-20T23:30:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T23:40:00",
        "buffered_depart_time": "2018-06-20T23:40:00",
        "arrive_time": "2018-06-20T23:46:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share:bus:ride-share",
    "id": 182,
    "departing_segments": []
  },
  {
    "total_price": 312.5,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T04:05:00",
        "buffered_depart_time": "2018-06-20T04:05:00",
        "arrive_time": "2018-06-20T04:30:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=3522835704288553_0%7C3558020294474371_0&price=210&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPv0KvDn6aPXv/5v9h+zKCcbu13e8YbaoOuO9VmF5FyN9a0MD7UdSZmCHohwXaF1xnr9QsbppOtU2slJWlujwbbFNc5vpNRcVRyHHs9FG0xf+iw5GN2EBc/b5rP/V2V9fU7EmnK0zYHQHgc7s3aih+0bPf7SO1wy8dsl9h8PQ+3m0vbF+Mm6Z8YWiZB+1bTSLm7dvxh4Kiie2n/nLwreB7S84FweAAH5jBxNO3ubykr0LoRm7+D/7oAsBJhWydpg4x0oYfOpAzLRew8tYIfT1G80oHID9dkhwsoTj+izzRkjr7m6HXVX11+zf87wxPPXYfIwKUf6CzMt+yH1KsDcfwOc2OWLQwsE/pY7tZBIU7oSERZ3ibs8lD3IIvSAqEcBmXQERcxYaU4idpwp44UfQjhpqZDBcMuRdnI8p1hes2iLyCpgrQuYipXBH8RA4QqdpzUehu31uGLKHzcAOxoCY/JyUtJqq2S1/nh4lI7Zn2sc6h4bW7cYItQ3QdHN6+cAjpatC509pbz6mbRpDHvlUxNOgBsukQVe6/cDJ9x0GO1QIz1jS6NZKRHB8HDcg3vtgHX8dwhnTOaTVeqCTe6TsyWqNnw6nC3FusReNirsyp61+qybAD5YWm5a02Ed855sIlf+q2X6rGFTFJSGNifgv8gTg57VOi3cgmWMGoZyYda5LVJzpxb0vvo5cyZ67N7FRZ",
        "price": "249",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T06:00:00",
        "buffered_depart_time": "2018-06-20T04:30:00",
        "arrive_time": "2018-06-20T17:00:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "40.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T17:30:00",
        "buffered_depart_time": "2018-06-20T17:30:00",
        "arrive_time": "2018-06-20T18:00:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "30th St Station, Philadelphia, PA",
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": "34th St b/t 11th Ave and 12th Ave, New York, NY",
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "1.0",
        "name": "megabus",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T23:20:00",
        "buffered_depart_time": "2018-06-20T23:00:00",
        "arrive_time": "2018-06-21T01:30:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-21T01:40:00",
        "buffered_depart_time": "2018-06-21T01:40:00",
        "arrive_time": "2018-06-21T01:46:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share:bus:ride-share",
    "id": 168,
    "departing_segments": []
  },
  {
    "total_price": 434.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 122,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T05:44:00",
        "buffered_depart_time": "2018-06-18T05:44:00",
        "arrive_time": "2018-06-18T05:50:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "Independence Hall Visitors Center, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T06:10:00",
        "buffered_depart_time": "2018-06-18T05:50:00",
        "arrive_time": "2018-06-18T08:10:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T20:12:00",
        "buffered_depart_time": "2018-06-18T20:12:00",
        "arrive_time": "2018-06-18T21:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=4001122827516499_0%7C3982431552169857_0%7C3982431552169857_1&price=266&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPyTEy6XbRnhA5yvVmvorIVcqhQQS+ax8fObRTBjno04vq5h7aicz+gjx8tCnIVIJh09NAPOUxGpOh9k79AK6bGfhFvj69RhhtEyIENtvLahEpBm373rdrOgApvs6YHmabANZ3zhGs+7uOIQtKn4yHSH43L5vQ3rrIFpB0Q7vqDvSgiE6EfkHkiyjJuEpYTDq8s4IdpFcIOROuKIZTRgn0hspiEaK4qP/t/kP1+cyPbb8UA63kop+pjn3sn7XM+05fq4uzx5oc14LnweCoE7SfwCP71ZGk6TL3KQSX4EPSszZsOMcVjPJM39jd8TwmpMGsmuFULhDEZr0mTjGYT5TSnXjZQKHn3p22VJaKZCEQQz75L7lZaCa+dpAduUUkfxJTW3U1dKQM0mLj5Y9UhThuWWcwwN9rzNSJMC3obX9FBnT7ZYODJq2p5XiTatK6aNiME7VjrCFWyU1KNT3IsX79UlBoC1OT/ZGPzhqh/lgI6pltNJWDb9kvQcqq/kvUAERTYJJl43b0Bu+T0fNQQkDmM7GoPhO8OhZoiOi6SQBi4+glKof9r6cy3dZke1c/4nNzjzYg6mKsnnk28uQfb0at2kbdTaI83Mhgu15qQAfuk3nWAqSFVBpNkr6aBXXgKVmL6bvqF/bMdhCG9/KrOi8Bj2+qkwHTk15hA1IOzXoD9N0guwpgSafWiUwp5LjdGnZtDHpMA/Feypu6aeZ3991pzJQXqAejXwUzV6JpDA9wETyZdOqrhzwEEMm+ZOU5ajgq",
        "price": "315",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T22:45:00",
        "buffered_depart_time": "2018-06-18T21:15:00",
        "arrive_time": "2018-06-19T09:43:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-19T10:13:00",
        "buffered_depart_time": "2018-06-19T10:13:00",
        "arrive_time": "2018-06-19T10:37:00"
      }
    ]
  },
  {
    "total_price": 367.99,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.94059",
            "to_lat": "41.26069",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "6.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T11:41:00",
        "buffered_depart_time": "2018-06-20T11:41:00",
        "arrive_time": "2018-06-20T11:45:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "Eastbound side of Cherry Street, between 7th and 8th Streets, Des Moines, IA",
            "to_lon": "-93.62697",
            "to_lat": "41.58329",
            "from_string": "Crossroads Mall - N 72nd St between Dodge St and Cass St, Omaha, NE",
            "from_lon": "-95.94059",
            "from_lat": "41.26069"
          }
        },
        "purchase_link": null,
        "price": "19.99",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T12:05:00",
        "buffered_depart_time": "2018-06-20T11:45:00",
        "arrive_time": "2018-06-20T14:45:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-93.657778",
            "to_lat": "41.534167",
            "from_string": null,
            "from_lon": "-93.62697",
            "from_lat": "41.58329"
          }
        },
        "purchase_link": null,
        "price": "9.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T15:12:00",
        "buffered_depart_time": "2018-06-20T15:12:00",
        "arrive_time": "2018-06-20T15:25:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "EWR Airport, New York City",
            "to_lon": "-74.168611",
            "to_lat": "40.6925",
            "from_string": "DSM Airport, Des Moines",
            "from_lon": "-93.657778",
            "from_lat": "41.534167"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=DSM&to=EWR&departure=20-06-2018&flightsId=3548124614089892_0%7C3548124614089892_1&price=184&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPNHGxSVuTiBOhiX4K8HhrfRiYIN/e+RJOnOwLh+RE7yY0JwfIPikRp4ei25MVgKnLtxvlsEeVJWvydBogcjNgqZLbNcs4zbdzxCHLfXoCcCLl+HMTzH+rlfO09POzySc4aHgf0fuuiXPgS1bC1LcONyvgkbqoQVWoyTtgD02k2Ow16NNrIsKEqEu50+L2xOrekdlqtLhF01vDn6cRXOdMGkItk/92jXNsI5ryThkNVKiIlUY+vzbd+47QQdZjs0d+HnZypIGEal81T93TlDdz6rnjRucj+yRyatVk7yenqIb3lDZndm//PMMln/oiLgLwxpb0UePxUKxI02dDQlUyfwiDKKtaZugqciqvBdjqCVaRJsGoZS2Qu4DWngO/RyGpVgKaNiDmNSVwBtixN2YRU/BKj94Poimb7A8UTM3Jm5P64EmLQC6QH9a55yWdN19USqo9/9hKNqgJTZXLON3IxRbe5FEs5jrlAH+2wrzAEuckyUhSYnTOTMJ/NPNtY2zsoiDfYrlihBaakTHap6idkGUPAAhrauKkUAl0yuoXdyEJqS88vCtqGww4xqzvjCNnZIsTwQ+vS58nHwWStv7OXeZcTHdJJS3FMrIapZ5cGMJzbCMVDdFzgLfqlbJDZlFLRtAMMi0UKLV+rJD9V6re4Y0GxXBM+idZX+7OHHSg7+OsKZTaO8HkWTGfNSIPkFQl",
        "price": "217",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T16:55:00",
        "buffered_depart_time": "2018-06-20T15:25:00",
        "arrive_time": "2018-06-21T00:43:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-74.168611",
            "from_lat": "40.6925"
          }
        },
        "purchase_link": null,
        "price": "115.5",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-21T01:13:00",
        "buffered_depart_time": "2018-06-21T01:13:00",
        "arrive_time": "2018-06-21T02:58:00"
      }
    ],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 187,
    "departing_segments": []
  },
  {
    "total_price": 319.5,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T04:50:00",
        "buffered_depart_time": "2018-06-20T04:50:00",
        "arrive_time": "2018-06-20T05:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=4035207816796086_0%7C4035207816796086_1%7C3598702163596938_0&price=216&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPhMhiXGhmctYJmBJTQXuLUj1sQLf00gX21TRZqyUR0SpvoV+yG9wrU9B5Ar6P6oUSiBCHuRO3/5RF54tI0igB+D/9PpPqvFzSqMMttDq1By25DXR4EbrRJ5At+3SxjkxfGVzqyD53lYxIN4mL1WoeZa0LTFJNgqN1oJUYNOcEQfzunyKLZR80nevtXKfmer7OSOSETMIt6nbMsGRdiP+b5gC4xgVXmkMWdm7zhsRVkaQ7Y7Q2PLJXSGB9OqPmWPqgcsIgHkqojc7MtSGpz6WtM91o71URANaUm0cDFSHe1dlY8pW7IdR6UaBN2tym4ontittkIJj0fCvyIlylMxhI8eO7hSAjmBV54Ddz5SjJ52ChBgvlY5ZeF8tmHQDCreG2D+Hk7222ODayUJrJcg4TTU+f6VGG8DRRBw6/zShYveUqeP1JFTGMiNk3puTLhiQlVtjdRRd6LhjmC1noV/lUGaJ4f9XxMBZWEwbAHBrJDx/6BWFiJNQIEdmiK1DUmPCOBa5JHptKmrr+9Bo25MLMLDeHnzZgN0luToXOxc9wrI3DaZ4bo6m3gzr7J5whQzJvo21UQPBMNDwbtyriyoWyhIbpfWAWnYaTo6Xoaaftwx5Y8/OMtaCph4KSUcnRfEaU62Tuymambgc9GIYdigx/VpG7GVRJOzm8DeNeUJRbOjzB0s6k43u5AotV+WU1mLGtdKitnjQ4iwayW8khy6+mBqdGRv1C4z0CvPn0zrkf+cWxj2SqgX/WUgk4FYmE5Wwl",
        "price": "256",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T06:45:00",
        "buffered_depart_time": "2018-06-20T05:15:00",
        "arrive_time": "2018-06-20T15:40:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "40.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T16:10:00",
        "buffered_depart_time": "2018-06-20T16:10:00",
        "arrive_time": "2018-06-20T16:40:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "Independence Hall Visitors Center, Philadelphia, PA",
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": "34th St b/t 11th Ave and 12th Ave, New York, NY",
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "1.0",
        "name": "megabus",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T23:20:00",
        "buffered_depart_time": "2018-06-20T23:00:00",
        "arrive_time": "2018-06-21T01:20:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-21T01:30:00",
        "buffered_depart_time": "2018-06-21T01:30:00",
        "arrive_time": "2018-06-21T01:36:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share:bus:ride-share",
    "id": 183,
    "departing_segments": []
  },
  {
    "total_price": 324.5,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T04:50:00",
        "buffered_depart_time": "2018-06-20T04:50:00",
        "arrive_time": "2018-06-20T05:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=4008819685527143_0%7C4008819685527143_1%7C3742737859286809_0&price=214&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPjoUDnBsV+8uftjDbJxyY5IBPEOiEo8mHQXluz8hkRli01WLCsa/jvg/MAIcwq3op+LPOUPUVH/QWZ26nJ4U24nzJvQFJZ6eIXh12dT/+EEeiZxFeD28ei+ZwIjMnT351Ia6vhguGB8/uhyYCnHMcVNrDrSPXaDmUrsSj3+nNnHi07slYhs5jhSTtZAKkAkkDzmUwJTBwEuQ//H/u2DXQn4svpqa0GQumPbs1JoZUwq6sAI8eoz6DrUIiErevVfPnU5pK4NgP8ne2hYKVPZgRKobOGjQyvjzgv+iCsO08b26zK5rbWX+zu2oluwEVdCUTvbhkFof38kqpAaVwYKU7GvPSp0sPRhqVq2oituPuos2WwBd8uKVZLsaAn3waR2e7gavFB44ltXL78vjOtFWUnUzmhHzFZ9YG16gDx9XgpG+g3dtiCkG0M0jWaRchWMFxm9v9Ig7u6Wmhzq4EVlA1GKzgwb9rKRwrxiV/nHFy0EG63/0SahBW+e0oHNnh7mEJYFqBdTqTb3I46UFUHS0nrNv81sLw4QXsTz+petIVNbXwAaVaA3kNcS+Zqc6m8pDWbUGLOfmxKP3z1AJD2r3HHpEfteYOG0FevWyrqfJjfUTCLpqeLUTF7mfiwMkFF8/6aNegyFWILLp6CdjmaRiDYkgZ2FJ+8MQuQL5VyaVvK//BdfMvzU4PBBlgIoG7mCnlhOsVEeA7J+D/SoIDngG7BfQ3CGZiKZt1oN+zqQ03sO2xTTyK5+5pwxRaA0CqAfBX7rvQM2FWjaAifWfS/wzZIw==",
        "price": "253",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T06:45:00",
        "buffered_depart_time": "2018-06-20T05:15:00",
        "arrive_time": "2018-06-20T17:45:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "40.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T18:15:00",
        "buffered_depart_time": "2018-06-20T18:15:00",
        "arrive_time": "2018-06-20T18:45:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "Independence Hall Visitors Center, Philadelphia, PA",
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": "34th St b/t 11th Ave and 12th Ave, New York, NY",
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "9.0",
        "name": "megabus",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T21:20:00",
        "buffered_depart_time": "2018-06-20T21:00:00",
        "arrive_time": "2018-06-20T23:20:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T23:30:00",
        "buffered_depart_time": "2018-06-20T23:30:00",
        "arrive_time": "2018-06-20T23:36:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share:bus:ride-share",
    "id": 171,
    "departing_segments": []
  },
  {
    "total_price": 434.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 130,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T09:44:00",
        "buffered_depart_time": "2018-06-18T09:44:00",
        "arrive_time": "2018-06-18T09:50:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "Independence Hall Visitors Center, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T10:10:00",
        "buffered_depart_time": "2018-06-18T09:50:00",
        "arrive_time": "2018-06-18T12:10:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T20:12:00",
        "buffered_depart_time": "2018-06-18T20:12:00",
        "arrive_time": "2018-06-18T21:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=4001122827516499_0%7C3982431552169857_0%7C3982431552169857_1&price=266&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPyTEy6XbRnhA5yvVmvorIVcqhQQS+ax8fObRTBjno04vq5h7aicz+gjx8tCnIVIJh09NAPOUxGpOh9k79AK6bGfhFvj69RhhtEyIENtvLahEpBm373rdrOgApvs6YHmabANZ3zhGs+7uOIQtKn4yHSH43L5vQ3rrIFpB0Q7vqDvSgiE6EfkHkiyjJuEpYTDq8s4IdpFcIOROuKIZTRgn0hspiEaK4qP/t/kP1+cyPbb8UA63kop+pjn3sn7XM+05fq4uzx5oc14LnweCoE7SfwCP71ZGk6TL3KQSX4EPSszZsOMcVjPJM39jd8TwmpMGsmuFULhDEZr0mTjGYT5TSnXjZQKHn3p22VJaKZCEQQz75L7lZaCa+dpAduUUkfxJTW3U1dKQM0mLj5Y9UhThuWWcwwN9rzNSJMC3obX9FBnT7ZYODJq2p5XiTatK6aNiME7VjrCFWyU1KNT3IsX79UlBoC1OT/ZGPzhqh/lgI6pltNJWDb9kvQcqq/kvUAERTYJJl43b0Bu+T0fNQQkDmM7GoPhO8OhZoiOi6SQBi4+glKof9r6cy3dZke1c/4nNzjzYg6mKsnnk28uQfb0at2kbdTaI83Mhgu15qQAfuk3nWAqSFVBpNkr6aBXXgKVmL6bvqF/bMdhCG9/KrOi8Bj2+qkwHTk15hA1IOzXoD9N0guwpgSafWiUwp5LjdGnZtDHpMA/Feypu6aeZ3991pzJQXqAejXwUzV6JpDA9wETyZdOqrhzwEEMm+ZOU5ajgq",
        "price": "315",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T22:45:00",
        "buffered_depart_time": "2018-06-18T21:15:00",
        "arrive_time": "2018-06-19T09:43:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-19T10:13:00",
        "buffered_depart_time": "2018-06-19T10:13:00",
        "arrive_time": "2018-06-19T10:37:00"
      }
    ]
  },
  {
    "total_price": 434.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 142,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T15:44:00",
        "buffered_depart_time": "2018-06-18T15:44:00",
        "arrive_time": "2018-06-18T15:50:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "Independence Hall Visitors Center, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T16:10:00",
        "buffered_depart_time": "2018-06-18T15:50:00",
        "arrive_time": "2018-06-18T18:10:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T20:12:00",
        "buffered_depart_time": "2018-06-18T20:12:00",
        "arrive_time": "2018-06-18T21:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=4001122827516499_0%7C3982431552169857_0%7C3982431552169857_1&price=266&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPyTEy6XbRnhA5yvVmvorIVcqhQQS+ax8fObRTBjno04vq5h7aicz+gjx8tCnIVIJh09NAPOUxGpOh9k79AK6bGfhFvj69RhhtEyIENtvLahEpBm373rdrOgApvs6YHmabANZ3zhGs+7uOIQtKn4yHSH43L5vQ3rrIFpB0Q7vqDvSgiE6EfkHkiyjJuEpYTDq8s4IdpFcIOROuKIZTRgn0hspiEaK4qP/t/kP1+cyPbb8UA63kop+pjn3sn7XM+05fq4uzx5oc14LnweCoE7SfwCP71ZGk6TL3KQSX4EPSszZsOMcVjPJM39jd8TwmpMGsmuFULhDEZr0mTjGYT5TSnXjZQKHn3p22VJaKZCEQQz75L7lZaCa+dpAduUUkfxJTW3U1dKQM0mLj5Y9UhThuWWcwwN9rzNSJMC3obX9FBnT7ZYODJq2p5XiTatK6aNiME7VjrCFWyU1KNT3IsX79UlBoC1OT/ZGPzhqh/lgI6pltNJWDb9kvQcqq/kvUAERTYJJl43b0Bu+T0fNQQkDmM7GoPhO8OhZoiOi6SQBi4+glKof9r6cy3dZke1c/4nNzjzYg6mKsnnk28uQfb0at2kbdTaI83Mhgu15qQAfuk3nWAqSFVBpNkr6aBXXgKVmL6bvqF/bMdhCG9/KrOi8Bj2+qkwHTk15hA1IOzXoD9N0guwpgSafWiUwp5LjdGnZtDHpMA/Feypu6aeZ3991pzJQXqAejXwUzV6JpDA9wETyZdOqrhzwEEMm+ZOU5ajgq",
        "price": "315",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T22:45:00",
        "buffered_depart_time": "2018-06-18T21:15:00",
        "arrive_time": "2018-06-19T09:43:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-19T10:13:00",
        "buffered_depart_time": "2018-06-19T10:13:00",
        "arrive_time": "2018-06-19T10:37:00"
      }
    ]
  },
  {
    "total_price": 484.0,
    "returning_segments": [],
    "permutation": "ride-share:flight:ride-share",
    "id": 105,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-76.668333",
            "to_lat": "39.175278",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "159.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T09:01:00",
        "buffered_depart_time": "2018-06-18T09:01:00",
        "arrive_time": "2018-06-18T11:01:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "BWI Airport, Washington, D.C.",
            "from_lon": "-76.668333",
            "from_lat": "39.175278"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=BWI&to=OMA&departure=18-06-2018&flightsId=3766926879407511_0%7C3531631835702220_0&price=262&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPpt6EKthCX7PYCdVfZWFaboJg4c34iKGAvjRcZN6sbXEvV/K0hYJDxUQNcsDLvhiY9STROEglPOnyNi0cqBLAMiM6tNVbhE+NnTzLlAua/zktT5Ed1otmzDcmtl+3QWDVJ8lzeTjMi5boLV7sWpQao6yfTSShPAK2XawW++wwxRAVpNUlV4BnCVOJUSaHQ+0YpKREoZ+5zPPzYZ9xefREUOpvkrMkQwkx2VRuePq8urSO5OVqc/9S9ummgWeP9rhMjYuh61QyZw4VpryR4FI8nDmWNRpybqQh2O8liNpZKuysIy/wnIdjhm8rKUKrFYQY6d0HFG82LXzVb9PKyU5rg9c2o0Zl52sX06ksEsha8oaqlNhgSqHAMJoQUV1/nGlSIJwyu9KQQc17psiqJ5r5fZv5aL8LV2Rv0RA6RwI4I96QhxadDtcrtE2ufEG+kEUaA51k/1vX6b/73ZBBAoOFWhoxgoSt7RAn5jBMyo0hRKZDXCFR4lp67WpwTRj9MNmYk+VhDCcJBdsoYi3SBl/eN+K6HPVDsqJSbSDMTzr5L52GnyB0zFAYP3KvusUYpUtUT0Sa1a0p/maeAJ8UrA+N2fNyMr2e6N00umKfAXwVA0Y7rMV2jJzpAcsU2XEN71UV/YcR8bjaU0rg4ZCDwjEuItlQvNS1pj24pXd5YAw0/S+j7OC2Xy+oWqCGu+PMRQ88uqzb//ffzoXZhlJKNuc1lg==",
        "price": "310",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T12:31:00",
        "buffered_depart_time": "2018-06-18T11:01:00",
        "arrive_time": "2018-06-18T20:39:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T21:09:00",
        "buffered_depart_time": "2018-06-18T21:09:00",
        "arrive_time": "2018-06-18T21:33:00"
      }
    ]
  },
  {
    "total_price": 434.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 140,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T15:24:00",
        "buffered_depart_time": "2018-06-18T15:24:00",
        "arrive_time": "2018-06-18T15:30:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "Independence Hall Visitors Center, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T15:50:00",
        "buffered_depart_time": "2018-06-18T15:30:00",
        "arrive_time": "2018-06-18T17:50:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T20:12:00",
        "buffered_depart_time": "2018-06-18T20:12:00",
        "arrive_time": "2018-06-18T21:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=4001122827516499_0%7C3982431552169857_0%7C3982431552169857_1&price=266&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPyTEy6XbRnhA5yvVmvorIVcqhQQS+ax8fObRTBjno04vq5h7aicz+gjx8tCnIVIJh09NAPOUxGpOh9k79AK6bGfhFvj69RhhtEyIENtvLahEpBm373rdrOgApvs6YHmabANZ3zhGs+7uOIQtKn4yHSH43L5vQ3rrIFpB0Q7vqDvSgiE6EfkHkiyjJuEpYTDq8s4IdpFcIOROuKIZTRgn0hspiEaK4qP/t/kP1+cyPbb8UA63kop+pjn3sn7XM+05fq4uzx5oc14LnweCoE7SfwCP71ZGk6TL3KQSX4EPSszZsOMcVjPJM39jd8TwmpMGsmuFULhDEZr0mTjGYT5TSnXjZQKHn3p22VJaKZCEQQz75L7lZaCa+dpAduUUkfxJTW3U1dKQM0mLj5Y9UhThuWWcwwN9rzNSJMC3obX9FBnT7ZYODJq2p5XiTatK6aNiME7VjrCFWyU1KNT3IsX79UlBoC1OT/ZGPzhqh/lgI6pltNJWDb9kvQcqq/kvUAERTYJJl43b0Bu+T0fNQQkDmM7GoPhO8OhZoiOi6SQBi4+glKof9r6cy3dZke1c/4nNzjzYg6mKsnnk28uQfb0at2kbdTaI83Mhgu15qQAfuk3nWAqSFVBpNkr6aBXXgKVmL6bvqF/bMdhCG9/KrOi8Bj2+qkwHTk15hA1IOzXoD9N0guwpgSafWiUwp5LjdGnZtDHpMA/Feypu6aeZ3991pzJQXqAejXwUzV6JpDA9wETyZdOqrhzwEEMm+ZOU5ajgq",
        "price": "315",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T22:45:00",
        "buffered_depart_time": "2018-06-18T21:15:00",
        "arrive_time": "2018-06-19T09:43:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-19T10:13:00",
        "buffered_depart_time": "2018-06-19T10:13:00",
        "arrive_time": "2018-06-19T10:37:00"
      }
    ]
  },
  {
    "total_price": 323.5,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T04:50:00",
        "buffered_depart_time": "2018-06-20T04:50:00",
        "arrive_time": "2018-06-20T05:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=4035207816796086_0%7C4035207816796086_1%7C3598702163596938_0&price=216&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPhMhiXGhmctYJmBJTQXuLUj1sQLf00gX21TRZqyUR0SpvoV+yG9wrU9B5Ar6P6oUSiBCHuRO3/5RF54tI0igB+D/9PpPqvFzSqMMttDq1By25DXR4EbrRJ5At+3SxjkxfGVzqyD53lYxIN4mL1WoeZa0LTFJNgqN1oJUYNOcEQfzunyKLZR80nevtXKfmer7OSOSETMIt6nbMsGRdiP+b5gC4xgVXmkMWdm7zhsRVkaQ7Y7Q2PLJXSGB9OqPmWPqgcsIgHkqojc7MtSGpz6WtM91o71URANaUm0cDFSHe1dlY8pW7IdR6UaBN2tym4ontittkIJj0fCvyIlylMxhI8eO7hSAjmBV54Ddz5SjJ52ChBgvlY5ZeF8tmHQDCreG2D+Hk7222ODayUJrJcg4TTU+f6VGG8DRRBw6/zShYveUqeP1JFTGMiNk3puTLhiQlVtjdRRd6LhjmC1noV/lUGaJ4f9XxMBZWEwbAHBrJDx/6BWFiJNQIEdmiK1DUmPCOBa5JHptKmrr+9Bo25MLMLDeHnzZgN0luToXOxc9wrI3DaZ4bo6m3gzr7J5whQzJvo21UQPBMNDwbtyriyoWyhIbpfWAWnYaTo6Xoaaftwx5Y8/OMtaCph4KSUcnRfEaU62Tuymambgc9GIYdigx/VpG7GVRJOzm8DeNeUJRbOjzB0s6k43u5AotV+WU1mLGtdKitnjQ4iwayW8khy6+mBqdGRv1C4z0CvPn0zrkf+cWxj2SqgX/WUgk4FYmE5Wwl",
        "price": "256",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T06:45:00",
        "buffered_depart_time": "2018-06-20T05:15:00",
        "arrive_time": "2018-06-20T15:40:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "40.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T16:10:00",
        "buffered_depart_time": "2018-06-20T16:10:00",
        "arrive_time": "2018-06-20T16:40:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "Independence Hall Visitors Center, Philadelphia, PA",
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": "34th St b/t 11th Ave and 12th Ave, New York, NY",
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T17:20:00",
        "buffered_depart_time": "2018-06-20T17:00:00",
        "arrive_time": "2018-06-20T19:20:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T19:30:00",
        "buffered_depart_time": "2018-06-20T19:30:00",
        "arrive_time": "2018-06-20T19:36:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share:bus:ride-share",
    "id": 175,
    "departing_segments": []
  },
  {
    "total_price": 434.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 129,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T09:34:00",
        "buffered_depart_time": "2018-06-18T09:34:00",
        "arrive_time": "2018-06-18T09:40:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "30th St Station, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T10:00:00",
        "buffered_depart_time": "2018-06-18T09:40:00",
        "arrive_time": "2018-06-18T12:10:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T20:12:00",
        "buffered_depart_time": "2018-06-18T20:12:00",
        "arrive_time": "2018-06-18T21:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=4001122827516499_0%7C3982431552169857_0%7C3982431552169857_1&price=266&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPyTEy6XbRnhA5yvVmvorIVcqhQQS+ax8fObRTBjno04vq5h7aicz+gjx8tCnIVIJh09NAPOUxGpOh9k79AK6bGfhFvj69RhhtEyIENtvLahEpBm373rdrOgApvs6YHmabANZ3zhGs+7uOIQtKn4yHSH43L5vQ3rrIFpB0Q7vqDvSgiE6EfkHkiyjJuEpYTDq8s4IdpFcIOROuKIZTRgn0hspiEaK4qP/t/kP1+cyPbb8UA63kop+pjn3sn7XM+05fq4uzx5oc14LnweCoE7SfwCP71ZGk6TL3KQSX4EPSszZsOMcVjPJM39jd8TwmpMGsmuFULhDEZr0mTjGYT5TSnXjZQKHn3p22VJaKZCEQQz75L7lZaCa+dpAduUUkfxJTW3U1dKQM0mLj5Y9UhThuWWcwwN9rzNSJMC3obX9FBnT7ZYODJq2p5XiTatK6aNiME7VjrCFWyU1KNT3IsX79UlBoC1OT/ZGPzhqh/lgI6pltNJWDb9kvQcqq/kvUAERTYJJl43b0Bu+T0fNQQkDmM7GoPhO8OhZoiOi6SQBi4+glKof9r6cy3dZke1c/4nNzjzYg6mKsnnk28uQfb0at2kbdTaI83Mhgu15qQAfuk3nWAqSFVBpNkr6aBXXgKVmL6bvqF/bMdhCG9/KrOi8Bj2+qkwHTk15hA1IOzXoD9N0guwpgSafWiUwp5LjdGnZtDHpMA/Feypu6aeZ3991pzJQXqAejXwUzV6JpDA9wETyZdOqrhzwEEMm+ZOU5ajgq",
        "price": "315",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T22:45:00",
        "buffered_depart_time": "2018-06-18T21:15:00",
        "arrive_time": "2018-06-19T09:43:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-19T10:13:00",
        "buffered_depart_time": "2018-06-19T10:13:00",
        "arrive_time": "2018-06-19T10:37:00"
      }
    ]
  },
  {
    "total_price": 320.5,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T04:05:00",
        "buffered_depart_time": "2018-06-20T04:05:00",
        "arrive_time": "2018-06-20T04:30:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=3522835704288553_0%7C3558020294474371_0&price=210&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPv0KvDn6aPXv/5v9h+zKCcbu13e8YbaoOuO9VmF5FyN9a0MD7UdSZmCHohwXaF1xnr9QsbppOtU2slJWlujwbbFNc5vpNRcVRyHHs9FG0xf+iw5GN2EBc/b5rP/V2V9fU7EmnK0zYHQHgc7s3aih+0bPf7SO1wy8dsl9h8PQ+3m0vbF+Mm6Z8YWiZB+1bTSLm7dvxh4Kiie2n/nLwreB7S84FweAAH5jBxNO3ubykr0LoRm7+D/7oAsBJhWydpg4x0oYfOpAzLRew8tYIfT1G80oHID9dkhwsoTj+izzRkjr7m6HXVX11+zf87wxPPXYfIwKUf6CzMt+yH1KsDcfwOc2OWLQwsE/pY7tZBIU7oSERZ3ibs8lD3IIvSAqEcBmXQERcxYaU4idpwp44UfQjhpqZDBcMuRdnI8p1hes2iLyCpgrQuYipXBH8RA4QqdpzUehu31uGLKHzcAOxoCY/JyUtJqq2S1/nh4lI7Zn2sc6h4bW7cYItQ3QdHN6+cAjpatC509pbz6mbRpDHvlUxNOgBsukQVe6/cDJ9x0GO1QIz1jS6NZKRHB8HDcg3vtgHX8dwhnTOaTVeqCTe6TsyWqNnw6nC3FusReNirsyp61+qybAD5YWm5a02Ed855sIlf+q2X6rGFTFJSGNifgv8gTg57VOi3cgmWMGoZyYda5LVJzpxb0vvo5cyZ67N7FRZ",
        "price": "249",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T06:00:00",
        "buffered_depart_time": "2018-06-20T04:30:00",
        "arrive_time": "2018-06-20T17:00:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "40.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T17:30:00",
        "buffered_depart_time": "2018-06-20T17:30:00",
        "arrive_time": "2018-06-20T18:00:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "Independence Hall Visitors Center, Philadelphia, PA",
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": "34th St b/t 11th Ave and 12th Ave, New York, NY",
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "9.0",
        "name": "megabus",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T21:20:00",
        "buffered_depart_time": "2018-06-20T21:00:00",
        "arrive_time": "2018-06-20T23:20:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T23:30:00",
        "buffered_depart_time": "2018-06-20T23:30:00",
        "arrive_time": "2018-06-20T23:36:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share:bus:ride-share",
    "id": 165,
    "departing_segments": []
  },
  {
    "total_price": 425.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 119,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T09:44:00",
        "buffered_depart_time": "2018-06-18T09:44:00",
        "arrive_time": "2018-06-18T09:50:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "Independence Hall Visitors Center, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T10:10:00",
        "buffered_depart_time": "2018-06-18T09:50:00",
        "arrive_time": "2018-06-18T12:10:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T12:20:00",
        "buffered_depart_time": "2018-06-18T12:20:00",
        "arrive_time": "2018-06-18T13:23:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=3488751098027710_0%7C3917560245168350_0%7C3917560245168350_1&price=259&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPQ/zjLVOCowaBhF3iXk2bEn07Xr+8wLkggi326weN87Ro+JAqpgcdJfVoCY0gNDJ4fB0J4RufmcjOaCwW3AbMCo8XFkKDbrB0oIQwA3e/aW6K8Ys3/ku9d1vxwmLon+yvmR6rUcdTfTK8EGievETfkPgySpkUB8YZqoXoGoiv/WY9pasl6OuRjvTlIywLL+QyfjhUKU+jCSkQWeMvi+KYd1rDl7DABeDM0CDi+zkOOd/AD/MNOyfyFnDxJJlCPfgw3udVGuJ2VuYSlsgQYekguJp/lU59sZ/S1eqWopMaTpelkpjeGmod1t17bypJHfmL5sj0Zpg8t7g7V+JfRDg76U0/K/FOPFfqlA1mkekWGFmXCY6Ia8gGY+v10wNmZ8zHGqhzxHB6rKyNyjq+hdiX/HbxCvYnQR6+OaRX+pMZTZGrbj16x+o5JKfyC4Y3wsSHc/736Um3EHrKj/L/NL2zjB2aw7UnUpKcHtmLAOlflfcJUYfJFNRK3Q/vqLroJvAcV7AdUhqD2oJmBpRmt66Tda3LECLli8QAKtmUNUUQgit/R+ut47g6kF0cIKA8GQUMOpl+xk434O4UX5m6FnBr3wiAOP0H3txba5w/OZf+KmbYjWEcw56wp3Znq0wmG0Z2fTWg6x7LumeITdmVYldk8nG49PBKUfEjTjAmVZUvDnBn5qbkb0G15TUvta9Cc5I5jtlV9ZPF/Lyl5ECsT/7qscAfMjE9FnWVwbOys9Sat12+Jls2ozxNj2/vYQNkIvgwVn8aXwJhpkraGo//KeMhJw==",
        "price": "306",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T14:53:00",
        "buffered_depart_time": "2018-06-18T13:23:00",
        "arrive_time": "2018-06-18T23:15:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T23:45:00",
        "buffered_depart_time": "2018-06-18T23:45:00",
        "arrive_time": "2018-06-19T00:09:00"
      }
    ]
  },
  {
    "total_price": 434.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 121,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T05:34:00",
        "buffered_depart_time": "2018-06-18T05:34:00",
        "arrive_time": "2018-06-18T05:40:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "30th St Station, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T06:00:00",
        "buffered_depart_time": "2018-06-18T05:40:00",
        "arrive_time": "2018-06-18T08:10:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T20:12:00",
        "buffered_depart_time": "2018-06-18T20:12:00",
        "arrive_time": "2018-06-18T21:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=4001122827516499_0%7C3982431552169857_0%7C3982431552169857_1&price=266&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPyTEy6XbRnhA5yvVmvorIVcqhQQS+ax8fObRTBjno04vq5h7aicz+gjx8tCnIVIJh09NAPOUxGpOh9k79AK6bGfhFvj69RhhtEyIENtvLahEpBm373rdrOgApvs6YHmabANZ3zhGs+7uOIQtKn4yHSH43L5vQ3rrIFpB0Q7vqDvSgiE6EfkHkiyjJuEpYTDq8s4IdpFcIOROuKIZTRgn0hspiEaK4qP/t/kP1+cyPbb8UA63kop+pjn3sn7XM+05fq4uzx5oc14LnweCoE7SfwCP71ZGk6TL3KQSX4EPSszZsOMcVjPJM39jd8TwmpMGsmuFULhDEZr0mTjGYT5TSnXjZQKHn3p22VJaKZCEQQz75L7lZaCa+dpAduUUkfxJTW3U1dKQM0mLj5Y9UhThuWWcwwN9rzNSJMC3obX9FBnT7ZYODJq2p5XiTatK6aNiME7VjrCFWyU1KNT3IsX79UlBoC1OT/ZGPzhqh/lgI6pltNJWDb9kvQcqq/kvUAERTYJJl43b0Bu+T0fNQQkDmM7GoPhO8OhZoiOi6SQBi4+glKof9r6cy3dZke1c/4nNzjzYg6mKsnnk28uQfb0at2kbdTaI83Mhgu15qQAfuk3nWAqSFVBpNkr6aBXXgKVmL6bvqF/bMdhCG9/KrOi8Bj2+qkwHTk15hA1IOzXoD9N0guwpgSafWiUwp5LjdGnZtDHpMA/Feypu6aeZ3991pzJQXqAejXwUzV6JpDA9wETyZdOqrhzwEEMm+ZOU5ajgq",
        "price": "315",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T22:45:00",
        "buffered_depart_time": "2018-06-18T21:15:00",
        "arrive_time": "2018-06-19T09:43:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-19T10:13:00",
        "buffered_depart_time": "2018-06-19T10:13:00",
        "arrive_time": "2018-06-19T10:37:00"
      }
    ]
  },
  {
    "total_price": 446.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 120,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T03:14:00",
        "buffered_depart_time": "2018-06-18T03:14:00",
        "arrive_time": "2018-06-18T03:20:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "30th St Station, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "17.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T03:40:00",
        "buffered_depart_time": "2018-06-18T03:20:00",
        "arrive_time": "2018-06-18T05:45:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T20:12:00",
        "buffered_depart_time": "2018-06-18T20:12:00",
        "arrive_time": "2018-06-18T21:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=4001122827516499_0%7C3982431552169857_0%7C3982431552169857_1&price=266&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPyTEy6XbRnhA5yvVmvorIVcqhQQS+ax8fObRTBjno04vq5h7aicz+gjx8tCnIVIJh09NAPOUxGpOh9k79AK6bGfhFvj69RhhtEyIENtvLahEpBm373rdrOgApvs6YHmabANZ3zhGs+7uOIQtKn4yHSH43L5vQ3rrIFpB0Q7vqDvSgiE6EfkHkiyjJuEpYTDq8s4IdpFcIOROuKIZTRgn0hspiEaK4qP/t/kP1+cyPbb8UA63kop+pjn3sn7XM+05fq4uzx5oc14LnweCoE7SfwCP71ZGk6TL3KQSX4EPSszZsOMcVjPJM39jd8TwmpMGsmuFULhDEZr0mTjGYT5TSnXjZQKHn3p22VJaKZCEQQz75L7lZaCa+dpAduUUkfxJTW3U1dKQM0mLj5Y9UhThuWWcwwN9rzNSJMC3obX9FBnT7ZYODJq2p5XiTatK6aNiME7VjrCFWyU1KNT3IsX79UlBoC1OT/ZGPzhqh/lgI6pltNJWDb9kvQcqq/kvUAERTYJJl43b0Bu+T0fNQQkDmM7GoPhO8OhZoiOi6SQBi4+glKof9r6cy3dZke1c/4nNzjzYg6mKsnnk28uQfb0at2kbdTaI83Mhgu15qQAfuk3nWAqSFVBpNkr6aBXXgKVmL6bvqF/bMdhCG9/KrOi8Bj2+qkwHTk15hA1IOzXoD9N0guwpgSafWiUwp5LjdGnZtDHpMA/Feypu6aeZ3991pzJQXqAejXwUzV6JpDA9wETyZdOqrhzwEEMm+ZOU5ajgq",
        "price": "315",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T22:45:00",
        "buffered_depart_time": "2018-06-18T21:15:00",
        "arrive_time": "2018-06-19T09:43:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-19T10:13:00",
        "buffered_depart_time": "2018-06-19T10:13:00",
        "arrive_time": "2018-06-19T10:37:00"
      }
    ]
  },
  {
    "total_price": 320.5,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T04:05:00",
        "buffered_depart_time": "2018-06-20T04:05:00",
        "arrive_time": "2018-06-20T04:30:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=3522835704288553_0%7C3558020294474371_0&price=210&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPv0KvDn6aPXv/5v9h+zKCcbu13e8YbaoOuO9VmF5FyN9a0MD7UdSZmCHohwXaF1xnr9QsbppOtU2slJWlujwbbFNc5vpNRcVRyHHs9FG0xf+iw5GN2EBc/b5rP/V2V9fU7EmnK0zYHQHgc7s3aih+0bPf7SO1wy8dsl9h8PQ+3m0vbF+Mm6Z8YWiZB+1bTSLm7dvxh4Kiie2n/nLwreB7S84FweAAH5jBxNO3ubykr0LoRm7+D/7oAsBJhWydpg4x0oYfOpAzLRew8tYIfT1G80oHID9dkhwsoTj+izzRkjr7m6HXVX11+zf87wxPPXYfIwKUf6CzMt+yH1KsDcfwOc2OWLQwsE/pY7tZBIU7oSERZ3ibs8lD3IIvSAqEcBmXQERcxYaU4idpwp44UfQjhpqZDBcMuRdnI8p1hes2iLyCpgrQuYipXBH8RA4QqdpzUehu31uGLKHzcAOxoCY/JyUtJqq2S1/nh4lI7Zn2sc6h4bW7cYItQ3QdHN6+cAjpatC509pbz6mbRpDHvlUxNOgBsukQVe6/cDJ9x0GO1QIz1jS6NZKRHB8HDcg3vtgHX8dwhnTOaTVeqCTe6TsyWqNnw6nC3FusReNirsyp61+qybAD5YWm5a02Ed855sIlf+q2X6rGFTFJSGNifgv8gTg57VOi3cgmWMGoZyYda5LVJzpxb0vvo5cyZ67N7FRZ",
        "price": "249",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T06:00:00",
        "buffered_depart_time": "2018-06-20T04:30:00",
        "arrive_time": "2018-06-20T17:00:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "40.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T17:30:00",
        "buffered_depart_time": "2018-06-20T17:30:00",
        "arrive_time": "2018-06-20T18:00:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "Independence Hall Visitors Center, Philadelphia, PA",
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": "34th St b/t 11th Ave and 12th Ave, New York, NY",
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "9.0",
        "name": "megabus",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T19:05:00",
        "buffered_depart_time": "2018-06-20T18:45:00",
        "arrive_time": "2018-06-20T21:05:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T21:15:00",
        "buffered_depart_time": "2018-06-20T21:15:00",
        "arrive_time": "2018-06-20T21:21:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share:bus:ride-share",
    "id": 161,
    "departing_segments": []
  },
  {
    "total_price": 477.0,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T04:50:00",
        "buffered_depart_time": "2018-06-20T04:50:00",
        "arrive_time": "2018-06-20T05:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=4008819685527143_0%7C4008819685527143_1%7C3742737859286809_0&price=214&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPjoUDnBsV+8uftjDbJxyY5IBPEOiEo8mHQXluz8hkRli01WLCsa/jvg/MAIcwq3op+LPOUPUVH/QWZ26nJ4U24nzJvQFJZ6eIXh12dT/+EEeiZxFeD28ei+ZwIjMnT351aC2pI9hhhRQz3UPdtxAxRegIYWdSQJz001EoNFEkXeQgNBtYEq9DJd14tbGHx44B9DXYz3S1W6mTutUza/mUrjsS1N6d1hH40WrJ8d1v8aRTG4lhwNOE0fb1PWX8HDKmMSJAL6tY0j+q0TmZxD/TJ7VO8iZenQfxGTg0UmNIPKiTnfc8uyjklYWaYd70vhZmL1mksK9MgpVq7dUe6oRunEIOCQkxh4a9SfdgLLLseTlVGIgYzpiTezfhd6c19TU1hs+raO3sXzhX6KYs9jFjYu+NiQ1J/Ke8luqkQVKYwHvog09XsJiwbmVhnz1nPpXDWkjHb+nUs+IyI+tMmfKwoQRFvUNrq391KpGor//w5S+/BzxwDlNpjNkC8rEg7UDH3ETJeCHuj/BOd1kUTTtBJdn6LR4u/vI5A+EQoFV+Em3JCcPYqzmK5vVvyYeM1eXB0dyk2JcynpHR0c0MlJ8Gv3u8jsihmdWj6ZOcyFFHxYTfcek8NgxUf91wmuW0boHK086c7ODA2woHYgHPozn3O55EJAmVFwIZ6zbUNJ33qM1HjaCmjSIS4pn/mM3KI+TH6lxfaXIegrM9/JBJasgA2gCcaABSWiFVLHxqtR++jcLqEv88c74YhPqLQ5/BxuZ6Cq/HhYBX5tf7RxJ+WcpSEw==",
        "price": "253",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T06:45:00",
        "buffered_depart_time": "2018-06-20T05:15:00",
        "arrive_time": "2018-06-20T17:45:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "208.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T18:15:00",
        "buffered_depart_time": "2018-06-20T18:15:00",
        "arrive_time": "2018-06-20T20:06:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share",
    "id": 155,
    "departing_segments": []
  },
  {
    "total_price": 419.0,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T04:50:00",
        "buffered_depart_time": "2018-06-20T04:50:00",
        "arrive_time": "2018-06-20T05:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=4008819685527143_0%7C4008819685527143_1%7C3803210722975286_0&price=165&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPjoUDnBsV+8uftjDbJxyY5IBPEOiEo8mHQXluz8hkRli01WLCsa/jvg/MAIcwq3op82v/7bTTYw8R9/iFUAOQOdMIBiHo2p/w8/JexfVas1O2mxnOTtYDJdyhmxLKAl+NpI4swVwVWpVjaDv5IRwi4yhcbZbCl6VeHekxUxg/WYgJeWOVQcCBiwk7s12k8xgoLjuc6nOU3Kc18GJW/e+Ghn3IUgPTSiDiXrlKnaXma2WYkHRR5GdjxGwTn7PEpPZHs3K3s8uZyX72FrHNoNCgEtFipPdjro7io4JkEF6BQH4mR3GiO3Y94Tfe8EBg5jco+AFXfFFyG2M3z7GLeG4j3wsi8ab0x6STat2TygKARdLjsS0LyvrsVSQoy2nJ13S/9KO0bAQLrrWWvm9ezAlxf5O1dD1elvnyKgJt+7tjsoOOHYFwnZKUU5Cc3Tdhh7/6wsMA77Ykuwy42tA+QT8fJNUKC+F9QsZ+1FMcU0qXfMWuCXj7X2GougZraVVVURArKjuX/LOtgbZq506uJc66HSnAOY9Vr8Fh2TfEOW3mJ9KY7RoqXLtpefW4ModudOCp23cF0Fxe9mZ5sbkoiRodplGrZVRpumUIV0neCZY300kz505Wz/gYyy0OiabdiDpcL4ArQF34dFe/0+0ipnljJFDq3XxukVbeNWvGIDZJwS8wOSKh1fohrRIdJVGV/dZneLJ14OLyV+YZWEg72Ci34NKWK0bWbT6lquDh1QqmWuMRHMy+lq2dPxibQg8uY76H",
        "price": "195",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T06:45:00",
        "buffered_depart_time": "2018-06-20T05:15:00",
        "arrive_time": "2018-06-20T21:00:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "208.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T21:30:00",
        "buffered_depart_time": "2018-06-20T21:30:00",
        "arrive_time": "2018-06-20T23:21:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share",
    "id": 147,
    "departing_segments": []
  },
  {
    "total_price": 434.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 137,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T14:39:00",
        "buffered_depart_time": "2018-06-18T14:39:00",
        "arrive_time": "2018-06-18T14:45:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "30th St Station, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T15:05:00",
        "buffered_depart_time": "2018-06-18T14:45:00",
        "arrive_time": "2018-06-18T17:15:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T20:12:00",
        "buffered_depart_time": "2018-06-18T20:12:00",
        "arrive_time": "2018-06-18T21:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=4001122827516499_0%7C3982431552169857_0%7C3982431552169857_1&price=266&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPyTEy6XbRnhA5yvVmvorIVcqhQQS+ax8fObRTBjno04vq5h7aicz+gjx8tCnIVIJh09NAPOUxGpOh9k79AK6bGfhFvj69RhhtEyIENtvLahEpBm373rdrOgApvs6YHmabANZ3zhGs+7uOIQtKn4yHSH43L5vQ3rrIFpB0Q7vqDvSgiE6EfkHkiyjJuEpYTDq8s4IdpFcIOROuKIZTRgn0hspiEaK4qP/t/kP1+cyPbb8UA63kop+pjn3sn7XM+05fq4uzx5oc14LnweCoE7SfwCP71ZGk6TL3KQSX4EPSszZsOMcVjPJM39jd8TwmpMGsmuFULhDEZr0mTjGYT5TSnXjZQKHn3p22VJaKZCEQQz75L7lZaCa+dpAduUUkfxJTW3U1dKQM0mLj5Y9UhThuWWcwwN9rzNSJMC3obX9FBnT7ZYODJq2p5XiTatK6aNiME7VjrCFWyU1KNT3IsX79UlBoC1OT/ZGPzhqh/lgI6pltNJWDb9kvQcqq/kvUAERTYJJl43b0Bu+T0fNQQkDmM7GoPhO8OhZoiOi6SQBi4+glKof9r6cy3dZke1c/4nNzjzYg6mKsnnk28uQfb0at2kbdTaI83Mhgu15qQAfuk3nWAqSFVBpNkr6aBXXgKVmL6bvqF/bMdhCG9/KrOi8Bj2+qkwHTk15hA1IOzXoD9N0guwpgSafWiUwp5LjdGnZtDHpMA/Feypu6aeZ3991pzJQXqAejXwUzV6JpDA9wETyZdOqrhzwEEMm+ZOU5ajgq",
        "price": "315",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T22:45:00",
        "buffered_depart_time": "2018-06-18T21:15:00",
        "arrive_time": "2018-06-19T09:43:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-19T10:13:00",
        "buffered_depart_time": "2018-06-19T10:13:00",
        "arrive_time": "2018-06-19T10:37:00"
      }
    ]
  },
  {
    "total_price": 434.0,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T13:29:00",
        "buffered_depart_time": "2018-06-20T13:29:00",
        "arrive_time": "2018-06-20T13:54:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "BWI Airport, Washington, D.C.",
            "to_lon": "-76.668333",
            "to_lat": "39.175278",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=BWI&departure=20-06-2018&flightsId=3924157037593505_0%7C3598702021635281_0&price=178&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObP0ZZk35PWQ4SROD5NR2qLB0R5jKFRPtMt5u/gpubBi8PDK2ndwSuAObX0gxKi6TIZY79SjxtMdwHs8zpiLH97Af+FA3mNkP/rleMOoPcsoW+AypGdNd6DijmdeF4OL7dwbp7R6yD5O4mr9laXnXRG/S5d0xicqZ46dJIVqczh8b2oTVUb7V8zHHI7IrZl+oZZkXaBIPEX05ZhoeTdj/OdrHwwDpRjp/5OzCY2GQM6sE2Tr4JWzVTzRjpLYrmZhOwZLQfXM2RzEsVKgxur2eoeb1BTeq1+SlB3XLwcxcCDl5gvo004mOi1ob1In22Ajo9lHhGloiDMe8rx7KbhKLJQTYQM2hcEbHuZSu18afjD1hITRvGrIX4Zf5xyP4Ns19CZkIaPbVzgbLm3F4+UM5rKbZD8EwC5InOZWVujICJrioihKUln4oLtJIbLcrAQZnPPn2Vf7B5/3onmC8+CVIr7HrX1SIpOxO5o8I9IIYFqUQod1/HY2NgLLHYlYbPUk+Njb7mLICLFb2Lg16mv8tSyrccAWSbZLgb1bZr4A1Ksy4ELBzgJ2tHKn5lPDiFOpcKw/32GFrD7q2rOtLC1rlqyZajG2D1j07DZf5ddrKw6n8gnsClI8ZMMkVVzodzj1+Y3EPr6JjoDz+jvx+7bA39J3tdqBflGM6uzeKwO2h73p5g475gr7p5YNIrZhFALwuwB",
        "price": "210",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T15:24:00",
        "buffered_depart_time": "2018-06-20T13:54:00",
        "arrive_time": "2018-06-21T00:25:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-76.668333",
            "from_lat": "39.175278"
          }
        },
        "purchase_link": null,
        "price": "208.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-21T00:55:00",
        "buffered_depart_time": "2018-06-21T00:55:00",
        "arrive_time": "2018-06-21T03:12:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share",
    "id": 150,
    "departing_segments": []
  },
  {
    "total_price": 189.5,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T13:35:00",
        "buffered_depart_time": "2018-06-20T13:35:00",
        "arrive_time": "2018-06-20T14:00:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "PHL Airport, Philadelphia",
            "to_lon": "-75.241111",
            "to_lat": "39.871944",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=PHL&departure=20-06-2018&flightsId=4033008802595707_0%7C4033008802595707_1&price=128&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPMgSlaJ4TmtjfllMhSZTSV9llLF1SU111zJregc6GYEig7xV15Cw3UAMEN204U2l9ZGvOnc204JFldxCNs4Z9NbUeAOyp126jcXVF2E7oxwpJ2pmMHdXzHzW/XjOtJ3aMf16LDUTDTmcREBq4roI06h7fIA3MS2QUWv3iOEe/1gW02cUTiokyVue9rN1azFC5TqtkE/eL1JoxbIHLPtiOA1qOSWjV2qgINH0pIh+J6bfNYgJiYZ9TMhCwbkwZrPPwHJWTxIx/0cksIJZNmVvadfhhPlSuUu9ydYjRlxlF05mytnjfVmc8ZhjhVsZ9x6hmAsFMcz4UQPdq5bcO9BRFx2INI3/IRNWozIVDGw9X93lYn4dKXhrnsZWGzVA3EgEO0WfVQSFKjLHu6CFL5n2Kuma1PFBaTe+kcWLNMfWqRHwGf3MiqHt7XIcaHGzfutIiGEiY2HG+lECTSQTBE7mrkmloRNAIbAtdVkTYSoHzi5jXZGtkewj0CHqseDoj8wHG1mp/p9ePhy13+RVeNNSEaB//ONpHYJyf4fomiv8BweZok9TUAVgVUpC/p/cyPSdY578Cre9SqqNsWztrzhDcTBWlu3fI8b9xwUdGeiQN/ItXylH7AwO6I/NLc6XAdpRbVGHQGpvktG8l0GFclT+oNM7oHSJOEEJWNosmZLSZwuRTuQzwRSO5C1qRO1mFkDdd",
        "price": "152",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T15:30:00",
        "buffered_depart_time": "2018-06-20T14:00:00",
        "arrive_time": "2018-06-20T23:56:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-75.241111",
            "from_lat": "39.871944"
          }
        },
        "purchase_link": null,
        "price": "21.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-21T00:26:00",
        "buffered_depart_time": "2018-06-21T00:26:00",
        "arrive_time": "2018-06-21T00:49:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share",
    "id": 146,
    "departing_segments": []
  },
  {
    "total_price": 471.0,
    "returning_segments": [],
    "permutation": "ride-share:flight:ride-share",
    "id": 100,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-74.577222",
            "to_lat": "39.4575",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T10:37:00",
        "buffered_depart_time": "2018-06-18T10:37:00",
        "arrive_time": "2018-06-18T11:52:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LNK Airport, Lincoln",
            "to_lon": "-96.759167",
            "to_lat": "40.851111",
            "from_string": "ACY Airport, Atlantic City",
            "from_lon": "-74.577222",
            "from_lat": "39.4575"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=ACY&to=LNK&departure=18-06-2018&flightsId=3599801544787963_0%7C3970336594698073_0&price=243&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObP8IOMNeUpI+nr+FVQDC3eDUMzMuRnneCVxQgyFJq+O/GKnKb1MEkT6CTBUNJ4Dy5fM9muu+W9WWr920/+KYPUckU5UdAe11eRCjrohfaOwuYYnzFOLrjHzbjPPQ1wUnhXz1edxrA2lVM++dHnE2K1aipbwsnrJaa922t0p9EASZhL8eh9ZlHm7gWpcIV0Y1u8iggk7yUS3rGR465N4fq68fLxC6iOkEN0orcWC9UvFSAAhmUXpl83MAvEfdkHmKYObWilB3/bTjYg4SGGYwXnL3+hC7CVw5B/6MT6BQ4v6/QZJEIUTvL5RtGQipuLdpSYSIPZqJ8hmI+9At+xmBH/BAmvFit5FwxiDu1EEY35sHA5ppENmz424T/GBOlj2qaKcP4n3wY62EO9aO2orkcDp1vo5P0ywoy1EsqJ6PGhpzSWYj4oiZQUQMXKJCpMguzOA86NrIYHzi49m1JmenppaRLX4H/Y2/QVfbAFk2OfKra437DPhJ6BYRi5r3DVuqmgXV4kpyPcW+buDabT8a81MOIIXt0biXPz7rN5hvJSCsfq3MpOaYHOisR1GOf81Jm3FU/cySXt/ZlEWOCBhSuhcp6y6VmKTFF49XoAedk7EZoKdFcnTBI+ZMY0yqcwTEzCxIOy/TT3JvLmbrGd5teh+fb3z8JSVRMOtDt3I6wJ9X2SUM6EgA/A6YUkdp8v0qLJ",
        "price": "288",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T13:22:00",
        "buffered_depart_time": "2018-06-18T11:52:00",
        "arrive_time": "2018-06-18T22:32:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-96.759167",
            "from_lat": "40.851111"
          }
        },
        "purchase_link": null,
        "price": "90.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T23:02:00",
        "buffered_depart_time": "2018-06-18T23:02:00",
        "arrive_time": "2018-06-19T00:04:00"
      }
    ]
  },
  {
    "total_price": 274.5,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T15:20:00",
        "buffered_depart_time": "2018-06-20T15:20:00",
        "arrive_time": "2018-06-20T15:45:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=3942848755778894_0&price=178&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObP/GQc7RXEySu6up5WPlRDX9L1+fWRjUBAE89jyP+Wfvt628tAoJqzwCtsoXIyhdyvATQw7k6X/LIrFcxLxIhC2guCvyTDxmaiRLAT1WN4vmMPiiG7uKflzNfQtgBM9yO6SW7DqTNCuMI1AQs2JqdAuV55AXuXANaaFwq9Hd7LqoE6xu89uaAuZsslBXPqh6P8asKvPTUHVayGNg+VplZbGa6XTBWLmj4yI9YK+V86RRns7kW7gSiq1AcAR+1hHQ8RloImvgXpY35G6b8xQ5p17CNuP+ebjw/AasJzuNrN1Nvmv0tKSdBeo71QCD19jTqL8nwwQz41+00VgwSk2RDBV0qyrU0etU9imjueP8qqYCvDxtcVJhYZPtGW9iIGwt+0BoMiqUPr10W0pRxnxtRGsGRIRtA9OkCIqzX4HumUL1q2Vz8tljxn/eMFPM8rvibaz9X2GxSIMaUWtFEBLQMnBoCWjvALsWG+zmre4QufpylcoDZ1v+eiF0FHOP8pI9RSBi19nxqalJMrBukcbACKYRWb81sBg85cxtPtszlvgySdt9VJYOSbnYrAM3fcs825c3BgQsyY5+/iACL5wgxyKPfXLutWb2SC8PNGL/OIeStlNSlJqHT4PYKI98/tqeK1blRtDYsghAgK70n0Z4fNlQ==",
        "price": "211",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T17:15:00",
        "buffered_depart_time": "2018-06-20T15:45:00",
        "arrive_time": "2018-06-20T21:15:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "40.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T21:45:00",
        "buffered_depart_time": "2018-06-20T21:45:00",
        "arrive_time": "2018-06-20T22:15:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "Independence Hall Visitors Center, Philadelphia, PA",
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": "34th St b/t 11th Ave and 12th Ave, New York, NY",
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "1.0",
        "name": "megabus",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T23:20:00",
        "buffered_depart_time": "2018-06-20T23:00:00",
        "arrive_time": "2018-06-21T01:20:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-21T01:30:00",
        "buffered_depart_time": "2018-06-21T01:30:00",
        "arrive_time": "2018-06-21T01:36:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share:bus:ride-share",
    "id": 159,
    "departing_segments": []
  },
  {
    "total_price": 434.0,
    "returning_segments": [],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 132,
    "departing_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": null,
            "from_lon": "-75.175808",
            "from_lat": "39.952539"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T10:49:00",
        "buffered_depart_time": "2018-06-18T10:49:00",
        "arrive_time": "2018-06-18T10:55:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "7th Ave and 27th St, New York, NY",
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": "Independence Hall Visitors Center, Philadelphia, PA",
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "5.0",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T11:15:00",
        "buffered_depart_time": "2018-06-18T10:55:00",
        "arrive_time": "2018-06-18T13:15:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.778889",
            "to_lat": "40.639722",
            "from_string": null,
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "92.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T20:12:00",
        "buffered_depart_time": "2018-06-18T20:12:00",
        "arrive_time": "2018-06-18T21:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "OMA Airport, Omaha",
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": "JFK Airport, New York City",
            "from_lon": "-73.778889",
            "from_lat": "40.639722"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=JFK&to=OMA&departure=18-06-2018&flightsId=4001122827516499_0%7C3982431552169857_0%7C3982431552169857_1&price=266&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPyTEy6XbRnhA5yvVmvorIVcqhQQS+ax8fObRTBjno04vq5h7aicz+gjx8tCnIVIJh09NAPOUxGpOh9k79AK6bGfhFvj69RhhtEyIENtvLahEpBm373rdrOgApvs6YHmabANZ3zhGs+7uOIQtKn4yHSH43L5vQ3rrIFpB0Q7vqDvSgiE6EfkHkiyjJuEpYTDq8s4IdpFcIOROuKIZTRgn0hspiEaK4qP/t/kP1+cyPbb8UA63kop+pjn3sn7XM+05fq4uzx5oc14LnweCoE7SfwCP71ZGk6TL3KQSX4EPSszZsOMcVjPJM39jd8TwmpMGsmuFULhDEZr0mTjGYT5TSnXjZQKHn3p22VJaKZCEQQz75L7lZaCa+dpAduUUkfxJTW3U1dKQM0mLj5Y9UhThuWWcwwN9rzNSJMC3obX9FBnT7ZYODJq2p5XiTatK6aNiME7VjrCFWyU1KNT3IsX79UlBoC1OT/ZGPzhqh/lgI6pltNJWDb9kvQcqq/kvUAERTYJJl43b0Bu+T0fNQQkDmM7GoPhO8OhZoiOi6SQBi4+glKof9r6cy3dZke1c/4nNzjzYg6mKsnnk28uQfb0at2kbdTaI83Mhgu15qQAfuk3nWAqSFVBpNkr6aBXXgKVmL6bvqF/bMdhCG9/KrOi8Bj2+qkwHTk15hA1IOzXoD9N0guwpgSafWiUwp5LjdGnZtDHpMA/Feypu6aeZ3991pzJQXqAejXwUzV6JpDA9wETyZdOqrhzwEEMm+ZOU5ajgq",
        "price": "315",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-18T22:45:00",
        "buffered_depart_time": "2018-06-18T21:15:00",
        "arrive_time": "2018-06-19T09:43:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.9345",
            "to_lat": "41.2565",
            "from_string": null,
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": null,
        "price": "15.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": true,
        "depart_time": "2018-06-19T10:13:00",
        "buffered_depart_time": "2018-06-19T10:13:00",
        "arrive_time": "2018-06-19T10:37:00"
      }
    ]
  },
  {
    "total_price": 304.5,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T04:31:00",
        "buffered_depart_time": "2018-06-20T04:31:00",
        "arrive_time": "2018-06-20T04:56:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "TTN Airport, Trenton",
            "to_lon": "-74.811944",
            "to_lat": "40.276944",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=TTN&departure=20-06-2018&flightsId=4047302532196183_0%7C4047302532196183_1%7C3521735873039649_0&price=204&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPwpBhOtwfRU1ueYHxzvON+GX2N7dSLUiAJG5K1PNqyXT4Ht/wK+Y5v9ZLdWi/WVVp4Ftv6P/EbjAstlHotDDuUd9qjST0r1KZgFW6Yt+0a4KGcqlz0rRvcRAb4C32oGIc4i6FFMAKLeuyNp+nGuLMWEo/x38BTr0pprOpLpGL49mIkVXF3/QO22fZEYrxZs9nxqT84adSULxMXUP+HiHdhoqr6yhJvs8eulbVhAq8Gko2rnL2vrro3vIUhaJ2wXxRV5rGlpqwXFrqPz+J6sQo0AtbCdBPzGYydH8mjr5QZG7ylK5s1AH8V95jf9IdkfY5ONHbR4mkAkCsOOdy3bBIx4lEUjDw9kyarwjTeNJE2y28LBO+eY1GYfKe8NDTwGXLvG/7Ncus5woj+ZwqBUgBz5nmMDQgrrojQ8RNO0vdZhneoAmYdvrsRDHeKKT5kj8ogMo/yaLckrLa4wvAHyDye0OtkKbLgrOEXIw9Vt3rb+jHZpnPpN/ywY2kLbfQyNuJA87+ToZzN5ACHkpgjw4S62StakbzvSOnfarOPi1wAH2ng09rh2sSihOBcsIOOyxLarUPn9PFhnTS0IxISr4kAbGJFJ8fv7bkETAu2lPk4N6SsE6O7TLsvfexYgBtdJetSxoDQVfEmND4wraTj0d8lxgwtFqV0RsrGKJPgq2+KKX11byUHQsYYm476z663IHhHMh3IhLGeLwxD5D/XXHXtscXD2xZDp72MT6ZZqa2h8/8YSdSGw1r2Y9ocXT7gOf8",
        "price": "241",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T06:26:00",
        "buffered_depart_time": "2018-06-20T04:56:00",
        "arrive_time": "2018-06-20T22:04:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-74.811944",
            "from_lat": "40.276944"
          }
        },
        "purchase_link": null,
        "price": "47.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T22:34:00",
        "buffered_depart_time": "2018-06-20T22:34:00",
        "arrive_time": "2018-06-20T23:25:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share",
    "id": 152,
    "departing_segments": []
  },
  {
    "total_price": 324.5,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.894167",
            "to_lat": "41.303056",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "16.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T04:50:00",
        "buffered_depart_time": "2018-06-20T04:50:00",
        "arrive_time": "2018-06-20T05:15:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "LGA Airport, New York City",
            "to_lon": "-73.8725",
            "to_lat": "40.777222",
            "from_string": "OMA Airport, Omaha",
            "from_lon": "-95.894167",
            "from_lat": "41.303056"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=OMA&to=LGA&departure=20-06-2018&flightsId=4008819685527143_0%7C4008819685527143_1%7C3742737859286809_0&price=214&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPjoUDnBsV+8uftjDbJxyY5IBPEOiEo8mHQXluz8hkRli01WLCsa/jvg/MAIcwq3op+LPOUPUVH/QWZ26nJ4U24nzJvQFJZ6eIXh12dT/+EEeiZxFeD28ei+ZwIjMnT351Ia6vhguGB8/uhyYCnHMcVNrDrSPXaDmUrsSj3+nNnHi07slYhs5jhSTtZAKkAkkDzmUwJTBwEuQ//H/u2DXQn4svpqa0GQumPbs1JoZUwq6sAI8eoz6DrUIiErevVfPnU5pK4NgP8ne2hYKVPZgRKobOGjQyvjzgv+iCsO08b26zK5rbWX+zu2oluwEVdCUTvbhkFof38kqpAaVwYKU7GvPSp0sPRhqVq2oituPuos2WwBd8uKVZLsaAn3waR2e7gavFB44ltXL78vjOtFWUnUzmhHzFZ9YG16gDx9XgpG+g3dtiCkG0M0jWaRchWMFxm9v9Ig7u6Wmhzq4EVlA1GKzgwb9rKRwrxiV/nHFy0EG63/0SahBW+e0oHNnh7mEJYFqBdTqTb3I46UFUHS0nrNv81sLw4QXsTz+petIVNbXwAaVaA3kNcS+Zqc6m8pDWbUGLOfmxKP3z1AJD2r3HHpEfteYOG0FevWyrqfJjfUTCLpqeLUTF7mfiwMkFF8/6aNegyFWILLp6CdjmaRiDYkgZ2FJ+8MQuQL5VyaVvK//BdfMvzU4PBBlgIoG7mCnlhOsVEeA7J+D/SoIDngG7BfQ3CGZiKZt1oN+zqQ03sO2xTTyK5+5pwxRaA0CqAfBX7rvQM2FWjaAifWfS/wzZIw==",
        "price": "253",
        "name": "kiwi",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T06:45:00",
        "buffered_depart_time": "2018-06-20T05:15:00",
        "arrive_time": "2018-06-20T17:45:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-73.995445",
            "to_lat": "40.74447",
            "from_string": null,
            "from_lon": "-73.8725",
            "from_lat": "40.777222"
          }
        },
        "purchase_link": null,
        "price": "40.0",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T18:15:00",
        "buffered_depart_time": "2018-06-20T18:15:00",
        "arrive_time": "2018-06-20T18:45:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "Independence Hall Visitors Center, Philadelphia, PA",
            "to_lon": "-75.16245",
            "to_lat": "39.95228",
            "from_string": "34th St b/t 11th Ave and 12th Ave, New York, NY",
            "from_lon": "-73.995445",
            "from_lat": "40.74447"
          }
        },
        "purchase_link": null,
        "price": "9.0",
        "name": "megabus",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T20:25:00",
        "buffered_depart_time": "2018-06-20T20:05:00",
        "arrive_time": "2018-06-20T22:25:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-75.16245",
            "from_lat": "39.95228"
          }
        },
        "purchase_link": null,
        "price": "6.5",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T22:35:00",
        "buffered_depart_time": "2018-06-20T22:35:00",
        "arrive_time": "2018-06-20T22:41:00"
      }
    ],
    "permutation": "ride-share:flight:ride-share:bus:ride-share",
    "id": 169,
    "departing_segments": []
  },
  {
    "total_price": 433.49,
    "returning_segments": [
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-95.94059",
            "to_lat": "41.26069",
            "from_string": null,
            "from_lon": "-95.9345",
            "from_lat": "41.2565"
          }
        },
        "purchase_link": null,
        "price": "6.0",
        "name": "uber",
        "index": 0,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T11:41:00",
        "buffered_depart_time": "2018-06-20T11:41:00",
        "arrive_time": "2018-06-20T11:45:00"
      },
      {
        "type": "bus",
        "segment_coords": {
          "data": {
            "to_string": "Eastbound side of Cherry Street, between 7th and 8th Streets, Des Moines, IA",
            "to_lon": "-93.62697",
            "to_lat": "41.58329",
            "from_string": "Crossroads Mall - N 72nd St between Dodge St and Cass St, Omaha, NE",
            "from_lon": "-95.94059",
            "from_lat": "41.26069"
          }
        },
        "purchase_link": null,
        "price": "19.99",
        "name": "megabus",
        "index": 1,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T12:05:00",
        "buffered_depart_time": "2018-06-20T11:45:00",
        "arrive_time": "2018-06-20T14:45:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-93.657778",
            "to_lat": "41.534167",
            "from_string": null,
            "from_lon": "-93.62697",
            "from_lat": "41.58329"
          }
        },
        "purchase_link": null,
        "price": "9.5",
        "name": "uber",
        "index": 2,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T18:16:00",
        "buffered_depart_time": "2018-06-20T18:16:00",
        "arrive_time": "2018-06-20T18:29:00"
      },
      {
        "type": "flight",
        "segment_coords": {
          "data": {
            "to_string": "BWI Airport, Washington, D.C.",
            "to_lon": "-76.668333",
            "to_lat": "39.175278",
            "from_string": "DSM Airport, Des Moines",
            "from_lon": "-93.657778",
            "from_lat": "41.534167"
          }
        },
        "purchase_link": "https://www.kiwi.com/deep?from=DSM&to=BWI&departure=20-06-2018&flightsId=3651478258259288_0%7C3638284458979421_0&price=161&passengers=1&affilid=picky&lang=us&currency=USD&booking_token=DHMwfZ9w9ZvT1CVktnOdJjHNSOOh4rh+/KRZU8WZ87iJvkYej9nvIY9qclVkZ1Z6Y17IQX+ReE/n8E+Zh5n0U0v/ouniGK8nXIF607KGPJYk5qYVvOsIRZuFzjvb0DNeMzu28IkrqoWFbiN46zZCIZoOCzPnSmyhkNsxOfMzjb+at5vbC+qHiNr5ufWaMObPZ1F/IF+TnYhSMNQyK6ni2Z3cbPw29qMIb5x0SrN4jENuhb+5t3csWSGPwhY8rcK5TLRshB5gaHmum1mzasZkhYoku94Y6Ys3hC1G6gjdGdmZYQcHEVmgZvs5xlNPUEnZPV21x85kPfVb2Fcfiktyn6jUa/6s4R+swsDz+vz3ccauQoHbxIvC01L4ZyBf7MLgsx/at//4EKTg8L5243/ubY7Jv+kQwsYKPijPzRv+/2KvtdSHjj4Xsi1Jwv84MCMhY5sKGBAjOhndq3mvEJ8pCa7lGFCVNOy6LYDRRpVPMjcFhnWZ+thZBQzyzRnzqTfIKx9O3ALG6afNA+ulrKGHQN6QX9XQDExgeRgJDfT97IxcIcZOuXdxFlBBPzHoJotqBq2MiHbnLe8y6rYpvD0YJNqS44r3K+Ma+u6wl9sOwN1tPZOp14KxTE/izz8D1JxAeAVZ76kf7ORB6PFwJJpcdNudq68UFbqXlIJCfuUEai0IaM3Ii8ZdLewnFeSUyTzkbkCAswTcgqUTy0RcaOnXLPV8vLbnQXTrxG+35w5bmOFnWhc07C+woc1e4DC4X8xjq7zDbcOLxwX9LbrYMP9d150J0rj1kktkQMO3UY70mj/07vZGoTm+uCYZ6ypzi5ckHY3l6phLRhIfyowY7dGZ67rkzSTKAALXZsRmpndF2wQZP531Nri2EF0Mi9/qE5cE",
        "price": "190",
        "name": "kiwi",
        "index": 3,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-20T19:59:00",
        "buffered_depart_time": "2018-06-20T18:29:00",
        "arrive_time": "2018-06-21T04:22:00"
      },
      {
        "type": "ride-share",
        "segment_coords": {
          "data": {
            "to_string": null,
            "to_lon": "-75.175808",
            "to_lat": "39.952539",
            "from_string": null,
            "from_lon": "-76.668333",
            "from_lat": "39.175278"
          }
        },
        "purchase_link": null,
        "price": "208.0",
        "name": "uber",
        "index": 4,
        "description": null,
        "departing": false,
        "depart_time": "2018-06-21T04:52:00",
        "buffered_depart_time": "2018-06-21T04:52:00",
        "arrive_time": "2018-06-21T07:09:00"
      }
    ],
    "permutation": "ride-share:bus:ride-share:flight:ride-share",
    "id": 185,
    "departing_segments": []
  }
]
}

export default itineraries



// WEBPACK FOOTER //
// ./src/itineraries.js